// Francisation des libellés amont, hors des fichiers de Dust : une fusion ne la rouvre plus.
// Le dictionnaire reprend les traductions faites entre le 19/08 et le 30/08 directement dans
// les fichiers amont (lot D de la première fusion, 25/09/2026), qui ont été rendus à l'amont.
// Une clé absente rend la clé : aucun libellé ne disparaît, il reste en anglais.
import { PRODUCT_NAME, SIDEKICK_NAME } from "@app/lib/compta/branding";

const FR: Record<string, string> = {
  Spaces: "Dossiers",
  Space: "Dossier",
  Workspace: "Espace de travail",
  Conversations: "Conversations",
  Files: "Fichiers",
  Tasks: "Tâches",
  Settings: "Réglages",
  Usage: "Utilisation",
  "IT & Security": "Identité & Sécurité",
  Analytics: "Analytique",
  "Analytics (new)": "Analytique (nouveau)",
  Members: "Membres",
  Agents: "Agents",
  Knowledge: "Connaissances",
  Admin: "Administration",
  Subscription: "Abonnement",
  Billing: "Facturation",
  "Subscribe to Dust": "",
  // Sites rendus a l'anglais par la premiere fusion amont (revue du 25/09/2026).
  "Programmatic Usage": "API & Programmatique",
  "Dust API Keys": "Clés API",
  "Credits Usage": "Usage programmatique",
  Automations: "Automatisations",
  "Get work done": "Écrivez votre demande",
  "Settings & Governance": "Réglages & Gouvernance",
  "Manage what members can do in your workspace":
    "Gérez ce que les membres peuvent faire dans votre cabinet",
  "For best accuracy, first use":
    "Pour une précision maximale, utilisez d'abord",
  "to summarize this conversation and free up context. If needed, start a fresh conversation or narrow your request.":
    "pour résumer la conversation et libérer du contexte. Au besoin, démarrez une nouvelle conversation ou précisez votre demande.",
  "Helps the Dust team improve": `Aide l'équipe ${PRODUCT_NAME} à améliorer`,
  "Helps editors improve the agent": "Aide les éditeurs à améliorer l'agent",
  // Sous-plan 10, lot B : les ecrans du chat integre dans la page Assistant.
  "Chat with...": "Vos assistants",
  "To get started": "Pour commencer",
  "Rename conversation": "Renommer la conversation",
  "Mark as unread": "Marquer comme non lue",
  Join: "Rejoindre",
  "Open in a browser tab": "Ouvrir dans un onglet",
  "Copy link": "Copier le lien",
  Leave: "Quitter",
  Delete: "Supprimer",
  "Credit usage": "Crédits",
  "Nothing to see here": "Aucun fichier pour l'instant",
  Member: "Membre",
  "No result": "Aucun résultat",
  "Completed in": "Terminé en",
  "Errored after": "Échec après",
  "Cancelled after": "Annulé après",
  Completed: "Terminé",
  Cancelled: "Annulé",
  "More message actions": "Plus d'actions",
  "without tools": "sans outil",
  "No tools used.": "Aucun outil utilisé.",
  "Writing…": "Rédaction…",
  "Thinking…": "Réflexion…",
  Done: "Terminé",
  "Link copied !": "Lien copié",
  New: "Nouvelle",
  // Bouton de création d'un espace (08/10).
  "New space": "Nouvel espace",
  // Page Membres de l'administration (08/10) : les comptes se gèrent dans l'application.
  "Team accounts are managed in the application":
    "Les comptes de l'équipe se gèrent dans l'application",
  "Open the application settings, Comptes tab, to add a member, change a role or remove an account. Changes made here would be replaced by the application.":
    "Ouvrez les réglages de l'application, onglet Comptes, pour ajouter un membre, changer un rôle ou retirer un compte. Un changement fait ici serait remplacé par celui de l'application.",
  "Open the settings": "Ouvrir les réglages",
  Inbox: "Non lues",
  "Mark all as read": "Tout marquer comme lu",
  Search: "Rechercher",
  // Lot E1 : selecteur d'assistant, menu de creation, fiche d'assistant, sections de date.
  "Search Agents": "Rechercher",
  "No results found": "Aucun résultat",
  Create: "Créer",
  "New agent": "Nouvel assistant",
  "From scratch": "Depuis zéro",
  "From template": "Depuis un modèle d'assistant",
  "From YAML": "Depuis un fichier YAML",
  "Uploading...": "Envoi…",
  Agent: "Assistant",
  "Create a new conversation": "Nouvelle conversation",
  "New conversation": "Nouvelle conversation",
  Today: "Aujourd'hui",
  Yesterday: "Hier",
  "Last Week": "Semaine dernière",
  "Last Month": "Mois dernier",
  "Last 12 Months": "Douze derniers mois",
  Older: "Plus ancien",
  Me: "Moi",
  Info: "Infos",
  Editors: "Éditeurs",
  Insights: "Statistiques",
  Memory: "Mémoire",
  Triggers: "Déclencheurs",
  "Edit agent": "Modifier l'assistant",
  "Copy agent ID": "Copier l'identifiant",
  "Duplicate (New)": "Dupliquer",
  Archive: "Archiver",
  Restore: "Restaurer",
  "Add editors": "Ajouter des utilisateurs",
  "Add trigger": "Ajouter un déclencheur",
  Feedback: "Retours",
  "Restricted access": "Accès restreint",
  "Saved memories": "Souvenirs enregistrés",
  Cancel: "Annuler",
  Save: "Enregistrer",
  Edited: "Modifié",
  "Not Available": "Indisponible",
  "This agent has been archived.": "Cet assistant a été archivé.",
  Instructions: "Instructions",
  Folders: "Dossiers",
  Documents: "Documents",
  Tables: "Tableaux",
  Filters: "Filtres",
  Activated: "Activé",
  Skills: "Compétences",
  Tools: "Outils",
  // Lot E1b : page de creation d'un assistant, fiche (Publié, Dernière modification).
  Retry: "Réessayer",
  "Unable to load models": "Impossible de charger les modèles",
  "Agent preview": "Aperçu de l'assistant",
  "Use your agent or share it with your team to see insights data.":
    "Utilisez votre assistant ou partagez-le avec votre équipe pour voir des statistiques.",
  Preview: "Aperçu",
  "Waiting for data": "En attente de données",
  "Hide preview": "Masquer l'aperçu",
  "Open preview": "Ouvrir l'aperçu",
  "Agent Sidekick": SIDEKICK_NAME,
  "Drag and drop your text files (txt, doc, pdf) and image files (jpg, png) here.":
    "Déposez ici vos fichiers texte (txt, doc, pdf) et images (jpg, png).",
  "There was an issue starting the Sidekick session. Please try again later.": `${SIDEKICK_NAME} n'a pas pu démarrer. Réessayez plus tard.`,
  "Attach files to Sidekick": `Joindre des fichiers à ${SIDEKICK_NAME}`,
  Manage: "Gérer",
  All: "Tous",
  Unseen: "Non lus",
  "View conversation": "Voir la conversation",
  Connect: "Connecter",
  Connected: "Connecté",
  "About personal tools": "À propos des outils personnels",
  "Search capabilities...": "Rechercher une capacité…",
  "Used by other resources": "Utilisé par d'autres ressources",
  "Search spaces and Pods": "Rechercher un espace",
  "Connect data": "Connecter des données",
  "Go back": "Retour",
  "No pages found": "Aucune page trouvée",
  "Name ...": "Nom…",
  Name: "Nom",
  "No selection": "Aucune sélection",
  "My tool name…": "Nom de mon outil…",
  "Search tools...": "Rechercher un outil…",
  "Configure additional parameters required by this action.":
    "Renseignez les paramètres supplémentaires de cette action.",
  "Additional configuration": "Configuration supplémentaire",
  "Select Agent": "Choisir un assistant",
  "Must-have labels": "Étiquettes obligatoires",
  "Must-not-have labels": "Étiquettes exclues",
  Filtering: "Filtrage",
  "Edit selection": "Modifier la sélection",
  "Select a Dust App": "Choisir une app",
  "Re-generate from Instructions": "Régénérer depuis les instructions",
  Schema: "Schéma",
  "Automatically re-generate the extraction schema based on Instructions":
    "Régénère automatiquement le schéma d'extraction à partir des instructions",
  "Search...": "Rechercher…",
  "No Pods available": "Aucun pod disponible",
  "Select Pod": "Choisir un pod",
  Change: "Changer",
  "Failed to load secrets": "Impossible de charger les secrets",
  "Select a Secret": "Choisir un secret",
  "Manage selection": "Gérer la sélection",
  "Select data sources": "Choisir des sources de données",
  "JSON Response": "Réponse JSON",
  "Command or guideline you provide to your agent to direct its responses.":
    "Consignes données à votre assistant pour guider ses réponses.",
  "Leave comparison mode": "Quitter la comparaison",
  "Restore this version": "Restaurer cette version",
  "Choose version to compare": "Choisir une version à comparer",
  "Compare with previous versions": "Comparer avec les versions précédentes",
  "Accept all": "Tout accepter",
  "Reject all": "Tout refuser",
  "Accept all suggestions": "Accepter toutes les suggestions",
  "Reject all suggestions": "Refuser toutes les suggestions",
  Bold: "Gras",
  "Bulleted list": "Liste à puces",
  "Code Block": "Bloc de code",
  Heading: "Titre",
  Italic: "Italique",
  "Ordered list": "Liste numérotée",
  "XML tag": "Balise XML",
  "Daily counts of positive and negative feedback.":
    "Nombre de retours positifs et négatifs par jour.",
  "Feedback Trends": "Évolution des retours",
  "Visible & usable by all members of the workspace.":
    "Visible et utilisable par tous les membres.",
  "Visible & usable by editors only.":
    "Visible et utilisable par les éditeurs seulement.",
  Published: "Publié",
  Unpublished: "Non publié",
  "Not published": "Non publié",
  "Slack preferences": "Préférences Slack",
  "Editors & Access": "Éditeurs et accès",
  "Who is this agent available for?": "Qui peut utiliser cet assistant ?",
  "Enter agent description": "Décrivez l'assistant",
  Description: "Description",
  "Enter agent name": "Nom de l'assistant",
  "Cost Management": "Gestion des coûts",
  "Search channels...": "Rechercher un canal…",
  "Admin Access Required": "Accès administrateur requis",
  Tags: "Étiquettes",
  Add: "Ajouter",
  "Choose an option": "Choisir une option",
  "Select a tag": "Choisir une étiquette",
  Upload: "Importer",
  "Pick a color": "Choisir une couleur",
  "Pick an Emoji": "Choisir un emoji",
  Accept: "Accepter",
  Reject: "Refuser",
  "Accept suggestion": "Accepter la suggestion",
  "Reject suggestion": "Refuser la suggestion",
  "Add capabilities": "Ajouter des capacités",
  "Add knowledge": "Ajouter des connaissances",
  "Capabilities and knowledge": "Capacités et connaissances",
  "Add triggers": "Ajouter des déclencheurs",
  "Other members' triggers": "Déclencheurs des autres membres",
  "Run in my conversations.": "S'exécute dans mes conversations.",
  "My conversations (default)": "Mes conversations (par défaut)",
  "Charge to": "Imputer à",
  "Trigger this agent on a schedule":
    "Déclencher cet assistant selon un horaire",
  Schedule: "Horaire",
  "Search triggers...": "Rechercher un déclencheur…",
  "Enter trigger name": "Nom du déclencheur",
  "Compute stats": "Calculer les statistiques",
  "Payload filtering Syntax": "Syntaxe de filtrage de la charge utile",
  Select: "Choisir",
  "Similar agents found": "Assistants similaires trouvés",
  "Data and access": "Données et accès",
  "Selected capabilities": "Capacités sélectionnées",
  Pods: "Projets",
  "Other tools": "Autres outils",
  "Top tools": "Outils principaux",
  "Selected tools": "Outils sélectionnés",
  "In-conversation filtering": "Filtrage dans la conversation",
  "Space:": "Espace :",
  "Knowledge lookup method": "Méthode de recherche",
  "Note:": "Note :",
  "Time Range Configuration": "Période",
  "All members can view and use this agent.":
    "Tous les membres peuvent voir et utiliser cet assistant.",
  "Only editors can view and use this agent.":
    "Seuls les éditeurs peuvent voir et utiliser cet assistant.",
  "Slack Channel Settings": "Réglages des canaux Slack",
  "Other tags": "Autres étiquettes",
  "No webhook requests yet.": "Aucune requête webhook pour l'instant.",
  "Request history": "Historique des requêtes",
  Credits: "Crédits",
  Status: "Statut",
  Scheduler: "Planification",
  "Message (optional)": "Message (facultatif)",
  "Where to create this conversation? (optional)":
    "Où créer cette conversation ? (facultatif)",
  "Include webhook payload": "Inclure la charge utile du webhook",
  "Listen for": "Écouter",
  "Rate limits": "Limites de débit",
  "Last edited": "Dernière modification",
  // Menu + (30/09, remarque de Louka) : outils et compétences proposés, avec leurs descriptions.
  Configure: "Configurer",
  "Search capabilities": "Rechercher un outil",
  "No capabilities found": "Aucun outil trouvé",
  "No more capabilities to select": "Tous les outils sont déjà ajoutés",
  "Upload File": "Téléverser un fichier",
  "Create Files": "Créer des fichiers",
  "Create Images": "Créer des images",
  "Create Frames": "Créer des tableaux de bord",
  "Query Tables": "Interroger des tableaux",
  "Wake-ups": "Réveils programmés",
  "Astraly outils metier": `Outils métier ${PRODUCT_NAME}`,
  "Compta calculators": "Calculateurs comptables",
  "Agent memory": "Mémoire de l'agent",
  "Extract data": "Extraire des données",
  "Include data": "Inclure des données",
  "Run agent": "Lancer un assistant",
  "Speech generator": "Synthèse vocale",
  "Web search & browse": "Recherche et navigation web",
  "Web search browse": "Recherche et navigation web",
  "Call a tool to answer a question.":
    "Appeler un outil métier pour répondre à une question.",
  "Lire les chiffres du dossier comptable de cette conversation : balance, tiers, lettrage, activité, TVA, rattachement, grand livre, régularité en la forme, option IR. Lecture seule.":
    "Lire les chiffres du dossier comptable de cette conversation : balance, tiers, lettrage, activité, TVA, rattachement, grand livre, régularité en la forme, option IR. Lecture seule.",
  "User-scoped long-term memory tools for agents.":
    "Mémoire durable de l'agent, propre à chaque membre.",
  "Parse documents to create structured datasets.":
    "Lire des documents pour en tirer des données structurées.",
  "Generate and convert documents.": "Créer et convertir des documents.",
  "Generate, create, draw, or edit images from text prompts and optional reference images.":
    "Créer, dessiner ou retoucher des images à partir d'une consigne et d'images de référence.",
  "Load complete content for full context up to memory limits. Note: won't include spreadsheet/table data.":
    "Charger le contenu complet d'un document dans le contexte (hors tableaux et feuilles de calcul).",
  "Run a child agent (agent as tool).":
    "Confier une tâche à un autre assistant.",
  "Turn written text into spoken audio or dialog":
    "Transformer un texte en audio parlé",
  "Agent can search (Google) and retrieve information from specific websites.":
    "Chercher sur le web et lire des pages de sites précis.",
  "Search content whose meaning best matches your message (not suited for analytics).":
    "Chercher dans les documents de la crèche ce qui répond le mieux à la demande.",
  "Query structured data like a spreadsheet or database. Use list_tables to discover available tables, get_database_schema for the tables you need, then execute_database_query to run SQL analyses.":
    "Interroger des données structurées (tableaux, feuilles de calcul, bases) pour des analyses chiffrées.",
  "Schedule wake-ups that re-invoke the agent at a later time.":
    "Programmer une relance de l'assistant à un moment ultérieur.",
  "Author Skills": "Créer des compétences",
  Computer: "Ordinateur",
  PDFs: "PDF",
  "Slide decks": "Présentations",
  Spreadsheets: "Tableurs",
  "Discover Knowledge": "Explorer les connaissances",
  "Discover Skills": "Découvrir des compétences",
  "Discover Tools": "Découvrir des outils",
  "User Memory": "Mémoire de l'utilisateur",
  "Mention Users": "Mentionner des membres",
  "Dust Learning": "Conseils d'utilisation",
  "Dust Support": "Assistance",
  "Get a recommendation for the next best action to get more value from Dust":
    "Recevoir une recommandation pour mieux utiliser l'assistant",
  "Read, edit, and create text documents (.docx) in the sandbox.":
    "Lire, modifier et créer des documents texte (.docx).",
  "Turn insights into interactive dashboards and presentations your team can explore, customize, and share. Living documents that adapt to different stakeholders.":
    "Transformer des analyses en tableaux de bord et présentations interactifs à explorer et partager.",
  "Allow agents to mention and notify workspace users in conversations.":
    "Permettre à l'assistant de mentionner et prévenir des membres dans une conversation.",
  "Read, OCR scans, extract text and tables, create, and edit PDFs in the Computer.":
    "Lire des PDF (y compris scannés), en extraire texte et tableaux, en créer et en modifier.",
  "Read, edit, and create slide presentations":
    "Lire, modifier et créer des présentations",
  "Allow agents to create conversations & messages in Pods, leverage Pods knowledge.":
    "Permettre à l'assistant de créer des conversations et messages dans les Pods et d'en exploiter le contenu.",
  "Run code, scripts, and shell commands in the conversation's Computer (a sandboxed Linux environment).":
    "Exécuter du code, des scripts et des commandes dans l'ordinateur de la conversation (environnement isolé).",
  "Let this agent create and refine reusable Skills for your workspace.":
    "Laisser l'assistant créer et affiner des compétences réutilisables.",
  "Get help with Dust using public docs, open-source issues, and community knowledge.":
    "Obtenir de l'aide sur l'assistant à partir de la documentation publique.",
  "Read, edit, and create spreadsheets (.xlsx, .csv)":
    "Lire, modifier et créer des tableurs (.xlsx, .csv)",
  "Search across all your company documents and data warehouses to surface the information you need without manual configuration.":
    "Chercher dans tous les documents et données de l'entreprise, sans réglage préalable.",
  "Automatically discover and activate workspace skills as needed.":
    "Découvrir et activer automatiquement les compétences utiles.",
  "Automatically discover and activate specialized tools as needed. Extend your agent's capabilities on-demand without manual configuration.":
    "Découvrir et activer automatiquement les outils spécialisés utiles, sans réglage préalable.",
  "Give agents a persistent memory of the user's preferences and context across conversations.":
    "Donner à l'assistant une mémoire durable des préférences et du contexte du membre, d'une conversation à l'autre.",
  // Fil de la conversation (30/09, remarque de Louka) : reactions, actions, navigation, dates.
  "Add reaction": "Réagir",
  "Message actions": "Actions du message",
  "Add a follow-up...": "Poursuivre la conversation…",
  "Previous user message": "Message précédent",
  "Next user message": "Message suivant",
  "Conversation menu": "Menu de la conversation",
  "New Conversation": "Nouvelle conversation",
  Tomorrow: "Demain",
  // Fiche d'un assistant, onglet Statistiques, et Sidekick du constructeur (01/10, remarques de Louka).
  Sidekick: SIDEKICK_NAME,
  "Unable to start Sidekick": `${SIDEKICK_NAME} n'a pas pu démarrer`,
  "Starting Sidekick session...": `Démarrage de ${SIDEKICK_NAME}…`,
  Overview: "Vue d'ensemble",
  Explore: "Explorer",
  "Active Users": "Membres actifs",
  "Messages / active user": "Messages par membre actif",
  "Total cost": "Coût total",
  "Avg. cost/msg": "Coût moyen par message",
  "Used this period": "Utilisé sur la période",
  "Top agent": "Assistant le plus utilisé",
  "Manage in Usage": "Gérer dans Usage",
  "This cycle": "Ce cycle",
  // Page de création d'un assistant et feuille des capacités (01/10, remarques de Louka).
  "Create new agent": "Nouvel assistant",
  "Edit agent {name}": "Modifier {name}",
  "Duplicate {name}": "Dupliquer {name}",
  "Saving...": "Enregistrement…",
  "Adding spaces or pods will make the data from each of them available to the agent. Only members of all the spaces and pods listed will have access to the agent.":
    "Les espaces ajoutés mettent leurs données à disposition de l'assistant. Seuls les membres de tous les espaces listés pourront l'utiliser.",
  "Add skills, tools, and knowledge to enhance your agent's abilities.":
    "Ajoutez des compétences, des outils et des connaissances à votre assistant.",
  "Run agents based on events.": "Lancez l'assistant sur des événements.",
  "Need help? Check our": "Besoin d'aide ? Consultez notre",
  guide: "guide",
  "Skill details": "Détails de la compétence",
  "Add 1 capability": "Ajouter 1 capacité",
  "Add {n} capabilities": "Ajouter {n} capacités",
  "Reusable packages of instructions and tools that enable agents to perform specialized tasks.":
    "Ensembles réutilisables d'instructions et d'outils pour des tâches spécialisées.",
  "No capability matches your search":
    "Aucune capacité ne correspond à votre recherche",
  "No capabilities available": "Aucune capacité disponible",
  "Try a different search term.": "Essayez un autre terme.",
  "Add tools or create skills to enhance your agents.":
    "Ajoutez des outils ou créez des compétences pour enrichir vos assistants.",
  "Preview your agent here": "Testez votre assistant ici",
  // Feuille des éditeurs, publication, pagination (01/10).
  "Manage Editors": "Gérer les éditeurs",
  "Search users...": "Rechercher un utilisateur…",
  "{n} editors": "{n} éditeurs",
  "{n} items": "{n} éléments",
  "1 item": "1 élément",
  "Showing {first}-{last} of {total} items":
    "{first} à {last} sur {total} éléments",
  "At least one editor is required.": "Il faut au moins un éditeur.",
  // Feuilles de configuration du constructeur, Pods renommés Projets (01/10).
  "Connected Data": "Données connectées",
  Websites: "Sites web",
  Apps: "Applications",
  "Agent responds in conversation": "L'assistant répond dans la conversation",
  "The selected agent runs in a background conversation and passes results back to the main agent.\nThis is the default behavior, well suited for breaking down complex work by delegating specific research/analysis subtasks while maintaining control of the overall response.":
    "L'assistant choisi travaille dans une conversation en arrière-plan et renvoie ses résultats à l'assistant principal.\nC'est le comportement par défaut, adapté pour déléguer des recherches ou analyses précises tout en gardant la main sur la réponse.",
  "The selected agent takes over and responds directly in the conversation.\nWell suited for a routing use case where the sub-agent should handle the entire interaction going forward.":
    "L'assistant choisi prend le relais et répond directement dans la conversation.\nAdapté quand il doit gérer toute la suite de l'échange.",
  "the agent": "l'assistant",
  "Execution mode": "Mode d'exécution",
  "Select {name}": "Choisir {name}",
  "Enter value for {name}": "Saisir {name}",
  "Agent runs in the background": "L'assistant travaille en arrière-plan",
  "Adding spaces or pods will make the data from each of them available to {entity}.":
    "Les espaces ajoutés mettent leurs données à disposition de {entity}.",
  "Select Data Sources": "Choisir des sources de données",
  "Choose the data sources to include in your knowledge base":
    "Choisissez les sources de données à inclure dans les connaissances de l'assistant",
  "Select Tables": "Choisir des tableaux",
  "Choose the tables to query for your processing method":
    "Choisissez les tableaux à interroger",
  "Search in {name}": "Rechercher dans {name}",
  space: "l'espace",
  Next: "Suivant",
  "Selection ({n} items)": "Sélection ({n} éléments)",
  "Selection (1 item)": "Sélection (1 élément)",
  "Selection (0 items)": "Sélection (0 élément)",
  // Cartes de la feuille « Ajouter des capacités » (01/10).
  ADDED: "AJOUTÉ",
  "Tool Details": "Détails de l'outil",
  "Find documentation": "Documentation",
  here: "ici",
  "Tools that allow agents to retrieve data and take actions.":
    "Outils qui permettent à l'assistant de lire des données et d'agir.",
  "Configure {name}": "Configurer {name}",
  "Edit {name}": "Modifier {name}",
  "Updated {ago} ago": "Mis à jour il y a {ago}",
  "Latest indexed record {ago} ago":
    "Dernier enregistrement indexé il y a {ago}",
  "{active} of {total} members active": "{active} membres actifs sur {total}",
  // Onglets Déclencheurs et Éditeurs de la fiche (01/10).
  "My triggers": "Mes déclencheurs",
  "You have no triggers set up for this agent yet.":
    "Aucun déclencheur pour cet assistant pour l'instant.",
  "Failed to delete trigger": "Suppression du déclencheur impossible",
  "An error occurred while deleting the trigger.":
    "Une erreur est survenue lors de la suppression du déclencheur.",
  "Last 7 days": "7 derniers jours",
  "Last 30 days": "30 derniers jours",
  "Last 90 days": "90 derniers jours",
  Daily: "Par jour",
  Weekly: "Par semaine",
  Monthly: "Par mois",
  Cumulative: "Cumulé",
  Consumption: "Consommation",
  Clear: "Effacer",
  "Select all": "Tout sélectionner",
  Reactions: "Réactions",
  Charts: "Graphiques",
  "By Timerange": "Par période",
  "By version": "Par version",
  Loading: "Chargement",
  "Not available": "Indisponible",
  to: "au",
  "Active users": "Membres actifs",
  Others: "Autres",
  Attribution: "Attribution",
  "No consumption over this period.": "Aucune consommation sur la période.",
  "Failed to load consumption.": "Impossible de charger la consommation.",
  "Not enough data to compute": "Pas assez de données",
  "Overview unavailable. Charts and attribution may still load.":
    "Vue d'ensemble indisponible. Les graphiques peuvent encore se charger.",
  "You need access to all spaces used by this agent to view its insights. Open the Info tab to review the access requirements.":
    "Il faut avoir accès à tous les espaces utilisés par cet assistant pour voir ses statistiques. L'onglet Infos détaille les accès requis.",
  // Barre de saisie (30/09, remarque de Louka) : info-bulles de la mise en forme, du + et de l envoi.
  Link: "Lien",
  Blockquote: "Citation",
  "Inline code": "Code en ligne",
  "Code block": "Bloc de code",
  More: "Plus",
  "Send message": "Envoyer le message",
  "Selected agent": "Assistant sélectionné",
  Capabilities: "Outils",
  Attach: "Joindre",
  by: "par",
  // Espaces et dossiers de Dust (RAG, 01/10) : pages des espaces, dossiers, televersement.
  "Open Spaces": "Espaces ouverts",
  "Restricted Spaces": "Espaces restreints",
  // Page Connecteurs (22/10, Louka) : « Connecteurs » au lieu de « Connexions » (menu, recherche, titre).
  Connections: "Connecteurs",
  "{count} item": "{count} élément",
  "{count} items": "{count} éléments",
  "and {count} item": "et {count} élément",
  "and {count} items": "et {count} éléments",
  "You are not a member of this space.":
    "Vous n'êtes pas membre de cet espace.",
  "You can't create more spaces.": "Vous ne pouvez plus créer d'espaces.",
  "We're going to make changes to data permissions spaces soon and are limiting the creation of spaces for that reason. Reach out to us to learn more.":
    "Les autorisations d'accès aux données des espaces vont bientôt évoluer, la création d'espaces est donc limitée pour le moment. Contactez-nous pour en savoir plus.",
  "The maximum number of spaces for this workspace has been reached. Please reach out at support@dust.tt to learn more.":
    "Le nombre maximal d'espaces de votre abonnement est atteint.",
  Ok: "OK",
  // Page Connexions (17/10) : Louka ne voyait pas la différence entre cette section (les sources de
  // documents de l'entreprise) et « Comptes des membres » (ComptesDesMembres.tsx). Une phrase par
  // section, ici suivie de l'explication amont sur les espaces ouverts et restreints.
  "Company documents the assistant can consult for everyone: a website, a shared Google Drive, a shared folder… They are copied and kept up to date automatically.":
    "Les documents de l'entreprise que l'Assistant peut consulter pour tout le monde : un site web, un Google Drive partagé, un dossier partagé… Ils sont copiés et tenus à jour automatiquement.",
  "Here you can authorize Connections and control what data Dust can access. Once connected, data can be distributed to Open Spaces (accessible to all workspace members) or Restricted Spaces (limited access).":
    "Ici, vous autorisez les connexions et choisissez les données auxquelles l'assistant peut accéder. Une fois connectées, les données peuvent être réparties dans des espaces ouverts (accessibles à toute l'équipe) ou des espaces restreints (accès limité).",
  "Need help? Check out our": "Besoin d'aide ? Consultez notre",
  "Here you can add new trigger sources to your workspace. Once created, those sources can be used in the Agent Builder to trigger Agents.":
    "Ici, vous ajoutez de nouvelles sources de déclenchement à votre espace de travail. Une fois créées, ces sources peuvent servir dans l'éditeur d'assistant pour déclencher des assistants.",
  "Used by": "Utilisé par",
  "Space settings": "Réglages de l'espace",
  "Add data": "Ajouter des données",
  "Upload Data": "Téléverser des données",
  "Scrape a website": "Importer un site web",
  "Create a Dust App": "Créer une application",
  "Connections Admin": "Connecteurs",
  "{count} agent": "{count} assistant",
  "{count} agents": "{count} assistants",
  "{count} skill": "{count} compétence",
  "{count} skills": "{count} compétences",
  "{agents} and {skills}": "{agents} et {skills}",
  "0 agents": "0 assistant",
  "Used by 0 agents": "Utilisé par 0 assistant",
  "Used by {usage}": "Utilisé par {usage}",
  "Search agents and skills": "Rechercher des assistants et des compétences",
  "Search agents": "Rechercher des assistants",
  "No matches found": "Aucun résultat",
  "No agents found": "Aucun assistant trouvé",
  Groups: "Groupes",
  "Restricted Access": "Accès restreint",
  "Delete space": "Supprimer l'espace",
  "Deleting {name}": "Suppression de {name}",
  "{count} agent uses tools that depend on this space and will be impacted by its deletion":
    "{count} assistant utilise des outils qui dépendent de cet espace et sera affecté par sa suppression",
  "{count} agents use tools that depend on this space and will be impacted by its deletion":
    "{count} assistants utilisent des outils qui dépendent de cet espace et seront affectés par sa suppression",
  "{count} skill depends on this space and will be impacted by its deletion":
    "{count} compétence dépend de cet espace et sera affectée par sa suppression",
  "{count} skills depend on this space and will be impacted by its deletion":
    "{count} compétences dépendent de cet espace et seront affectées par sa suppression",
  "Are you sure you want to permanently delete space {name}? This action cannot be undone.":
    "Voulez-vous vraiment supprimer définitivement l'espace {name} ? Cette action est irréversible.",
  "Members are the people picked below, plus everyone in the groups given access to the space.":
    "Les membres sont les personnes choisies ci-dessous, ainsi que toutes les personnes des groupes ayant accès à l'espace.",
  "Security notice": "Avertissement de sécurité",
  "You are modifying this space's settings while not being a member yourself. This action will be logged for security purposes. Do you want to proceed?":
    "Vous modifiez les réglages de cet espace sans en être membre. Cette action sera journalisée pour des raisons de sécurité. Voulez-vous continuer ?",
  Proceed: "Continuer",
  "Space Settings - {name}": "Réglages de l'espace, {name}",
  "Space Settings": "Réglages de l'espace",
  "Access settings unavailable": "Réglages d'accès indisponibles",
  "Failed to load group members, please reload the page.":
    "Impossible de charger les membres des groupes, veuillez recharger la page.",
  "Restricted access is active.": "L'accès restreint est activé.",
  "Members can read the content of the space and write data into it (upload files, delete documents...).":
    "Les membres peuvent lire le contenu de l'espace et y ajouter des données (téléverser des fichiers, supprimer des documents...).",
  "Restricted access is disabled. The space is open.":
    "L'accès restreint est désactivé. L'espace est ouvert.",
  "Anyone in the workspace can read the data from this space.":
    "Tous les membres peuvent lire les données de cet espace.",
  "Members of the space can also write data (upload files, delete documents...).":
    "Les membres de l'espace peuvent aussi ajouter des données (téléverser des fichiers, supprimer des documents...).",
  "Space's name": "Nom de l'espace",
  "Space name must be unique": "Le nom de l'espace doit être unique",
  Access: "Accès",
  "{name} is the space where you upload and connect the data the whole company has access to, so anyone in the workspace can read this data.":
    "{name} est l'espace où vous téléversez et connectez les données accessibles à toute la structure : tous les membres peuvent donc les lire.",
  "Only admins, managers and the people and groups selected here can modify the data (upload files, delete documents, connect data sources...).":
    "Seuls les administrateurs, les responsables et les personnes et groupes choisis ici peuvent modifier les données (téléverser des fichiers, supprimer des documents, connecter des sources de données...).",
  "They are the people picked below, plus everyone in the groups given access to the space.":
    "Il s'agit des personnes choisies ci-dessous, ainsi que de toutes les personnes des groupes ayant accès à l'espace.",
  "Managed by": "Géré par",
  "Last sync": "Dernière synchronisation",
  Never: "Jamais",
  "Retry in a few minutes": "Réessayez dans quelques minutes",
  "Connecting...": "Connexion en cours...",
  View: "Voir",
  Edit: "Modifier",
  "Use from API": "Utiliser depuis l'API",
  "Available to": "Disponible pour",
  "Last updated": "Dernière mise à jour",
  "Error while adding data to space":
    "Erreur lors de l'ajout des données à l'espace",
  "Data added to space": "Données ajoutées à l'espace",
  "An Unknown error {error} occurred while adding data to space.":
    "Une erreur inconnue ({error}) est survenue lors de l'ajout des données à l'espace.",
  "Manage Data": "Gérer les données",
  "No content": "Aucun contenu",
  document: "document",
  table: "tableau",
  "Connection ready. Select the data to sync.":
    "Connexion prête. Sélectionnez les données à synchroniser.",
  "Drag and drop your files here.": "Glissez et déposez vos fichiers ici.",
  "Add Files": "Ajouter des fichiers",
  "Add to space": "Ajouter à un espace",
  "Copy DataSource ID": "Copier l'identifiant de la source de données",
  "View associated URL": "Voir l'adresse associée",
  "View in {source}": "Voir dans {source}",
  "View raw content": "Voir le contenu brut",
  "You need write access to add data in the {space} space.":
    "Vous devez disposer d'un accès en écriture pour ajouter des données dans l'espace {space}.",
  "Only members of the space can add data.":
    "Seuls les membres de l'espace peuvent ajouter des données.",
  "You need write access to edit a folder in the {space} space.":
    "Vous devez disposer d'un accès en écriture pour modifier un dossier dans l'espace {space}.",
  "Only members of the space can edit a folder.":
    "Seuls les membres de l'espace peuvent modifier un dossier.",
  "Create a document": "Créer un document",
  "Create a table": "Créer un tableau",
  "Upload files": "Téléverser des fichiers",
  "Edit folder": "Modifier le dossier",
  "Edit Website": "Modifier le site web",
  "Name is required.": "Le nom est obligatoire.",
  "Name is invalid, must be multiple characters with no space.":
    "Nom invalide, il doit comporter plusieurs caractères sans espace.",
  "Create Folder": "Créer un dossier",
  "Edit Folder": "Modifier le dossier",
  folder_name: "nom_du_dossier",
  "Folder name must be unique": "Le nom du dossier doit être unique",
  "Folder description": "Description du dossier",
  "Delete Folder": "Supprimer le dossier",
  "Data sync in progress...": "Synchronisation des données en cours...",
  "Once synchronized, table will appear under":
    "Une fois synchronisés, les tableaux apparaîtront dans",
  "Once synchronized, data will appear under":
    "Une fois synchronisées, les données apparaîtront dans",
  '"Connection Admin"': "« Connecteurs »",
  "and can be added to:": "et vous pourrez les ajouter à :",
  An: "Un",
  "Open Space": "Espace ouvert",
  "for company-wide access": "pour un accès à toute la structure",
  A: "Un",
  "Restricted Space": "Espace restreint",
  "for custom access": "pour un accès sur mesure",
  "Data Management": "Gestion des données",
  See: "Consultez la",
  documentation: "documentation",
  "for more information.": "pour en savoir plus.",
  "Failed to enable connection ({provider})":
    "Impossible d'activer la connexion ({provider})",
  "{plan} plan": "Formule {plan}",
  "Unlock this managed data source by upgrading your plan.":
    "Passez à une formule supérieure pour débloquer cette source de données connectée.",
  Validate: "Valider",
  "Coming Soon!": "Bientôt disponible !",
  "Please email us at support@dust.tt for early access.":
    "Écrivez-nous à support@dust.tt pour un accès anticipé.",
  "Contact us": "Nous contacter",
  // Seul usage : le bouton de la page Connexions (AddConnectionMenu), qui ajoute un connecteur de
  // documents de l'entreprise (17/10).
  "Add Connections": "Ajouter une source de documents",
  "Showing {shown} of {total} results":
    "{shown} résultats affichés sur {total}",
  Location: "Emplacement",
  Actions: "Actions",
  "Searching in": "Recherche dans",
  "Advanced settings": "Réglages avancés",
  "Custom Headers": "En-têtes personnalisés",
  "Add custom request headers for the web crawler.":
    "Ajoutez des en-têtes de requête personnalisés pour l'exploration du site.",
  "Header Name": "Nom de l'en-tête",
  "Header Value": "Valeur de l'en-tête",
  "Add Header": "Ajouter un en-tête",
  "Website Entry Point": "Adresse de départ du site",
  "Enter the address of the website you'd like to index.":
    "Saisissez l'adresse du site web que vous souhaitez indexer.",
  "Ensure the website is public": "Vérifiez que le site web est public",
  "Only public websites accessible without authentication will work.":
    "Seuls les sites web publics, accessibles sans identification, fonctionneront.",
  "Indexing settings": "Réglages d'indexation",
  "Adjust the settings to only index the data you are interested in.":
    "Ajustez les réglages pour n'indexer que les données qui vous intéressent.",
  "Crawling strategy": "Stratégie d'exploration",
  "Do you want to limit to child pages or not?":
    "Souhaitez-vous vous limiter aux sous-pages ?",
  "Only child pages of the provided URL":
    "Uniquement les sous-pages de l'adresse indiquée",
  "Follow all the links within the domain": "Suivre tous les liens du domaine",
  "Refresh schedule": "Fréquence d'actualisation",
  "How often would you like to check for updates?":
    "À quelle fréquence souhaitez-vous vérifier les mises à jour ?",
  "Every day": "Tous les jours",
  "Every week": "Toutes les semaines",
  "Every month": "Tous les mois",
  "Depth of Search": "Profondeur d'exploration",
  "How far from the initial page would you like to go?":
    "Jusqu'où souhaitez-vous aller à partir de la page de départ ?",
  "0 level": "0 niveau",
  "1 level": "1 niveau",
  "2 levels": "2 niveaux",
  "3 levels": "3 niveaux",
  "4 levels": "4 niveaux",
  "5 levels": "5 niveaux",
  "Page Limit": "Nombre maximal de pages",
  "What is the maximum number of pages you'd like to index?":
    "Combien de pages souhaitez-vous indexer au maximum ?",
  "Maximum pages must be between 1 and {max}":
    "Le nombre maximal de pages doit être compris entre 1 et {max}",
  "Website name cannot be changed.":
    "Le nom du site web ne peut pas être modifié.",
  "Give a name to this Data Source.":
    "Donnez un nom à cette source de données.",
  Articles: "Articles",
  "Please provide a name.": "Veuillez indiquer un nom.",
  "A website with this name already exists":
    "Un site web portant ce nom existe déjà",
  "Please provide a valid URL (e.g. https://example.com or https://example.com/a/b/c)).":
    "Veuillez indiquer une adresse valide (par exemple https://example.com ou https://example.com/a/b/c).",
  "Website updated": "Site web mis à jour",
  "Website created": "Site web créé",
  "The website has been successfully updated.":
    "Le site web a bien été mis à jour.",
  "The website has been successfully created.": "Le site web a bien été créé.",
  "Error updating website": "Erreur lors de la mise à jour du site web",
  "Error creating website": "Erreur lors de la création du site web",
  "An error occurred": "Une erreur est survenue",
  "Error deleting website": "Erreur lors de la suppression du site web",
  "Create a website": "Ajouter un site web",
  "Delete this website": "Supprimer ce site web",
  "Data sources in use": "Sources de données utilisées",
  "Delete anyway": "Supprimer quand même",
  Warning: "Attention",
  "Deleting these data sources will affect the agents using them. These agents will no longer have access to this data and may not work as expected.":
    "Supprimer ces sources de données aura un effet sur les assistants qui les utilisent. Ces assistants n'auront plus accès à ces données et risquent de ne plus fonctionner comme prévu.",
  "The following data sources are currently in use:":
    "Les sources de données suivantes sont actuellement utilisées :",
  "(used by {count} agents)": "(utilisée par {count} assistants)",
  "(used by {count} agent)": "(utilisée par {count} assistant)",
  "Are you sure you want to remove them?": "Voulez-vous vraiment les retirer ?",
  "Error Adding Data to Space": "Erreur lors de l'ajout des données à l'espace",
  "Data Successfully Updated": "Données mises à jour",
  "All data sources were successfully updated in the Space.":
    "Toutes les sources de données de l'espace ont bien été mises à jour.",
  "Edit data from {name}": "Modifier les données de {name}",
  "Add data from {name}": "Ajouter des données depuis {name}",
  "Edit data from connections": "Modifier les données des connecteurs",
  "Add data from connections": "Ajouter des données depuis les connecteurs",
  "No connection set up": "Aucun connecteur configuré",
  "You have no connection set up.": "Vous n'avez configuré aucun connecteur.",
  Close: "Fermer",
  "Go to connections management": "Gérer les connecteurs",
  "Editing spaces is temporarily disabled and will be re-enabled shortly.":
    "La modification des espaces est temporairement désactivée et sera rétablie sous peu.",
  "Add folder": "Ajouter un dossier",
  "Add website": "Ajouter un site web",
  "You need write access to add a folder in the Company data space.":
    "Vous devez avoir les droits d'écriture pour ajouter un dossier dans l'espace Données Entreprise.",
  "You need write access to add a website in the Company data space.":
    "Vous devez avoir les droits d'écriture pour ajouter un site web dans l'espace Données Entreprise.",
  "Only members of the space can add a folder.":
    "Seuls les membres de l'espace peuvent ajouter un dossier.",
  "Only members of the space can add a website.":
    "Seuls les membres de l'espace peuvent ajouter un site web.",
  "Add Tools": "Ajouter des outils",
  "No more tools to add": "Plus aucun outil à ajouter",
  'Add connected data to space "{name}"':
    "Ajouter des données connectées à l'espace « {name} »",
  "Remove tools from space": "Retirer les outils de l'espace",
  "You don’t have any triggers yet.": "Vous n'avez encore aucun déclencheur.",
  "Changing source selection": "Changement de source",
  "An agent can access one source of data only. The other tools are using a different source.":
    "Un assistant ne peut accéder qu'à une seule source de données. Les autres outils utilisent une source différente.",
  "Error sending email": "Erreur lors de l'envoi de l'e-mail",
  "An unexpected error occurred while sending email.":
    "Une erreur inattendue est survenue lors de l'envoi de l'e-mail.",
  "Email sent!": "E-mail envoyé !",
  "Your request was sent to {name}": "Votre demande a été envoyée à {name}",
  "An unexpected error occurred while sending the request.":
    "Une erreur inattendue est survenue lors de l'envoi de la demande.",
  "Request Tool": "Demander un outil",
  "Requesting Access to {name}": "Demande d'accès à {name}",
  "There are no extra tools set up that you can request access to. Ask an admin to set one up.":
    "Aucun outil supplémentaire n'est configuré pour une demande d'accès. Demandez à un administrateur d'en configurer un.",
  "Which tools you want to get access to?":
    "À quels outils souhaitez-vous accéder ?",
  "Pick Tools": "Choisir des outils",
  "{admin} is the administrator for the {tool} tool within Dust. Send an email to {admin}, explaining your request.":
    "{admin} est l'administrateur de l'outil {tool}. Envoyez un e-mail à {admin} pour expliquer votre demande.",
  Hello: "Bonjour",
  Send: "Envoyer",
  "Replace existing files?": "Remplacer les fichiers existants ?",
  "A file named": "Un fichier nommé",
  "already exists in this folder. Do you want to replace it?":
    "existe déjà dans ce dossier. Voulez-vous le remplacer ?",
  "{count} files already exist in this folder:":
    "{count} fichiers existent déjà dans ce dossier :",
  "and {count} more...": "et {count} de plus…",
  "Do you want to replace them?": "Voulez-vous les remplacer ?",
  Replace: "Remplacer",
  "Uploading files": "Téléversement des fichiers",
  "Processing files {completed} / {total}":
    "Traitement des fichiers {completed} / {total}",
  "Empty document content": "Document vide",
  "The uploaded file is empty. Please upload a file with content.":
    "Le fichier téléversé est vide. Veuillez téléverser un fichier avec du contenu.",
  "Error fetching document content":
    "Erreur lors de la récupération du contenu du document",
  "Missing document title": "Titre du document manquant",
  "You must provide a title for the document.":
    "Vous devez indiquer un titre pour le document.",
  "Missing document content": "Contenu du document manquant",
  "You must provide content for the document. Either upload a file or specify the content.":
    "Vous devez fournir un contenu pour le document. Téléversez un fichier ou saisissez le contenu.",
  "Invalid document": "Document invalide",
  "Please fill in all required fields.":
    "Veuillez remplir tous les champs obligatoires.",
  "Multiple files": "Plusieurs fichiers",
  "Please upload only one file at a time.":
    "Veuillez téléverser un seul fichier à la fois.",
  "Error uploading file": "Erreur lors du téléversement du fichier",
  "Edit document": "Modifier le document",
  "Add document": "Ajouter un document",
  "Content cannot be loaded.": "Le contenu ne peut pas être chargé.",
  "Document title": "Titre du document",
  "You must provide a title.": "Vous devez indiquer un titre.",
  "Associated URL": "URL associée",
  "The URL of the associated document (if any). Will be used to link users to the original document in agents citations.":
    "L'URL du document d'origine (le cas échéant). Elle sert à renvoyer vers le document d'origine dans les citations des assistants.",
  "Text content": "Contenu texte",
  "Copy paste content or upload a file ({extensions}). \n Up to {size} MB of raw text.":
    "Collez le contenu ou téléversez un fichier ({extensions}). \n Jusqu'à {size} Mo de texte brut.",
  "Upload file": "Téléverser un fichier",
  "Your document content...": "Contenu de votre document…",
  "You must upload a file or specify the content of the document.":
    "Vous devez téléverser un fichier ou saisir le contenu du document.",
  Labels: "Étiquettes",
  Hide: "Masquer",
  Show: "Afficher",
  "Labels can be set to filter Data Source retrieval.":
    "Les étiquettes permettent de filtrer la recherche dans la source de données.",
  "Add label": "Ajouter une étiquette",
  Label: "Étiquette",
  Remove: "Retirer",
  Error: "Erreur",
  "Cannot save the table: the file is still loading.":
    "Impossible d'enregistrer le tableau : le fichier est encore en cours de chargement.",
  "Missing file": "Fichier manquant",
  "You must upload a file to create a table.":
    "Vous devez téléverser un fichier pour créer un tableau.",
  "Invalid name": "Nom invalide",
  "You must provide a valid name for the table.":
    "Vous devez indiquer un nom valide pour le tableau.",
  "Invalid description": "Description invalide",
  "You must provide a description for the table.":
    "Vous devez indiquer une description pour le tableau.",
  "Invalid table": "Tableau invalide",
  "Please fill all the required fields.":
    "Veuillez remplir tous les champs obligatoires.",
  "Edit table": "Modifier le tableau",
  "Add table": "Ajouter un tableau",
  "Table name": "Nom du tableau",
  "Invalid name: Must be lowercase alphanumeric, max 32 characters and no space.":
    "Nom invalide : lettres minuscules et chiffres uniquement, 32 caractères au maximum, sans espace.",
  "Describe the content of your data. It will be used by the LLM model to generate relevant queries.":
    "Décrivez le contenu de vos données. L'assistant s'en servira pour formuler des requêtes pertinentes.",
  "This table contains...": "Ce tableau contient…",
  "You need to provide a description for your data file.":
    "Vous devez indiquer une description pour votre fichier de données.",
  "Data File": "Fichier de données",
  "Select your data file for extraction. Supported formats: CSV, XLSX. Maximum file size: {size}.":
    "Sélectionnez votre fichier de données. Formats acceptés : CSV, XLSX. Taille maximale : {size}.",
  "Replace file": "Remplacer le fichier",
  "Warning: Large file (5MB+)": "Attention : fichier volumineux (plus de 5 Mo)",
  "This file is large and may take a while to upload.":
    "Ce fichier est volumineux, son téléversement peut prendre un moment.",
  folder: "dossier",
  "{Type} deletion submitted": "Suppression du {type} demandée",
  "Deletion of {type} {title} is ongoing, it will complete shortly.":
    "La suppression du {type} {title} est en cours, elle sera terminée sous peu.",
  "Error deleting {type}": "Erreur lors de la suppression du {type}",
  "An error occurred while deleting your {type}.":
    "Une erreur est survenue lors de la suppression de votre {type}.",
  "Confirm deletion": "Confirmer la suppression",
  "Are you sure you want to delete{type}{title}?":
    "Voulez-vous vraiment supprimer ce{type}{title} ?",
  "This action cannot be undone.": "Cette action est irréversible.",
  "Checking usage...": "Vérification de l'utilisation…",
  "Failed to check usage.": "Impossible de vérifier l'utilisation.",
  "No usage data available.": "Aucune donnée d'utilisation disponible.",
  '{count} agents currently use "{name}": {agents}.':
    "{count} assistants utilisent actuellement « {name} » : {agents}.",
  'No agents are using "{name}".': "Aucun assistant n'utilise « {name} ».",
  "Are you sure you want to delete ?": "Voulez-vous vraiment supprimer ?",
  "You have reached the limit of documents per data source ({count} documents). Upgrade your plan for unlimited documents and data sources.":
    "Vous avez atteint la limite de documents par source de données ({count} documents). Passez à une offre supérieure pour des documents et des sources de données illimités.",
  "Check Dust plans": "Voir les offres",
  "Error loading synchronization information":
    "Erreur lors du chargement des informations de synchronisation",
  "Our access to your account has been revoked. Re-authorize to keep the connection up-to-date.":
    "Notre accès à votre compte a été révoqué. Autorisez-le de nouveau pour garder la connexion à jour.",
  "Re-authorization required": "Nouvelle autorisation requise",
  "We have encountered an error with {provider}. We sent you an email to resolve the issue.":
    "Une erreur est survenue avec {provider}. Nous vous avons envoyé un e-mail pour résoudre le problème.",
  "Synchronization failed": "Échec de la synchronisation",
  "We are having trouble retrieving your data from {provider}. Synchronization will resume automatically once the issue is resolved.":
    "Nous rencontrons des difficultés pour récupérer vos données depuis {provider}. La synchronisation reprendra automatiquement une fois le problème résolu.",
  "Synchronization delayed": "Synchronisation retardée",
  "The synchronization failed because too many excessively large pages were found.":
    "La synchronisation a échoué, trop de pages sont trop volumineuses.",
  "Pages too large": "Pages trop volumineuses",
  "The synchronization failed to retrieve any content.":
    "La synchronisation n'a récupéré aucun contenu.",
  "Empty content": "Contenu vide",
  "The synchronization failed because the websites blocks automated visits.":
    "La synchronisation a échoué, le site web bloque les visites automatisées.",
  "Access blocked": "Accès bloqué",
  "The website synchronization reached the maximum page limit.":
    "La synchronisation du site web a atteint le nombre maximal de pages.",
  "Limit reached": "Limite atteinte",
  "We need read-only access to your database to synchronize data. Please update the permissions and try again.":
    "Un accès en lecture seule à votre base de données est nécessaire pour synchroniser les données. Veuillez modifier les autorisations puis réessayer.",
  "We encountered a network error while trying to connect to your database.Please check your network connection and try again.":
    "Une erreur réseau est survenue lors de la connexion à votre base de données. Veuillez vérifier votre connexion réseau puis réessayer.",
  "You've exceeded the total storage quota of {quota} for your workspace. Contact support@dust.tt to upgrade your plan.":
    "Vous avez dépassé le quota de stockage total de {quota} pour votre cabinet. Contactez le support pour faire évoluer votre offre.",
  "Quota exceeded": "Quota dépassé",
  "Your current plan does not allow API access, which is required to synchronize data. Contact support@dust.tt to upgrade your plan.":
    "Votre offre actuelle ne permet pas l'accès API, nécessaire à la synchronisation des données. Contactez le support pour faire évoluer votre offre.",
  "Synchronization is paused. New content won't be synced until resumed.":
    "La synchronisation est en pause. Les nouveaux contenus ne seront pas synchronisés avant sa reprise.",
  Paused: "En pause",
  Synchronizing: "Synchronisation en cours",
  "{ago} ago": "il y a {ago}",
  Pending: "En attente",
  "Search results are partial due to the large amount of data.":
    "Les résultats sont partiels en raison du grand volume de données.",
  "0 results found": "Aucun résultat",
  "Showing {loaded} of {total} result": "{loaded} résultat affiché sur {total}",
  "Showing {loaded} of {total} results":
    "{loaded} résultats affichés sur {total}",
  "scroll for more": "faites défiler pour en voir plus",
  "No matching results found. Try different search terms.":
    "Aucun résultat correspondant. Essayez d'autres termes de recherche.",
  "No data source in this space.": "Aucune source de données dans cet espace.",
  "No space selected.": "Aucun espace sélectionné.",
  "Loading...": "Chargement…",
  "Unselect All": "Tout désélectionner",
  "Select All": "Tout sélectionner",
  "No tables": "Aucun tableau",
  "No documents": "Aucun document",
  "From spaces": "Depuis les espaces",
  "From Pods": "Depuis les projets",
  "Pod files": "Fichiers du projet",
  "All knowledge": "Toutes les connaissances",
  'In "{scope}"': "Dans « {scope} »",
  // Connexions : page, fenetre OAuth, permissions des connecteurs (02/10).
  "Connection Setup": "Configuration de la connexion",
  "Connecting {name}": "Connexion à {name}",
  "Read our guide": "Lire le guide",
  Disclosure: "Information",
  "Dust's use of information received from the Google APIs will adhere to":
    "L'utilisation par la plateforme des informations reçues des API Google respecte la",
  "Google API Services User Data Policy":
    "politique des données utilisateur des services d'API Google",
  ", including the Limited Use requirements.":
    ", y compris les exigences d'utilisation limitée.",
  "Notice on data processing": "Traitement des données",
  "By connecting Google Drive, you acknowledge and agree that within your Google Drive, the data contained in the files and folders that you choose to synchronize with Dust will be transmitted to third-party entities, including but not limited to Artificial Intelligence (AI) model providers, for the purpose of processing and analysis. This process is an integral part of the functionality of our service and is subject to the terms outlined in our Privacy Policy and Terms of Service.":
    "En connectant Google Drive, vous reconnaissez et acceptez que les données des fichiers et dossiers de votre Google Drive que vous choisissez de synchroniser avec la plateforme soient transmises à des tiers, notamment des fournisseurs de modèles d'intelligence artificielle (IA), pour être traitées et analysées. Ce traitement fait partie intégrante du service et relève de notre politique de confidentialité et de nos conditions d'utilisation.",
  Limitations: "Limites",
  "Acknowledge and connect": "Accepter et connecter",
  "Files with empty text content or with more than 750KB of extracted text are ignored. By default, PDF files are not indexed. Email us at support@dust.tt to enable PDF indexing.":
    "Les fichiers sans texte, ou dont le texte extrait dépasse 750 Ko, sont ignorés. Les PDF ne sont pas indexés par défaut : activez la synchronisation des PDF dans les options de la connexion.",
  "You cannot select another Google Drive Domain.\nPlease contact us at support@dust.tt if you initially selected a wrong shared Drive.":
    "Impossible de choisir un autre domaine Google Drive.\nSi le mauvais Drive partagé a été choisi au départ, contactez votre administrateur.",
  "Select folders and files": "Choisir les dossiers et fichiers",
  "When enabled, PDF documents from your Google Drive will be synced and processed by Dust.":
    "Une fois activée, les PDF de votre Google Drive sont synchronisés et lus par l'assistant.",
  "Dust will only index documents accessible to the account used when making the connection. Only organizational accounts are supported (Sharepoint). At the time, OneDrive cannot be synced.":
    "Seuls les documents accessibles au compte utilisé pour la connexion sont indexés. Seuls les comptes professionnels sont pris en charge (SharePoint). OneDrive ne peut pas encore être synchronisé.",
  "You cannot select another Microsoft account.\nPlease contact us at support@dust.tt if you initially selected a wrong account.":
    "Impossible de choisir un autre compte Microsoft.\nSi le mauvais compte a été choisi au départ, contactez votre administrateur.",
  "Select the folder to enable file synchronization.":
    "Choisissez le dossier pour activer la synchronisation des fichiers.",
  "When enabled, PDF documents from your Microsoft OneDrive and SharePoint will be synced and processed by Dust.":
    "Une fois activée, les PDF de votre OneDrive et de SharePoint sont synchronisés et lus par l'assistant.",
  "Enable PDF syncing": "Synchroniser les PDF",
  "Use a Service Principal": "Utiliser un principal de service",
  "Tenant ID": "ID du locataire",
  "Client ID": "ID client",
  "Service Account secret": "Secret du compte de service",
  "Save this secret - you'll need to re-enter it each time you configure this connector":
    "Conservez ce secret : il faudra le saisir à nouveau à chaque configuration de ce connecteur",
  "Selected SharePoint sites Dust will have access to (one per line).":
    "Sites SharePoint auxquels la plateforme aura accès (un par ligne).",
  "Provide the SharePoint site identifiers assigned to the service principal. Enter one identifier per line. This is not required if your Service Principal has access to all sites.":
    "Indiquez les identifiants des sites SharePoint attribués au principal de service, un par ligne. Inutile si votre principal de service a accès à tous les sites.",
  "Failed to update the permissions": "Échec de la mise à jour des permissions",
  "Failed to update the connection": "Échec de la mise à jour de la connexion",
  "The connection was updated but the credential could not be set.":
    "La connexion a été mise à jour, mais l'identifiant n'a pas pu être enregistré.",
  "Successfully updated connection": "Connexion mise à jour",
  "The connection was successfully updated.":
    "La connexion a bien été mise à jour.",
  "The authenticated user needs higher permissions from your service provider.":
    "Le compte utilisé a besoin de droits plus élevés chez le fournisseur.",
  "Failed to update the permissions of the Data Source. Please retry to reconnect, or contact support@dust.tt for assistance if the problem persists.":
    "Échec de la mise à jour des permissions de la source. Reconnectez-vous, ou contactez votre administrateur si le problème persiste.",
  "Manage Connection": "Gérer la connexion",
  "{name} data & permissions": "{name} : données et permissions",
  Important: "Important",
  Editing: "Modifier",
  "can break the existing data structure in Dust and Agents using them.":
    "peut casser la structure des données existantes et les assistants qui les utilisent.",
  "Read our": "Lire le",
  Playbook: "guide",
  "Connection Owner": "Propriétaire de la connexion",
  You: "Vous",
  "set it up": "l'avez configurée",
  "set it up (other)": "l'a configurée",
  " on {date}": " le {date}",
  "Authorized with Microsoft account": "Autorisée avec le compte Microsoft",
  "Editing permissions": "Modifier les permissions",
  "You are not the owner of this connection.":
    "Vous n'êtes pas le propriétaire de cette connexion.",
  "Editing permission rights with a different account will likely break the existing data structure in Dust and Agents using them.":
    "Modifier les permissions avec un autre compte risque de casser la structure des données existantes et les assistants qui les utilisent.",
  "Edit Permissions": "Modifier les permissions",
  "Editing permissions is temporarily disabled":
    "La modification des permissions est temporairement désactivée",
  "Are you sure?": "Confirmer ?",
  "The changes you are about to make may break existing {name} Data sources and the agents using them. Are you sure you want to continue?":
    "Ces modifications peuvent casser les sources {name} existantes et les assistants qui les utilisent. Continuer ?",
  Continue: "Continuer",
  "Successfully deleted connection": "Connexion supprimée",
  "The connection has been successfully deleted.":
    "La connexion a bien été supprimée.",
  "Error deleting connection": "Échec de la suppression de la connexion",
  "Deleting {name} connection": "Supprimer la connexion {name}",
  Deleting: "Supprimer",
  "will break Agents using this data.":
    "cassera les assistants qui utilisent ces données.",
  "Deleting this connection removes the documents imported from {name} and the assistants can no longer search them. Your files stay untouched in {name}.":
    "Supprimer la connexion efface de « Données Entreprise » les documents importés depuis {name}, et l'assistant ne pourra plus y chercher. Vos fichiers restent intacts dans {name}.",
  "Connection removal requires support":
    "La suppression de cette connexion demande une assistance",
  "Removing a connection permanently deletes its synced data and may break agents or spaces that rely on it. Contact your administrator to remove this connection.":
    "Supprimer une connexion efface définitivement les documents qu'elle a importés et retire aux assistants la recherche qui s'en sert. Cette suppression se fait avec l'équipe qui gère votre espace. Pour arrêter l'import sans rien perdre, suspendez la synchronisation.",
  "Delete Connection": "Supprimer la connexion",
  "The changes you are about to make will break existing agents using {name}. Are you sure you want to continue?":
    "Les documents importés depuis {name} seront effacés de « Données Entreprise » et l'assistant ne pourra plus y chercher. Vos fichiers restent intacts dans {name}. Supprimer la connexion ?",
  "Error saving connector configuration":
    "Échec de l'enregistrement de la configuration",
  "An unexpected error occurred while saving connector configuration.":
    "Une erreur inattendue est survenue pendant l'enregistrement de la configuration.",
  "Manage {name}": "Gérer {name}",
  "Manage {name} connection": "Gérer la connexion {name}",
  "Edit permissions": "Modifier les permissions",
  "Edit connection": "Modifier la connexion",
  "Setup Private Integration": "Configurer une intégration privée",
  "Delete connection": "Supprimer la connexion",
  "Connection options": "Options de la connexion",
  Advanced: "Avancé",
  " and {count} more...": " et {count} autres…",
  "Sensitive data synchronization": "Synchronisation de données sensibles",
  "You are synchronizing data from private source(s): {sources}. Is this okay?":
    "Vous synchronisez des données de sources privées : {sources}. Continuer ?",
  "Connected service's API limit reached. Please retry shortly.":
    "Limite d'appels du service connecté atteinte. Réessayez dans quelques instants.",
  "Failed to retrieve permissions due to a revoked authorization. Please re-authorize the connection.":
    "Impossible de lire les permissions : l'autorisation a été révoquée. Reconnectez le compte.",
  "The connected account does not have sufficient permissions. Please re-authorize the connection with an administrator account.":
    "Le compte connecté n'a pas les droits suffisants. Reconnectez avec un compte administrateur.",
  "Failed to retrieve permissions due to an unexpected error. The resource may have been deleted, moved, or its sharing permissions changed.":
    "Impossible de lire les permissions : erreur inattendue. L'élément a peut-être été supprimé, déplacé, ou ses droits de partage ont changé.",
  "Failed to select all": "Impossible de tout sélectionner",
  "Could not load folders to select. Please try again.":
    "Les dossiers à sélectionner n'ont pas pu être chargés. Réessayez.",
  "Some locations could not be selected":
    "Certains emplacements n'ont pas pu être sélectionnés",
  "Selected accessible folders, but skipped {count} inaccessible location(s).":
    "Dossiers accessibles sélectionnés, {count} emplacement(s) inaccessible(s) ignoré(s).",
  "Your request was sent to {name}.": "Votre demande a été envoyée à {name}.",
  Request: "Demander",
  "Requesting Data sources": "Demander des sources de données",
  "You have no connection set up. Ask an admin to set one up.":
    "Aucune connexion configurée. Demandez à un administrateur d'en créer une.",
  "Where are the requested Data hosted?":
    "Où se trouvent les données demandées ?",
  "Pick your platform": "Choisir la plateforme",
  "{name} is the administrator for the {connection} connection within Dust. Send an email to {name}, explaining your request.":
    "{name} administre la connexion {connection}. Envoyez un e-mail à {name} pour expliquer votre demande.",
  "Hello {name},": "Bonjour {name},",
  "Connect account": "Connecter le compte",
  "Dust needs access to {service} to complete this action.":
    "L'assistant a besoin d'accéder à {service} pour terminer cette action.",
  "this service": "ce service",
  "Once connected, {service} will remain connected for future requests.":
    "Une fois connecté, {service} le restera pour les prochaines demandes.",
  "Waiting for": "En attente de",
  "to connect their account.": "pour qu'il connecte son compte.",
  Decline: "Refuser",
  "Connect {service}": "Connecter {service}",
  account: "le compte",
  "Connections required for personal tools":
    "Connexions requises pour les outils personnels",
  "Connection required for personal tools":
    "Connexion requise pour les outils personnels",
  "Personal tools uses credentials of the user running the agent. Other users will be asked to connect their own accounts when they run the agent.":
    "Les outils personnels utilisent le compte de la personne qui lance l'assistant. Les autres membres devront connecter leur propre compte.",
  "Learn more": "En savoir plus",
  "Failed to connect provider": "La connexion a échoué",
  "{count} connections are required. If you proceed without connecting, the agent will request credentials when they use the tool.":
    "{count} connexions sont requises. Sans elles, l'assistant demandera la connexion au moment d'utiliser l'outil.",
  "{count} connection is required. If you proceed without connecting, the agent will request credentials when they use the tool.":
    "{count} connexion est requise. Sans elle, l'assistant demandera la connexion au moment d'utiliser l'outil.",
  "Failed to delete tool approbation history.":
    "Impossible d'effacer l'historique des confirmations de l'outil.",
  "Success!": "C'est fait",
  "Tool approbation history deleted.":
    "Historique des confirmations de l'outil effacé.",
  "Clear confirmation preferences": "Effacer les préférences de confirmation",
  Disconnect: "Déconnecter",
  "Search tools": "Rechercher un outil",
  "No matching tools found": "Aucun outil correspondant",
  "No tools available yet.": "Aucun outil disponible pour l'instant.",
  "{name} connected": "{name} connecté",
  "Successfully connected to {name}.": "Connexion à {name} réussie.",
  "Failed to connect {name}": "Échec de la connexion à {name}",
  "Could not connect to {name}. Please try again.":
    "Impossible de se connecter à {name}. Réessayez.",
  "{name} disconnected": "{name} déconnecté",
  "Successfully disconnected from {name}.": "{name} est déconnecté.",
  "Failed to disconnect {name}": "Échec de la déconnexion de {name}",
  "Could not disconnect from {name}. Please try again.":
    "Impossible de déconnecter {name}. Réessayez.",
  "A workspace admin must first connect {name} at the workspace level before users can connect their personal accounts. Please contact your workspace administrator to set up the workspace connection.":
    "Un administrateur doit d'abord connecter {name} pour toute l'organisation avant que chaque membre connecte son propre compte. Contactez votre administrateur.",
  "Unexpected error trying to connect to your provider. Please try again.":
    "Erreur inattendue pendant la connexion au fournisseur. Réessayez.",
  // Conversation : validations d'outils, fichiers, navigateur (02/10).
  "Access to {service} is needed to complete this action.":
    "L'accès à {service} est nécessaire pour terminer cette action.",
  "Approval {current} of {total}": "Validation {current} sur {total}",
  "Review details": "Voir le détail",
  "Allow {agent} to use {server}?": "Autoriser {agent} à utiliser {server} ?",
  "to confirm.": "pour qu'il confirme.",
  "Always allow": "Toujours autoriser",
  Allow: "Autoriser",
  "{approve} once": "{approve} une fois",
  "Allow all inputs this session": "Tout autoriser pour cette session",
  "Run this tool for the rest of this session without asking again, whatever the inputs. Nothing is saved afterwards.":
    "Utiliser cet outil jusqu'à la fin de la session sans redemander, quels que soient les paramètres. Rien n'est enregistré ensuite.",
  "Allow agent to {action}?": "Autoriser l'assistant à {action} ?",
  "Allow all the interactions with this tab":
    "Autoriser toutes les actions dans cet onglet",
  "Allow agent to add a domain to the Computer?":
    "Autoriser l'assistant à ajouter un domaine à l'Ordinateur ?",
  "Allow agent to create tasks?": "Autoriser l'assistant à créer des tâches ?",
  "Allow agent to create {n} task(s)?":
    "Autoriser l'assistant à créer {n} tâche(s) ?",
  "Always allow agent to create tasks":
    "Toujours autoriser l'assistant à créer des tâches",
  "Allow agent to update tasks?":
    "Autoriser l'assistant à modifier des tâches ?",
  "Allow agent to mark {n} task(s) as done?":
    "Autoriser l'assistant à marquer {n} tâche(s) comme terminée(s) ?",
  "Allow agent to update {n} task(s) ({done} marked as done)?":
    "Autoriser l'assistant à modifier {n} tâche(s) ({done} marquée(s) comme terminée(s)) ?",
  "Allow agent to update {n} task(s)?":
    "Autoriser l'assistant à modifier {n} tâche(s) ?",
  "Always allow agent to update tasks":
    "Toujours autoriser l'assistant à modifier des tâches",
  "Allow agent to edit Pod information?":
    "Autoriser l'assistant à modifier les informations du projet ?",
  "pod title": "titre",
  "pod description": "description",
  "pod access": "accès",
  "pinned frame": "tableau de bord épinglé",
  "Allow agent to update Pod {fields}?":
    "Autoriser l'assistant à modifier le projet ({fields}) ?",
  "Always allow agent to edit Pod information":
    "Toujours autoriser l'assistant à modifier les informations du projet",
  "Allow agent to update Pod members?":
    "Autoriser l'assistant à modifier les membres du projet ?",
  "add {n}": "ajouter {n}",
  "remove {n}": "retirer {n}",
  "Allow agent to {changes} Pod user(s)?":
    "Autoriser l'assistant à {changes} membre(s) du projet ?",
  " and ": " et ",
  "Always allow agent to update Pod members":
    "Toujours autoriser l'assistant à modifier les membres du projet",
  "Allow agent to set the Pod default agent?":
    "Autoriser l'assistant à choisir l'assistant par défaut du projet ?",
  "Allow agent to reset the Pod default agent?":
    "Autoriser l'assistant à rétablir l'assistant par défaut du projet ?",
  "Allow agent to set the Pod default agent to @{name}?":
    "Autoriser l'assistant à choisir @{name} comme assistant par défaut du projet ?",
  "Always allow agent to set the Pod default agent":
    "Toujours autoriser l'assistant à choisir l'assistant par défaut du projet",
  "Allow agent to schedule a wake-up?":
    "Autoriser l'assistant à programmer un réveil ?",
  "Allow agent to list wake-ups?":
    "Autoriser l'assistant à lister les réveils ?",
  "Allow agent to cancel a wake-up?":
    "Autoriser l'assistant à annuler un réveil ?",
  "Permission needed for {server}.": "Autorisation nécessaire pour {server}.",
  "Allow {subject} to {tool}?": "Autoriser {subject} : {tool} ?",
  "Allow every time an agent uses the “{tool}” tool":
    "Autoriser chaque fois qu'un assistant utilise l'outil « {tool} »",
  "“{arg}” is {value}": "« {arg} » vaut {value}",
  " only for {value}": " uniquement pour {value}",
  " only when {conditions}": " uniquement quand {conditions}",
  "Always allow {agent} to {tool}{scope}":
    "Toujours autoriser {agent} : {tool}{scope}",
  "Running a tool": "Outil en cours",
  "Run a tool": "Utiliser un outil",
  "Tool execution rejected or skipped by the user.":
    "Action refusée ou ignorée par le membre.",
  "Failed to assess action approval. Please try again.":
    "La validation de l'action a échoué. Veuillez réessayer.",
  "Failed to complete {step}": "Échec de {step}",
  "The tool could not resume after {step}. Please try again.":
    "L'outil n'a pas pu reprendre après {step}. Veuillez réessayer.",
  authentication: "l'authentification",
  "file authorization": "l'autorisation du fichier",
  "Failed to record your decision. Please try again.":
    "Votre décision n'a pas été enregistrée. Veuillez réessayer.",
  Yes: "Oui",
  No: "Non",
  "Loading…": "Chargement…",
  "Unknown skill": "Compétence inconnue",
  Skill: "Compétence",
  "Tell the agent what to do differently":
    "Dites à l'assistant quoi faire autrement",
  "Skipping question": "Question ignorée",
  "Submitting answer": "Envoi de la réponse",
  Skip: "Passer",
  "Send answer": "Envoyer la réponse",
  "Conversation files": "Fichiers de la conversation",
  "Delete Frame?": "Supprimer le tableau de bord ?",
  'Are you sure you want to delete the Frame "{name}"? Its source, functions, databases and share links will be permanently removed. This action cannot be undone.':
    "Voulez-vous vraiment supprimer le tableau de bord « {name} » ? Sa source, ses fonctions, ses bases de données et ses liens de partage seront supprimés définitivement. Cette action est irréversible.",
  "Delete folder?": "Supprimer le dossier ?",
  'Are you sure you want to delete "{name}" and all its contents? This action cannot be undone.':
    "Voulez-vous vraiment supprimer « {name} » et tout son contenu ? Cette action est irréversible.",
  "Delete file?": "Supprimer le fichier ?",
  'Are you sure you want to delete "{name}"? This action cannot be undone.':
    "Voulez-vous vraiment supprimer « {name} » ? Cette action est irréversible.",
  "Unpin from banner": "Retirer de la bannière",
  "Pin as Pod banner": "Épingler en bannière du projet",
  "Remove from Pod tabs": "Retirer des onglets du projet",
  "Add as Pod tab": "Ajouter comme onglet du projet",
  "Failed to download the file.": "Le téléchargement du fichier a échoué.",
  "Failed to download the folder.": "Le téléchargement du dossier a échoué.",
  "An error occurred while downloading. Please try again.":
    "Une erreur est survenue pendant le téléchargement. Veuillez réessayer.",
  "Working Files": "Fichiers de travail",
  "Mounted Files": "Fichiers montés",
  "This file path could not be resolved.":
    "Ce chemin de fichier est introuvable.",
  "This file is no longer available.": "Ce fichier n'est plus disponible.",
  Revert: "Annuler les modifications",
  Download: "Télécharger",
  "Downloading…": "Téléchargement…",
  "Conversation attachments & generated content will appear here.":
    "Les pièces jointes et les contenus créés dans la conversation apparaîtront ici.",
  "Search files...": "Rechercher un fichier…",
  "Search files": "Rechercher un fichier",
  "Computer running": "Ordinateur actif",
  "Computer sleeping": "Ordinateur en veille",
  "Waiting for approval": "En attente de validation",
  "Computer expired": "Ordinateur expiré",
  "No files in the Computer yet.":
    "Aucun fichier dans l'Ordinateur pour l'instant.",
  "View source": "Voir la source",
  Rename: "Renommer",
  "Move to…": "Déplacer vers…",
  Empty: "Vide",
  Frame: "Tableau de bord",
  Frames: "Tableaux de bord",
  Layout: "Affichage",
  Grid: "Grille",
  List: "Liste",
  "Last modified": "Dernière modification",
  "Name A → Z": "Nom de A à Z",
  "Name Z → A": "Nom de Z à A",
  Texts: "Textes",
  Images: "Images",
  Code: "Code",
  Slideshows: "Présentations",
  Audio: "Audio",
  Other: "Autres",
  "All files": "Tous les fichiers",
  "This file is too large to preview ({size}).":
    "Ce fichier est trop volumineux pour l'aperçu ({size}).",
  "Unable to preview this file.": "Aperçu impossible pour ce fichier.",
  "Preview Data": "Aperçu",
  Previous: "Précédent",
  "{name} (current location)": "{name} (emplacement actuel)",
  'Move "{name}"': "Déplacer « {name} »",
  "Move file": "Déplacer le fichier",
  "Move to: {destination}": "Déplacer vers : {destination}",
  " (current location)": " (emplacement actuel)",
  "Move here": "Déplacer ici",
  "Zoom out": "Dézoomer",
  "Zoom in": "Zoomer",
  "Rename file": "Renommer le fichier",
  "Rename folder": "Renommer le dossier",
  "Rename Frame": "Renommer le tableau de bord",
  "Enter new name...": "Nouveau nom…",
  "Enter new file name...": "Nouveau nom du fichier…",
  "File saved": "Fichier enregistré",
  "Failed to save file": "L'enregistrement du fichier a échoué",
  // Page des agents et declencheurs planifies (02/10).
  "Manage Agents": "Gérer les assistants",
  "Editable by me": "Modifiables par moi",
  Default: "Par défaut",
  Archived: "Archivés",
  "All custom agents.": "Tous les assistants personnalisés.",
  "Edited or created by you.": "Modifiés ou créés par vous.",
  "Default agents provided by Dust.": "Assistants fournis par défaut.",
  "Archived agents.": "Assistants archivés.",
  "Default Agent": "Assistant par défaut",
  "Hidden agents.": "Assistants masqués.",
  "Visible agents.": "Assistants visibles.",
  "Search (Name, Editors)": "Rechercher (nom, éditeurs)",
  "Show hidden agents": "Afficher les assistants masqués",
  "Shows the agents of all members you can access as an admin, even if they are not published or if they use restricted spaces":
    "Affiche les assistants de tous les membres auxquels vous avez accès en tant qu'administrateur, même non publiés ou liés à des espaces restreints",
  "No agent matches your search or filters.":
    "Aucun assistant ne correspond à votre recherche ou à vos filtres.",
  "No agents yet.": "Aucun assistant pour l'instant.",
  "Error toggling agent: {message}":
    "Impossible de changer l'état de l'assistant : {message}",
  "Clear selection": "Effacer la sélection",
  "Select all on page": "Tout sélectionner sur la page",
  "Deselect {name}": "Désélectionner {name}",
  Model: "Modèle",
  "Messages in the last 30 days": "Messages des 30 derniers jours",
  "Feedback in the last 30 days": "Retours des 30 derniers jours",
  "{n} feedback over the last 30 days": "{n} retour sur les 30 derniers jours",
  "{n} feedbacks over the last 30 days":
    "{n} retours sur les 30 derniers jours",
  "Last Edited": "Dernière modification",
  "More info": "Plus d'infos",
  "Loading agents": "Chargement des assistants",
  "Change tag": "Changer d'étiquette",
  "Search tags": "Rechercher une étiquette",
  "{n} selected.": "Sélection : {n}.",
  "Select all {total} {items}": "Tout sélectionner ({total} {items})",
  "Clear all": "Tout désélectionner",
  agent: "assistant",
  tool: "outil",
  skill: "compétence",
  automation: "automatisation",
  member: "membre",
  "Error loading usage data.":
    "Erreur de chargement des données d'utilisation.",
  "Loading usage data...": "Chargement des données d'utilisation…",
  "{count} over the last {days} days": "{count} sur les {days} derniers jours",
  "over the last {days} days": "sur les {days} derniers jours",
  "{nb} times": "{nb} fois",
  "This agent": "Cet assistant",
  "{name} has been used {count} in the last {days} days.":
    "{name} a été utilisé {count} au cours des {days} derniers jours.",
  "has been used": "a été utilisé",
  "in the last {days} days.": "au cours des {days} derniers jours.",
  "Archiving the agent": "Archiver l'assistant",
  "This will archive the agent for everyone.":
    "L'assistant sera archivé pour tout le monde.",
  "Are you sure you want to proceed?": "Voulez-vous vraiment continuer ?",
  "Archive for everyone": "Archiver pour tout le monde",
  Unpublish: "Dépublier",
  "Unpublishing {n} agent": "Dépublier {n} assistant",
  "Unpublishing {n} agents": "Dépublier {n} assistants",
  "These agents have been used {total} times in the last 30 days.":
    "Ces assistants ont été utilisés {total} fois au cours des 30 derniers jours.",
  "Unpublished agents will no longer be accessible to everyone in the workspace. Members will need to manually add them to use them.":
    "Les assistants dépubliés ne seront plus accessibles à tous les membres. Chacun devra les ajouter lui-même pour les utiliser.",
  "Archiving {n} agents": "Archiver {n} assistants",
  "This will archive the agents for everyone.":
    "Les assistants seront archivés pour tout le monde.",
  "Archive the agents": "Archiver les assistants",
  "Free plan": "Offre gratuite",
  "{name} is only available on our paid plans.":
    "{name} n'est disponible que sur les offres payantes.",
  "No archived agents": "Aucun assistant archivé",
  "Archived agents are kept here, out of everyone's way.":
    "Les assistants archivés sont rangés ici, à l'écart de tous.",
  "No agent has been archived. Agents nobody has mentioned for {days} days will be automatically archived.":
    "Aucun assistant n'a été archivé. Les assistants que personne n'a mentionnés depuis {days} jours seront archivés automatiquement.",
  "No agent has been archived. Agents nobody uses can be archived automatically, or right now.":
    "Aucun assistant n'a été archivé. Les assistants que personne n'utilise peuvent être archivés automatiquement, ou dès maintenant.",
  "Enable daily checks": "Activer la vérification quotidienne",
  "Set it up in the workspace's governance settings.":
    "À régler dans les réglages de gouvernance.",
  "Archive unused now": "Archiver les inutilisés maintenant",
  "Add tags": "Ajouter des étiquettes",
  "Available tags": "Étiquettes disponibles",
  "No tags available": "Aucune étiquette disponible",
  "Manage tags": "Gérer les étiquettes",
  "No tags found": "Aucune étiquette trouvée",
  "Tag label": "Étiquette",
  "Tag usage": "Utilisation",
  "Suggest tags": "Suggérer des étiquettes",
  "Add tag manually": "Ajouter une étiquette à la main",
  "New tag": "Nouvelle étiquette",
  "Tag created": "Étiquette créée",
  "Edit tag": "Modifier l'étiquette",
  "Delete tag": "Supprimer l'étiquette",
  "Managing tags": "Gérer les étiquettes",
  "No tags have been created yet. Let AI suggest tags for your agents, or add manually.":
    "Aucune étiquette pour l'instant. Laissez l'IA proposer des étiquettes pour vos assistants, ou ajoutez-les à la main.",
  "Add tag": "Ajouter une étiquette",
  "Create a new tag for your assistant":
    "Créez une étiquette pour vos assistants",
  "Tag name": "Nom de l'étiquette",
  "Are you absolutely sure?": "Êtes-vous sûr ?",
  'This will delete the tag "{name}" permanently.':
    "L'étiquette « {name} » sera supprimée définitivement.",
  "Tag suggestions applied": "Suggestions d'étiquettes appliquées",
  "All tags have been successfully created for your agents.":
    "Toutes les étiquettes ont été créées pour vos assistants.",
  "Error getting suggestions": "Impossible d'obtenir des suggestions",
  "Please try again. If the problem persists, please contact support.":
    "Réessayez. Si le problème persiste, contactez le support.",
  "Agent tag suggestions": "Suggestions d'étiquettes",
  "Analyzing your agents to create tags...":
    "Analyse de vos assistants pour proposer des étiquettes…",
  "Tag suggestions from your workspace agents:":
    "Étiquettes proposées à partir de vos assistants :",
  "Apply tag suggestions": "Appliquer les suggestions",
  "Failed to create tag": "Création de l'étiquette impossible",
  "Failed to delete tag": "Suppression de l'étiquette impossible",
  "Failed to update tag": "Mise à jour de l'étiquette impossible",
  "Tag deleted": "Étiquette supprimée",
  "Tag updated": "Étiquette mise à jour",
  "Successfully deleted {name}": "{name} archivé",
  "{name} was successfully archived.": "{name} a bien été archivé.",
  "Error archiving {name}": "Impossible d'archiver {name}",
  "Error: {message}": "Erreur : {message}",
  "Successfully archived agents": "Assistants archivés",
  "{n} agents were successfully archived.":
    "{n} assistants ont bien été archivés.",
  "Error archiving agents": "Impossible d'archiver les assistants",
  "Create Schedule": "Nouvelle tâche planifiée",
  "Edit Schedule": "Modifier la tâche planifiée",
  "View Schedule": "Voir la tâche planifiée",
  "Create Trigger": "Nouveau déclencheur",
  "Create {name} Trigger": "Nouveau déclencheur {name}",
  "Edit Trigger": "Modifier le déclencheur",
  "View Trigger": "Voir le déclencheur",
  "Please select an event": "Choisissez un événement",
  "Scheduled task": "Tâche planifiée",
  "Name is required": "Le nom est obligatoire",
  "Name should be less than 255 characters":
    "Le nom doit faire moins de 255 caractères",
  "Timezone is required": "Le fuseau horaire est obligatoire",
  "Cron expression is required": "Décrivez quand l'assistant doit s'exécuter",
  "Select a webhook source": "Choisissez une source de webhook",
  "Message for the agent when the trigger runs.":
    "Message transmis à l'assistant à chaque exécution.",
  Message: "Message",
  "Message is required":
    "Écrivez ce que l'assistant doit faire à chaque exécution.",
  "Run this trigger's conversation inside a Pod instead.":
    "Lancer plutôt la conversation de ce déclencheur dans un projet.",
  "You cannot edit this schedule. It is managed by":
    "Vous ne pouvez pas modifier cette tâche planifiée. Elle est gérée par",
  "another user": "un autre utilisateur",
  "Describe when you want the agent to run in natural language.":
    "Décrivez en langage courant quand l'assistant doit s'exécuter.",
  'e.g. "run every day at 9 AM", or "Late afternoon on business days"...':
    "ex. « tous les jours à 9 h » ou « en fin d'après-midi les jours ouvrés »…",
  "Unable to generate a schedule. Please try rephrasing.":
    "Impossible de générer une planification. Essayez de reformuler.",
  "Generating schedule...": "Génération de la planification…",
  "{description}, in {timezone} timezone.":
    "{description}, fuseau horaire {timezone}.",
  "Next 5 occurrences": "5 prochaines exécutions",
  Enabled: "Activé",
  Disabled: "Désactivé",
  "Disabled by manager": "Suspendu par un administrateur",
  Relocating: "En cours de déplacement",
  Downgraded: "Suspendu (offre réduite)",
  "This trigger's status is managed by Dust.":
    "Le statut de ce déclencheur est géré par la plateforme.",
  "Only a manager or an admin can re-enable this trigger.":
    "Seul un responsable ou un administrateur peut réactiver ce déclencheur.",
  "No description available.": "Aucune description.",
  "No matches": "Aucun résultat",
  "No Pods": "Aucun projet",
  "Your account cannot run scheduled tasks. Ask an administrator for access.":
    "Votre compte ne peut pas lancer de tâches planifiées. Demandez l'accès à un administrateur.",
  "Trigger created": "Déclencheur créé",
  'The trigger "{name}" has been created.':
    "Le déclencheur « {name} » a été créé.",
  "Failed to create trigger": "Création du déclencheur impossible",
  "An unexpected error occurred. Please try again.":
    "Une erreur inattendue s'est produite. Réessayez.",
  "Trigger updated": "Déclencheur mis à jour",
  'The trigger "{name}" has been updated.':
    "Le déclencheur « {name} » a été mis à jour.",
  "Failed to update trigger": "Mise à jour du déclencheur impossible",
  "Trigger enabled": "Déclencheur activé",
  "Trigger disabled": "Déclencheur désactivé",
  "The trigger is now running.": "Le déclencheur est en service.",
  "The trigger is no longer running.": "Le déclencheur est à l'arrêt.",
  // Outils : catalogue, configuration Gmail/Agenda, fiche d'un outil (02/10).
  "Add tools": "Ajouter des outils",
  "Add MCP Server": "Ajouter un serveur MCP",
  "No tool matches your search": "Aucun outil ne correspond à votre recherche",
  "No tools found. Try a different search term.":
    "Aucun outil trouvé. Essayez un autre terme.",
  "Read and send Gmail emails: manage inbox messages, threads, drafts, labels, and attachments.":
    "Lire et envoyer des e-mails Gmail : messages de la boîte de réception, fils, brouillons, libellés et pièces jointes.",
  "Manage Google Calendar: list calendars, create and update meeting events, check free/busy availability, and look up attendee timezones.":
    "Gérer Google Agenda : lister les agendas, créer et modifier des événements, vérifier les disponibilités et les fuseaux horaires des participants.",
  // 08/10 : Google Drive personnel de chaque membre (serveur interne google_drive).
  "Search, read, create, clone, edit, comment on, and manage permissions for files in Google Drive (Docs, Sheets, Presentations).":
    "Chercher, lire, créer, dupliquer, modifier, commenter et partager vos fichiers Google Drive (documents, classeurs, présentations).",
  Disconnected: "Déconnecté",
  Availability: "Disponibilité",
  Account: "Compte",
  By: "Par",
  Personal: "Personnel",
  Shared: "Partagé",
  "You don’t have any tools yet.": "Vous n'avez encore aucun outil.",
  "Setup connection": "Configurer la connexion",
  Success: "C'est fait",
  "{name} added successfully.": "{name} a été ajouté.",
  "Cannot submit credentials": "Envoi des identifiants impossible",
  "The credentials form is not ready. Please retry.":
    "Le formulaire des identifiants n'est pas prêt. Réessayez.",
  "Failed to create server": "Création du serveur impossible",
  "Failed to add the tool": "Ajout de l'outil impossible",
  "Server error from {domain}": "Erreur du serveur {domain}",
  "Failed to connect to the server": "Connexion au serveur impossible",
  "Tool name": "Nom de l'outil",
  "Enter a name for this instance": "Nom de cette instance",
  "Enter a different name": "Saisissez un autre nom",
  "{name} is already installed. This name tells them apart.":
    "{name} est déjà installé. Ce nom permet de les distinguer.",
  "Choose a name that distinguishes this Tool.":
    "Choisissez un nom qui distingue cet outil.",
  "MCP Server": "Serveur MCP",
  "Shared account": "Compte partagé",
  "Personal accounts": "Comptes personnels",
  "All members will use the credentials you provide here.":
    "Tous les membres utiliseront les identifiants que vous fournissez ici.",
  "Each member logs in with their own credentials when they use the tool.":
    "Chaque membre se connecte avec ses propres identifiants quand il utilise l'outil.",
  "Request body (recommended)": "Corps de la requête (recommandé)",
  "Basic auth header": "En-tête d'authentification Basic",
  "How do you want to connect?": "Comment voulez-vous vous connecter ?",
  "Connection type": "Type de connexion",
  "Customize scopes": "Personnaliser les autorisations",
  "Customize scopes ({enabled}/{total} optional enabled)":
    "Personnaliser les autorisations ({enabled}/{total} facultatives activées)",
  "{name} does not support individual connection.":
    "{name} ne permet pas de connexion individuelle.",
  "{name} does not support shared connection.":
    "{name} ne permet pas de connexion partagée.",
  "Customize OAuth scopes": "Personnaliser les autorisations OAuth",
  "Select which permissions to request. Required scopes cannot be removed.":
    "Choisissez les autorisations à demander. Les autorisations obligatoires ne peuvent pas être retirées.",
  implied: "incluse",
  required: "obligatoire",
  Apply: "Appliquer",
  "Failed to create MCP server": "Création du serveur MCP impossible",
  "Failed to discover OAuth metadata for MCP server":
    "Métadonnées OAuth du serveur MCP introuvables",
  "Missing use case": "Type de connexion manquant",
  "Failed to connect {provider}": "Connexion à {provider} impossible",
  "Failed to connect OAuth provider":
    "Connexion au fournisseur OAuth impossible",
  "This name is already in use.": "Ce nom est déjà utilisé.",
  "This name conflicts with an existing Tool. Enter a different name.":
    "Ce nom entre en conflit avec un outil existant. Saisissez un autre nom.",
  "Unsaved changes will be lost":
    "Les modifications non enregistrées seront perdues",
  "All unsaved changes will be lost. Are you sure you want to close?":
    "Toutes les modifications non enregistrées seront perdues. Voulez-vous vraiment fermer ?",
  "Close without saving": "Fermer sans enregistrer",
  "Confirm Removal": "Confirmer le retrait",
  "Are you sure you want to remove {name}?":
    "Voulez-vous vraiment retirer {name} ?",
  "Removing...": "Retrait…",
  General: "Général",
  "Tools & Stakes": "Outils et validations",
  "Available Tools ({count})": "Outils disponibles ({count})",
  "No tools available.": "Aucun outil disponible.",
  "Edited by {name}, {date}": "Modifié par {name}, le {date}",
  Authentication: "Authentification",
  Active: "Actif",
  "Requires authentication": "Authentification requise",
  Deactivate: "Désactiver",
  Activate: "Activer",
  Credentials: "Identifiants",
  Permissions: "Autorisations",
  "Restrict this tool to skills": "Réserver cet outil aux compétences",
  "Agents can only reach this tool through a skill, which carries the workspace context and safety rules with it.":
    "Les assistants n'accèdent à cet outil que par une compétence, qui apporte avec elle le contexte et les règles de sécurité.",
  "Agents can pick this tool up on its own, without a skill to frame how it is used.":
    "Les assistants peuvent utiliser cet outil directement, sans compétence pour encadrer son usage.",
  "Available to all workspace members": "Disponible pour tous les membres",
  "These tools are only available to the users of the selected spaces.":
    "Ces outils ne sont disponibles que pour les membres des dossiers sélectionnés.",
  "These tools are accessible to everyone in the workspace.":
    "Ces outils sont accessibles à tous les membres.",
  "Search a space": "Rechercher un dossier",
  "This server exposes no tools.": "Ce serveur ne propose aucun outil.",
  "{count} tools available": "{count} outils disponibles",
  "{visible} of {total} tools available":
    "{visible} outils disponibles sur {total}",
  "User Approval Settings": "Validation par l'utilisateur",
  High: "Élevé",
  Medium: "Moyen",
  Low: "Faible",
  "Never ask": "Sans validation",
  "Needs explicit user approval.":
    "Demande toujours la validation explicite de l'utilisateur.",
  "Users can save confirmations for specific tool inputs.":
    "L'utilisateur peut mémoriser sa validation pour des paramètres précis.",
  "Users can completely disable confirmations.":
    "L'utilisateur peut désactiver complètement les validations.",
  "Runs automatically.": "S'exécute automatiquement.",
  "High (always ask for confirmation)":
    "Élevé (toujours demander une validation)",
  "Medium (allows input-scoped confirmation save)":
    "Moyen (validation mémorisable par paramètres)",
  "Low (allows user-global confirmation save)":
    "Faible (validation mémorisable pour tout l'outil)",
  "Never ask (automatic execution)": "Sans validation (exécution automatique)",
  "Deselect all": "Désélectionner la liste",
  "No tool matches that search.":
    "Aucun outil ne correspond à cette recherche.",
  Stake: "Validation",
  "Show less": "Voir moins",
  "Show more": "Voir plus",
  "Set stake": "Définir la validation",
  State: "État",
  Enable: "Activer",
  Disable: "Désactiver",
  "Remove this tool from agents?": "Retirer cet outil des assistants ?",
  "Saving will remove the tool from the following agents:":
    "L'enregistrement retirera l'outil des assistants suivants :",
  "Skills using this tool will not be affected.":
    "Les compétences qui utilisent cet outil ne sont pas concernées.",
  "This action will delete the tool's existing copies":
    "Cette action supprimera les copies existantes de l'outil",
  "Making the tool available to all will delete its copies in these spaces:":
    "Rendre l'outil disponible pour tous supprimera ses copies dans ces dossiers :",
  "Any agents using the tool there will lose access until an admin manually re-adds the shared version to each one. If any agents are affected, you'll receive an email listing them.":
    "Les assistants qui l'utilisent dans ces dossiers perdront l'accès jusqu'à ce qu'un administrateur y ajoute à nouveau la version partagée. Si des assistants sont concernés, vous recevrez un e-mail qui les liste.",
  "Continue anyway": "Continuer quand même",
  "{name} updated": "{name} mis à jour",
  "Your changes have been saved.": "Vos modifications sont enregistrées.",
  "Failed to save changes": "Enregistrement impossible",
  "An error occurred while saving changes.":
    "Une erreur est survenue pendant l'enregistrement.",
  "Validation error": "Erreur de saisie",
  "Please fix the highlighted fields and try again.":
    "Corrigez les champs signalés et réessayez.",
  "Synchronization Error": "Erreur de synchronisation",
  "Server URL & Icon": "URL du serveur et icône",
  "Syncing...": "Synchronisation…",
  Sync: "Synchroniser",
  "Bearer Token": "Jeton Bearer",
  "Paste the Bearer Token here": "Collez le jeton Bearer ici",
  "This will be sent alongside the request made to your server as a Bearer token in the headers.":
    "Il sera envoyé avec chaque requête vers votre serveur, comme jeton Bearer dans les en-têtes.",
  "Networking & Headers ({count})": "Réseau et en-têtes ({count})",
  "Meta Fields ({count})": "Champs méta ({count})",
  Failure: "Échec",
  "Failed to delete {name}": "Retrait de {name} impossible",
  "Successfully removed {name}": "{name} retiré",
  "Error synchronizing server": "Erreur de synchronisation du serveur",
  "{name} synchronized successfully.": "{name} synchronisé.",
  // Competences : liste, fiche, creation et edition (02/10).
  ", so they cannot view or use it. Add them to that space, remove that space restriction or remove them from editors:":
    ", et ne peut donc ni la voir ni l'utiliser. Ajoutez ce membre à ce dossier, retirez la restriction à ce dossier ou retirez-le des éditeurs :",
  ", so they cannot view or use it. Add them to those spaces, remove those spaces restriction or remove them from editors:":
    ", et ne peut donc ni la voir ni l'utiliser. Ajoutez ce membre à ces dossiers, retirez la restriction à ces dossiers ou retirez-le des éditeurs :",
  ".zip or .skill": ".zip ou .skill",
  "A repository URL is required": "L'adresse d'un dépôt est obligatoire",
  Accepted: "Acceptée",
  "Access Repository, shared connection": "Accès au dépôt, connexion partagée",
  "Add a description of when to use the skill":
    "Indiquez d'abord quand utiliser la compétence",
  "Add at least {count} characters to instructions":
    "Ajoutez au moins {count} caractères aux instructions",
  "Add files that will be available to the skill at runtime. Templates, schemas, scripts, or reference materials.":
    "Ajoutez des fichiers que la compétence pourra utiliser : modèles, schémas, scripts ou documents de référence.",
  "Add skill": "Ajouter la compétence",
  "Add to favorites": "Ajouter aux favoris",
  "Added to favorites": "Ajoutée aux favoris",
  "Adding spaces or pods will make the data from each of them available to the skill. Only members of all the spaces and pods listed will have access to the skill.":
    "Ajouter des dossiers ou des projets rend leurs données accessibles à la compétence. Seuls les membres de tous les dossiers et projets listés auront accès à la compétence.",
  "Admin has disabled self-improvement for this skill.":
    "Un administrateur a désactivé l'amélioration continue de cette compétence.",
  "Agents with Discover Skills can use it automatically":
    "Les assistants dotés de « Découvrir des compétences » peuvent l'utiliser d'eux-mêmes",
  "All active skills": "Toutes les compétences actives",
  "All availabilities": "Toutes les disponibilités",
  "All members can find it via the composer and agent builder":
    "Tous les membres la trouvent dans la barre de saisie et à la création d'un assistant",
  "All members can find it via the composer and agent builder.":
    "Tous les membres la trouvent dans la barre de saisie et à la création d'un assistant.",
  "All members can find it via the composer and agent builder. Agents with Discover Skills, including Dust, can use it automatically.":
    "Tous les membres la trouvent dans la barre de saisie et à la création d'un assistant. Les assistants dotés de « Découvrir des compétences » peuvent l'utiliser d'eux-mêmes.",
  "All members can find them via the composer and agent builder.":
    "Tous les membres les trouvent dans la barre de saisie et à la création d'un assistant.",
  "All members can find them via the composer and agent builder. Agents with Discover Skills, including Dust, can use them automatically.":
    "Tous les membres les trouvent dans la barre de saisie et à la création d'un assistant. Les assistants dotés de « Découvrir des compétences » peuvent les utiliser d'eux-mêmes.",
  "Already attached: {files}": "Déjà joints : {files}",
  "Among them:": "Parmi eux :",
  "An unexpected error occurred.": "Une erreur inattendue est survenue.",
  and: "et",
  "Any agent with Discover Skills, including Dust, can use it automatically. See other skills available to agents in":
    "Tout assistant doté de « Découvrir des compétences » peut l'utiliser de lui-même. Voir les autres compétences ouvertes aux assistants dans",
  "Archive the skill": "Archiver la compétence",
  "Archive the skills": "Archiver les compétences",
  "Archived skills": "Compétences archivées",
  "Archiving the skill": "Archivage de la compétence",
  "Archiving {count} skill": "Archivage de {count} compétence",
  "Archiving {count} skills": "Archivage de {count} compétences",
  "Available to all members and agents with Discover Skills":
    "Ouverte à tous les membres et aux assistants dotés de « Découvrir des compétences »",
  Back: "Retour",
  "Become an editor": "Devenir éditeur",
  becomes: "devient",
  "Becoming an editor...": "Ajout comme éditeur…",
  "by {name}": "par {name}",
  "can view and use this skill.": "peuvent voir et utiliser cette compétence.",
  "Cannot save skill": "Enregistrement impossible",
  "Check the URL or ask an admin to reconnect with an account that has access.":
    "Vérifiez l'adresse ou demandez à un administrateur de reconnecter un compte qui y a accès.",
  "Check the URL or reconnect with an account that has access.":
    "Vérifiez l'adresse ou reconnectez un compte qui y a accès.",
  "Check the URL. For private repos, ask an admin to connect a GitHub account with access.":
    "Vérifiez l'adresse. Pour un dépôt privé, demandez à un administrateur de connecter un compte GitHub qui y a accès.",
  "Checking for similar skills available to members and agents...":
    "Recherche de compétences proches ouvertes aux membres et aux assistants…",
  "Checking for similar skills...": "Recherche de compétences proches…",
  Commands: "Commandes",
  "Configuration validation failed": "Configuration invalide",
  "Connect a GitHub account to grant access. All workspace members will share this connection.":
    "Connectez un compte GitHub pour donner l'accès. Tous les membres partageront cette connexion.",
  "Connect GitHub": "Connecter GitHub",
  "Connect GitHub to import from private repositories":
    "Connectez GitHub pour importer depuis des dépôts privés",
  "Copied!": "Copié",
  "Could not load actions. Retry": "Actions indisponibles. Réessayer",
  "Could not load skills. Please try again.":
    "Impossible de charger les compétences. Réessayez.",
  "Could not load the skill details.":
    "Impossible de charger le détail de la compétence.",
  "Create a skill": "Créer une compétence",
  "Create new skill": "Nouvelle compétence",
  "Create skill": "Créer une compétence",
  Declined: "Refusée",
  "Description must be {max} characters or less":
    "La description doit faire au plus {max} caractères",
  "Description of when to use the skill is required":
    "Indiquez quand utiliser la compétence",
  "Detecting skills": "Détection des compétences",
  "Detecting skills...": "Détection des compétences…",
  "Detection failed": "Échec de la détection",
  "Discoverable Skills": "Compétences découvrables",
  "Drag and drop or click to upload":
    "Glissez-déposez ou cliquez pour téléverser",
  "Drop files here": "Déposez les fichiers ici",
  "Duplicate files skipped.": "Fichiers en double ignorés.",
  "Dust continuously analyses conversations using this skill to suggest improvements.":
    "La plateforme analyse en continu les conversations qui utilisent cette compétence pour proposer des améliorations.",
  "Dust will analyze how this skill is used and suggest improvements to its instructions over time.":
    "La plateforme analysera l'usage de cette compétence et proposera au fil du temps des améliorations de ses instructions.",
  "Edit skill": "Modifier la compétence",
  "Edit skill {name}": "Modifier la compétence {name}",
  "Editors only": "Éditeurs seulement",
  "Enable skill": "Activation de la compétence",
  "Enable skill “{name}”": "Activation de la compétence « {name} »",
  "Enabling skill": "Activation de la compétence en cours",
  "Enabling skill “{name}”": "Activation de la compétence « {name} » en cours",
  "Enter a GitHub repository URL to detect skills.":
    "Saisissez l'adresse d'un dépôt GitHub pour y détecter des compétences.",
  "Enter skill description": "Description de la compétence",
  "Enter skill name": "Nom de la compétence",
  "Error archiving skills": "Erreur lors de l'archivage des compétences",
  "Error creating skill": "Erreur lors de la création de la compétence",
  "Error restoring {name}": "Erreur lors de la restauration de {name}",
  "Error updating skill": "Erreur lors de la mise à jour de la compétence",
  "Error updating skills": "Erreur lors de la mise à jour des compétences",
  "Failed to create skill": "Création de la compétence impossible",
  "Failed to favorite {name}": "Impossible d'ajouter {name} aux favoris",
  "Failed to generate description": "Impossible de générer la description",
  "Failed to import skills.": "Import des compétences impossible.",
  "Failed to unfavorite {name}": "Impossible de retirer {name} des favoris",
  "Failed to update editors": "Mise à jour des éditeurs impossible",
  "Failed to update reinforcement settings":
    "Mise à jour de l'amélioration continue impossible",
  "Failed to update skill": "Mise à jour de la compétence impossible",
  "Failed to update skill editors":
    "Mise à jour des éditeurs de la compétence impossible",
  Favorites: "Favoris",
  "File requirements": "Format attendu",
  "for everyone.": "pour tout le monde.",
  "From existing": "À partir d'un existant",
  "Generate description": "Générer la description",
  "Generating description...": "Génération de la description…",
  "GitHub connection can't access this repository":
    "La connexion GitHub n'a pas accès à ce dépôt",
  Guidelines: "Consignes",
  History: "Historique",
  "HTTP {status}: Failed to get description suggestion":
    "HTTP {status} : impossible d'obtenir une proposition de description",
  Import: "Importer",
  "Import failed": "Échec de l'import",
  "Import skills": "Importer des compétences",
  "Import successful": "Import réussi",
  "Importing skills": "Import des compétences",
  Insert: "Insérer",
  "Invalid editors": "Éditeurs invalides",
  "Invalid skill format": "Format de compétence invalide",
  "is an editor of this skill but is not a member of":
    "est éditeur de cette compétence mais n'est pas membre de",
  "It is no longer active and cannot be used.":
    "Elle n'est plus active et ne peut plus être utilisée.",
  "Join all required spaces": "Rejoindre tous les dossiers nécessaires",
  "Join space {name}": "Rejoindre le dossier {name}",
  "Joined {name}": "{name} rejoint",
  "Keep editing": "Continuer à modifier",
  "Large skills consume a significant part of the context window on each use. Consider keeping your guidelines concise.":
    "Une compétence volumineuse occupe une bonne part de la mémoire de travail de l'assistant à chaque utilisation. Gardez des consignes concises.",
  "Last edited {date} by {name}": "Modifiée le {date} par {name}",
  "Last edited: {date}": "Dernière modification : {date}",
  "Loading skill details...": "Chargement du détail de la compétence…",
  "Loading skills": "Chargement des compétences",
  "Make {count} skill available to all members":
    "Ouvrir {count} compétence à tous les membres",
  "Make {count} skill editors only":
    "Réserver {count} compétence à ses éditeurs",
  "Make {count} skills available to all members":
    "Ouvrir {count} compétences à tous les membres",
  "Make {count} skills editors only":
    "Réserver {count} compétences à leurs éditeurs",
  "Manage Skills": "Compétences",
  "Members and agents": "Membres et assistants",
  "New Skill": "Nouvelle compétence",
  "No commands found": "Aucune commande trouvée",
  "No pending suggestions.": "Aucune suggestion en attente.",
  "No skill matches your search or filters.":
    "Aucune compétence ne correspond à votre recherche ou à vos filtres.",
  "No skills match your search.":
    "Aucune compétence ne correspond à votre recherche.",
  "No skills to show.": "Aucune compétence à afficher.",
  "Number of active users in the last 30 days.":
    "Nombre de membres actifs sur les 30 derniers jours.",
  "Number of times this skill was used in the last 30 days.":
    "Nombre d'utilisations de cette compétence sur les 30 derniers jours.",
  "Only editors can find it via the composer and agent builder":
    "Seuls ses éditeurs la trouvent dans la barre de saisie et à la création d'un assistant",
  "Only editors can find it via the composer and agent builder. The skill remains available through agents and skills that use it.":
    "Seuls ses éditeurs la trouvent dans la barre de saisie et à la création d'un assistant. La compétence reste disponible via les assistants et les compétences qui l'utilisent.",
  "Only editors can find them via the composer and agent builder. The skills remain available through agents and skills that use them.":
    "Seuls leurs éditeurs les trouvent dans la barre de saisie et à la création d'un assistant. Les compétences restent disponibles via les assistants et les compétences qui les utilisent.",
  "Only members of": "Seuls les membres de",
  "Only members of all the following can view and use this skill:":
    "Seuls les membres de tous les dossiers suivants peuvent voir et utiliser cette compétence :",
  "Only skill editors can save changes.":
    "Seuls les éditeurs de la compétence peuvent enregistrer des modifications.",
  "Only {extensions} files are accepted.":
    "Seuls les fichiers {extensions} sont acceptés.",
  Outdated: "Dépassée",
  "Override existing skill": "Remplacera la compétence existante",
  'Provide the guidelines the skill should follow when it runs. Type "/" to attach knowledge, tools, or another skill.':
    "Donnez les consignes que la compétence doit suivre. Tapez « / » pour joindre des connaissances, des outils ou une autre compétence.",
  "Read more about importing skills":
    "En savoir plus sur l'import de compétences",
  "Remove editor": "Retirer l'éditeur",
  "Remove from favorites": "Retirer des favoris",
  "Remove {name}": "Retirer {name}",
  "Remove {name}?": "Retirer {name} ?",
  Repository: "Dépôt",
  "Repository not found": "Dépôt introuvable",
  "Restore all fields from this version":
    "Restaurer tous les champs de cette version",
  "Restore description": "Restaurer la description",
  "Restore files": "Restaurer les fichiers",
  "Restore instructions": "Restaurer les instructions",
  "Restore the skill": "Restaurer la compétence",
  "Restoring the skill": "Restauration de la compétence",
  "Retry loading editors before saving changes.":
    "Rechargez les éditeurs avant d'enregistrer.",
  "Reusable packages of instructions and tools that agents can share.":
    "Des ensembles réutilisables d'instructions et d'outils que les assistants peuvent partager.",
  "Search knowledge and reference conversation or pod files":
    "Chercher dans les connaissances et citer des fichiers de la conversation ou du projet",
  "Search skills": "Rechercher des compétences",
  "Search for skills": "Rechercher des compétences",
  Provider: "Fournisseur",
  "Could not load agents. Please try again.":
    "Impossible de charger les assistants. Réessayez.",
  "No agents match your search.":
    "Aucun assistant ne correspond à votre recherche.",
  "No agents to show.": "Aucun assistant à afficher.",
  "Search for agents": "Rechercher des assistants",
  "Build and manage agents that work with your team's knowledge and tools.":
    "Créez et gérez les assistants qui travaillent avec les connaissances et les outils de votre équipe.",
  "Search skills by name": "Rechercher une compétence par son nom",
  "See less": "Voir moins",
  "See more": "Voir plus",
  "Select at least one skill to import":
    "Sélectionnez au moins une compétence à importer",
  "Self Improvement": "Amélioration continue",
  "Self-improve": "Amélioration continue",
  "Self-improving skills are disabled in your workspace. Ask your admin to enable this feature.":
    "L'amélioration continue des compétences est désactivée dans votre espace. Demandez à un administrateur de l'activer.",
  "Set availability": "Disponibilité",
  "Show hidden skills": "Afficher les compétences masquées",
  "Shows skills you can access as an admin, even if you’re not an editor":
    "Affiche les compétences accessibles en tant qu'administrateur, même si vous n'en êtes pas éditeur",
  "Similar skills already available to members and agents":
    "Compétences proches déjà ouvertes aux membres et aux assistants",
  "Similar skills found": "Compétences proches trouvées",
  "Skill avatar": "Icône de la compétence",
  "Skill created": "Compétence créée",
  "Skill created, but its editors were not saved":
    "Compétence créée, mais ses éditeurs n'ont pas été enregistrés",
  "Skill description is required":
    "La description de la compétence est obligatoire",
  "Skill instructions are required":
    "Les instructions de la compétence sont obligatoires",
  "Skill name": "Nom de la compétence",
  "Skill name already in use": "Nom de compétence déjà pris",
  "Skill name is required": "Le nom de la compétence est obligatoire",
  "Skill not available": "Compétence indisponible",
  "Skill not found": "Compétence introuvable",
  "Skill options": "Options de la compétence",
  "Skill settings": "Réglages de la compétence",
  "Skill updated": "Compétence mise à jour",
  "Skill updated, but its editors were not saved":
    "Compétence mise à jour, mais ses éditeurs n'ont pas été enregistrés",
  "Skill {name} created!": "Compétence {name} créée",
  "Skills updated": "Compétences mises à jour",
  "Skills you can edit": "Les compétences que vous pouvez modifier",
  "Skills you favorited": "Vos compétences favorites",
  "Some skill editors cannot access some of the restricted spaces":
    "Certains éditeurs de la compétence n'ont pas accès à certains dossiers restreints",
  "Spaces and Pods": "Dossiers et projets",
  "Start conversation": "Démarrer une conversation",
  "Successfully added and removed editors": "Éditeurs ajoutés et retirés",
  "Successfully added editor": "Éditeur ajouté",
  "Successfully added editors": "Éditeurs ajoutés",
  "Successfully archived skills": "Compétences archivées",
  "Successfully archived {name}": "{name} archivée",
  "Successfully removed editor": "Éditeur retiré",
  "Successfully removed editors": "Éditeurs retirés",
  "Successfully restored {name}": "{name} restaurée",
  "Successfully updated editors": "Éditeurs mis à jour",
  "Successfully updated {count} skill.": "{count} compétence mise à jour.",
  "Successfully updated {count} skills.": "{count} compétences mises à jour.",
  "Suggested skills": "Compétences suggérées",
  Suggestion: "Suggestion",
  Suggestions: "Suggestions",
  "Superseded by a later suggestion":
    "Remplacée par une suggestion plus récente",
  System: "Système",
  "System skills are always active, so message usage does not apply":
    "Les compétences système sont toujours actives : le compte d'utilisations ne s'applique pas",
  "Tell the agent when it should use this skill.":
    "Dites à l'assistant quand utiliser cette compétence.",
  "The currently connected GitHub account can't access this repository.":
    "Le compte GitHub connecté n'a pas accès à ce dépôt.",
  "The imported {extensions} archive must include a SKILL.md file":
    "L'archive {extensions} importée doit contenir un fichier SKILL.md",
  "The platform": "La plateforme",
  "The skill could not be loaded. Please try again.":
    "La compétence n'a pas pu être chargée. Réessayez.",
  "The skill remains available through agents and skills that use it":
    "La compétence reste disponible via les assistants et les compétences qui l'utilisent",
  "The skill uses restricted spaces you are not a member of: {spaces}.":
    "La compétence utilise des dossiers restreints dont vous n'êtes pas membre : {spaces}.",
  "These skills have been used {count} time.":
    "Ces compétences ont été utilisées {count} fois.",
  "These skills have been used {count} times.":
    "Ces compétences ont été utilisées {count} fois.",
  "They can all find it via the composer and agent builder":
    "Ils la trouvent tous dans la barre de saisie et à la création d'un assistant",
  "This affects your entire workspace": "Cela concerne tout votre espace",
  "This file must contain the skill name and description formatted in YAML":
    "Ce fichier doit donner le nom et la description de la compétence au format YAML",
  "This is a generated skill suggestion":
    "Cette compétence est une suggestion générée",
  "This referenced skill is unavailable because its visibility or permissions changed.":
    "Cette compétence n'est plus disponible : sa visibilité ou ses autorisations ont changé.",
  "This skill has been archived.": "Cette compétence a été archivée.",
  "This skill has been used {count} time.":
    "Cette compétence a été utilisée {count} fois.",
  "This skill has been used {count} times.":
    "Cette compétence a été utilisée {count} fois.",
  "This skill has workspace-wide effects":
    "Cette compétence concerne tout l'espace",
  "This skill is currently visible only to its editors. An editor can publish it or share it with you.":
    "Cette compétence n'est visible que de ses éditeurs. Un éditeur peut la publier ou la partager avec vous.",
  "This skill is noticeably large": "Cette compétence est volumineuse",
  "This skill may have been deleted, or the link may be incorrect.":
    "Cette compétence a peut-être été supprimée, ou le lien est incorrect.",
  "This skill was automatically generated based on your workspace's configuration. We recommend reviewing and editing it to match your specific needs before saving.":
    "Cette compétence a été générée automatiquement d'après la configuration de votre espace. Relisez-la et adaptez-la à vos besoins avant de l'enregistrer.",
  "This skill was originally imported from":
    "Cette compétence a été importée depuis",
  "This will archive the skill": "Cette action archivera la compétence",
  "This will archive these skills for everyone.":
    "Cette action archivera ces compétences pour tout le monde.",
  "This will archive this skill for everyone.":
    "Cette action archivera cette compétence pour tout le monde.",
  "This will restore the skill": "Cette action restaurera la compétence",
  "Try skill": "Essayer la compétence",
  "Unable to load skill": "Impossible de charger la compétence",
  "Unable to verify editor access":
    "Impossible de vérifier les droits d'édition",
  "Unexpected error creating skill: {message}":
    "Erreur inattendue à la création de la compétence : {message}",
  "Unexpected error updating skill: {message}":
    "Erreur inattendue à la mise à jour de la compétence : {message}",
  Unknown: "Inconnu",
  Update: "Mettre à jour",
  "Upload a .zip or .skill file with your skills.":
    "Téléversez un fichier .zip ou .skill contenant vos compétences.",
  "Upload {extensions} files": "Téléverser des fichiers {extensions}",
  "Uploading files...": "Téléversement des fichiers…",
  "Usage is not available for this skill.":
    "Utilisation non disponible pour cette compétence.",
  "Use company knowledge or reference files for context.":
    "Utiliser les connaissances de l'entreprise ou citer des fichiers comme contexte.",
  "used by {usages}.": "utilisée par {usages}.",
  "Verifying editor access": "Vérification des droits d'édition",
  "Version {version}": "Version {version}",
  "View skill": "Voir la compétence",
  "Wait until skill editors finish loading before saving.":
    "Attendez la fin du chargement des éditeurs avant d'enregistrer.",
  "We could not load the agent editors. Retry before making changes.":
    "Impossible de charger les éditeurs de l'assistant. Réessayez avant de faire des modifications.",
  "We could not load the skill editors. Retry before making changes.":
    "Impossible de charger les éditeurs de la compétence. Réessayez avant de faire des modifications.",
  "What does this skill do? How should it behave?":
    "Que fait cette compétence ? Comment doit-elle se comporter ?",
  "When should this skill be used? What is this skill good for?":
    "Quand utiliser cette compétence ? À quoi sert-elle ?",
  "When to use this skill": "Quand utiliser cette compétence",
  "Who is this skill available for?":
    "À qui cette compétence est-elle ouverte ?",
  you: "vous",
  "You are about to join these spaces. This action will be logged for security purposes. Do you want to proceed?":
    "Vous allez rejoindre ces dossiers. Cette action sera journalisée pour des raisons de sécurité. Continuer ?",
  "You are about to join this space. This action will be logged for security purposes. Do you want to proceed?":
    "Vous allez rejoindre ce dossier. Cette action sera journalisée pour des raisons de sécurité. Continuer ?",
  "You are not an editor of this agent":
    "Vous n'êtes pas éditeur de cet assistant",
  "You are not an editor of this skill":
    "Vous n'êtes pas éditeur de cette compétence",
  "You are now a member of {name}.": "Vous êtes désormais membre de {name}.",
  "You can now use {name}. Try it in a new conversation or keep editing this skill.":
    "Vous pouvez désormais utiliser {name}. Essayez-la dans une nouvelle conversation ou continuez à la modifier.",
  "You can view this agent as a workspace admin. Become an editor to save changes.":
    "Vous voyez cet assistant en tant qu'administrateur. Devenez éditeur pour enregistrer des modifications.",
  "You can view this skill as a workspace admin. Become an editor to save changes.":
    "Vous voyez cette compétence en tant qu'administrateur. Devenez éditeur pour enregistrer des modifications.",
  "You cannot see the guidelines of this skill.":
    "Vous ne pouvez pas voir les consignes de cette compétence.",
  "You don’t have permission to change the availability of an auto-discoverable skill":
    "Vous n'avez pas le droit de changer la disponibilité d'une compétence découvrable automatiquement",
  "You don’t have permission to change this skill’s availability":
    "Vous n'avez pas le droit de changer la disponibilité de cette compétence",
  "You don’t have permission to make skills auto-discoverable":
    "Vous n'avez pas le droit de rendre des compétences découvrables automatiquement",
  "You will not be able to add this skill back because it is only accessible to the skill editors and you are not an editor.":
    "Vous ne pourrez pas rajouter cette compétence : elle n'est accessible qu'à ses éditeurs et vous n'en faites pas partie.",
  "Your skill has been successfully created.": "Votre compétence a été créée.",
  "Your skill has been successfully updated.":
    "Votre compétence a été mise à jour.",
  "{count} editors": "{count} éditeurs",
  "{count} skill detected. Select the ones to import.":
    "{count} compétence détectée. Sélectionnez celles à importer.",
  "{count} skill imported": "{count} compétence importée",
  "{count} skill skipped": "{count} compétence ignorée",
  "{count} skill updated": "{count} compétence mise à jour",
  "{count} skill was successfully archived.": "{count} compétence archivée.",
  "{count} skills detected. Select the ones to import.":
    "{count} compétences détectées. Sélectionnez celles à importer.",
  "{count} skills imported": "{count} compétences importées",
  "{count} skills skipped": "{count} compétences ignorées",
  "{count} skills updated": "{count} compétences mises à jour",
  "{count} skills were successfully archived.":
    "{count} compétences archivées.",
  "{name} was successfully restored.": "{name} a été restaurée.",
  // Checkup des textes restants (03/10).
  "(no message)": "(aucun message)",
  "404: Page not found": "404 : page introuvable",
  "A Pod or space with this name already exists.":
    "Un projet ou un espace porte déjà ce nom.",
  "A direct message in Slack": "Un message direct dans Slack",
  About: "À propos",
  "About you": "À propos de vous",
  "Access your favorite and most-used agents, or search for one from the home page.":
    "Retrouvez vos assistants favoris et les plus utilisés, ou cherchez-en un depuis l'accueil.",
  "Action removed from space": "Outil retiré de l'espace",
  "Action removed from workspace": "Outil retiré de l'espace de travail",
  "Add Meta Field": "Ajouter un champ",
  "Add Source": "Ajouter une source",
  "Add a trigger": "Ajouter un déclencheur",
  "Add comma separated emails": "Adresses email séparées par des virgules",
  "Add individual email addresses. Domain sharing is not available.":
    "Ajoutez des adresses email une par une. Le partage par domaine n'est pas disponible.",
  "Add more": "Ajouter",
  "Add yourself as an editor before saving changes.":
    "Ajoutez-vous comme éditeur avant d'enregistrer.",
  "Added Tools": "Outils ajoutés",
  "Additional Spaces": "Espaces supplémentaires",
  "Adjust how Dust looks and behaves for you.": `Réglez l'apparence et le comportement de ${PRODUCT_NAME}.`,
  "Agent builder is not available":
    "La création d'assistant n'est pas disponible",
  "Agent created": "Assistant créé",
  "Agent created successfully": "Assistant créé",
  "Agent created with warnings": "Assistant créé avec des avertissements",
  "Agent created!": "Assistant créé",
  "Agent creation failed": "Échec de la création de l'assistant",
  "Agent saved": "Assistant enregistré",
  "Agent suggestion": "Suggestion pour l'assistant",
  "Agent waiting sound alert": "Alerte sonore d'un assistant en attente",
  "Agent's Spaces": "Espaces de l'assistant",
  "All agents": "Tous les assistants",
  "All conversations marked as read":
    "Toutes les conversations sont marquées comme lues",
  "All models are now available in this workspace.":
    "Tous les modèles sont maintenant disponibles dans cet espace de travail.",
  "All viewers": "Tous les lecteurs",
  "Allow agents to determine filters to apply based on conversation context.":
    "Laisser les assistants choisir les filtres selon le contexte de la conversation.",
  "Allow once": "Autoriser une fois",
  "Allowed labels": "Étiquettes autorisées",
  Alphabetical: "Par ordre alphabétique",
  "Already submitting": "Envoi déjà en cours",
  "Already subscribed": "Déjà participant",
  "An error occurred while creating the agent from YAML":
    "Une erreur s'est produite pendant la création de l'assistant depuis le YAML",
  "An error occurred while deleting the automation.":
    "Une erreur s'est produite pendant la suppression de l'automatisation.",
  "An error occurred while exporting":
    "Une erreur s'est produite pendant l'export",
  "An error occurred while exporting the content.":
    "Une erreur s'est produite pendant l'export du contenu.",
  "An error occurred while generating tag suggestions. Please contact us if the error persists.":
    "Une erreur s'est produite pendant la suggestion d'étiquettes. Contactez-nous si elle persiste.",
  "An error occurred while generating the schema. Please contact us if the error persists.":
    "Une erreur s'est produite pendant la génération du schéma. Contactez-nous si elle persiste.",
  "An unexpected error occurred while updating member roles.":
    "Une erreur inattendue s'est produite pendant le changement de rôle.",
  "An unexpected error occurred while updating providers.":
    "Une erreur inattendue s'est produite pendant la mise à jour des fournisseurs.",
  "An unknown error occurred": "Une erreur inconnue s'est produite",
  "An unknown error occurred.": "Une erreur inconnue s'est produite.",
  "Applies to in-app popups, email, and Slack":
    "S'applique aux fenêtres dans l'application, à l'email et à Slack",
  "Archive plan": "Archiver le plan",
  "Archive this plan?": "Archiver ce plan ?",
  "Are you sure you want to delete this memory ?":
    "Voulez-vous vraiment supprimer ce souvenir ?",
  "Are you sure you want to delete this message? This action cannot be undone.":
    "Voulez-vous vraiment supprimer ce message ? Cette action est irréversible.",
  "Are you sure you want to leave this conversation?":
    "Voulez-vous vraiment quitter cette conversation ?",
  Assignee: "Responsable",
  "Attach page content": "Joindre le contenu de la page",
  "Authorization required": "Autorisation requise",
  Auto: "Auto",
  "Auto-generate": "Générer automatiquement",
  "Auto-switched to Standard": "Passage automatique au modèle Standard",
  "Automatic archival disabled": "Archivage automatique désactivé",
  "Automatic archival enabled": "Archivage automatique activé",
  "Automation deleted": "Automatisation supprimée",
  "Available Tools": "Outils disponibles",
  "Back to homepage": "Retour à l'accueil",
  Bcc: "Cci",
  Beta: "Bêta",
  "Branch conversation": "Créer une branche de la conversation",
  "Branch from here": "Créer une branche à partir d'ici",
  "Browsing:": "Parcours :",
  "By popularity": "Par popularité",
  "Cancel wake-up": "Annuler le réveil",
  "Cannot compact conversation": "Impossible de compacter la conversation",
  "Cannot save agent": "Impossible d'enregistrer l'assistant",
  "Change instructions and settings":
    "Modifier les instructions et les réglages",
  "Checking for similar agents…": "Recherche d'assistants similaires…",
  "Choose a new plan to continue":
    "Choisissez une nouvelle offre pour continuer",
  "Choose how Dust looks on this device": `Choisissez l'apparence de ${PRODUCT_NAME} sur cet appareil`,
  "Choose the Pod that the agent can access. The agent will have access to Pod metadata and context from the selected Pod.":
    "Choisissez le projet auquel l'assistant a accès. Il aura accès aux informations et au contexte de ce projet.",
  "Choose where else to receive notifications":
    "Choisissez où recevoir aussi les notifications",
  "Choose which events will activate this trigger":
    "Choisissez les événements qui activent ce déclencheur",
  "Choose your model from the input bar":
    "Choisissez votre modèle depuis la barre de saisie",
  "Clear history": "Effacer l'historique",
  "Click for more info on this beta":
    "Cliquez pour en savoir plus sur cette bêta",
  "Close analytics": "Fermer l'analytique",
  "Code for this visualization": "Code de cette visualisation",
  "Code sent!": "Code envoyé",
  "Compact now": "Compacter maintenant",
  Compacting: "Compactage",
  "Compaction requires a completed agent message in the conversation.":
    "Le compactage demande au moins une réponse terminée de l'assistant dans la conversation.",
  "Configuration failed": "Échec de la configuration",
  "Configure Knowledge": "Configurer les connaissances",
  "Configure model providers": "Configurer les fournisseurs de modèles",
  "Confirm Deletion": "Confirmer la suppression",
  "Connect data sources or ask your admin to set them up":
    "Connectez des sources de données ou demandez à votre administrateur de les configurer",
  "Connection lost while generating message. Reconnect to check its progress.":
    "Connexion perdue pendant la rédaction du message. Reconnectez-vous pour suivre sa progression.",
  "Content Type:": "Type de contenu :",
  "Content exceeds the character limit":
    "Le contenu dépasse la limite de caractères",
  "Content of the document:": "Contenu du document :",
  "Content too long": "Contenu trop long",
  "Context compaction failed": "Échec du compactage du contexte",
  "Context limit reached": "Limite de contexte atteinte",
  "Control how and when Dust notifies you": `Choisissez comment et quand ${PRODUCT_NAME} vous prévient`,
  Conversation: "Conversation",
  "Conversation Not Found": "Conversation introuvable",
  "Conversation context is almost full":
    "Le contexte de la conversation est presque plein",
  "Conversation file": "Fichier de la conversation",
  "Conversation font": "Police des conversations",
  "Conversation moved.": "Conversation déplacée.",
  "Conversation removed.": "Conversation retirée.",
  "Conversations options": "Options des conversations",
  "Conversations successfully deleted": "Conversations supprimées",
  "Conversations successfully moved": "Conversations déplacées",
  "Conversations with this agent will not pause to ask for confirmation when they cross the workspace's credit spend checkpoint.":
    "Les conversations avec cet assistant ne s'arrêteront pas pour demander confirmation au passage du seuil de crédits de l'espace de travail.",
  "Convert to agent": "Transformer en assistant",
  "Copy message link": "Copier le lien du message",
  "Copy to clipboard": "Copier",
  "Could not delete conversation history.":
    "Impossible de supprimer l'historique des conversations.",
  "Could not dismiss the email tip": "Impossible de masquer l'astuce email",
  "Could not get tag suggestions.":
    "Impossible d'obtenir des suggestions d'étiquettes.",
  "Could not load access rules.": "Impossible de charger les règles d'accès.",
  "Could not load sharing settings.":
    "Impossible de charger les réglages de partage.",
  "Could not load skills. Try again.":
    "Impossible de charger les compétences. Réessayez.",
  "Could not load this task.": "Impossible de charger cette tâche.",
  "Could not load viewers.": "Impossible de charger les lecteurs.",
  "Could not save the conversation font":
    "Impossible d'enregistrer la police des conversations",
  "Could not select Spaces": "Impossible de choisir les espaces",
  "Could not start recording.": "Impossible de démarrer l'enregistrement.",
  "Could not update the Frame sharing policy.":
    "Impossible de mettre à jour la règle de partage des tableaux de bord.",
  "Could not update the Slack footer removal setting.":
    "Impossible de mettre à jour le réglage du pied de message Slack.",
  "Could not update the Voice transcription setting.":
    "Impossible de mettre à jour le réglage de transcription vocale.",
  "Could not update the Workspace Analyst setting.":
    "Impossible de mettre à jour le réglage d'analyse de l'espace de travail.",
  "Could not update the browser extension MCP tools setting.":
    "Impossible de mettre à jour le réglage des outils MCP de l'extension du navigateur.",
  "Could not update the published agents model access setting.":
    "Impossible de mettre à jour l'accès aux modèles des assistants publiés.",
  "Couldn't check for similar agents.":
    "Impossible de chercher des assistants similaires.",
  "Create DataSource": "Créer une source de données",
  "Create a Pod": "Créer un projet",
  "Create a new Pod": "Créer un projet",
  "Create an Agent": "Créer un assistant",
  "Create agent": "Créer un assistant",
  "Create one or ask your admin to install apps from other spaces.":
    "Créez-en une ou demandez à votre administrateur d'installer des applications d'autres espaces.",
  Created: "Créée",
  "Creating...": "Création…",
  "Credit usage is temporarily unavailable.":
    "La consommation de crédits est momentanément indisponible.",
  "Current execution": "Exécution en cours",
  "Custom Webhook": "Webhook personnalisé",
  Customization: "Personnalisation",
  Dark: "Sombre",
  "Database Schema": "Schéma de la base",
  "Delete automation": "Supprimer l'automatisation",
  "Delete message": "Supprimer le message",
  "Delete task?": "Supprimer la tâche ?",
  "Delete trigger": "Supprimer le déclencheur",
  "Delete user message": "Supprimer le message de l'utilisateur",
  "Delete your message": "Supprimer votre message",
  'Describe the conditions (e.g "Pull requests by John on dust repository")':
    "Décrivez les conditions (ex. « Pull requests de Jean sur le dépôt principal »)",
  "Describe what went wrong": "Décrivez ce qui n'allait pas",
  "Description (optional)": "Description (facultative)",
  "Deselecting partial selection unavailable.":
    "Impossible de désélectionner une sélection partielle.",
  Details: "Détails",
  "Disabled by a manager or admin, who can re-enable it.":
    "Désactivée par un responsable ou un administrateur, qui peut la réactiver.",
  "Disabled following a plan downgrade.":
    "Désactivée après un changement d'offre.",
  "Disabled while the workspace is being relocated.":
    "Désactivée pendant le déménagement de l'espace de travail.",
  Discard: "Abandonner",
  "Discard changes": "Abandonner les modifications",
  "Discard selection": "Abandonner la sélection",
  "Discard your unsaved changes?":
    "Abandonner vos modifications non enregistrées ?",
  Dismiss: "Fermer",
  "Dismiss email tip for all agents":
    "Masquer l'astuce email pour tous les assistants",
  "Do you want to proceed?": "Voulez-vous continuer ?",
  "Do you want to unselect all selected items?":
    "Voulez-vous désélectionner tous les éléments ?",
  "Document has been updated": "Le document a été mis à jour",
  "Document processing": "Document en cours de traitement",
  "Document updated": "Document mis à jour",
  Droids: "Droïdes",
  "Dust Application": "Application",
  "Dust builds a personal memory from your conversations and uses it to tailor future responses.": `${PRODUCT_NAME} construit une mémoire personnelle à partir de vos conversations pour adapter ses réponses.`,
  "Dust had to trim part of the tool output used to generate this message to fit the model's context window. This usually happens when a search or other tool returns more data than the model can process at once.":
    "Une partie du résultat des outils a dû être coupée pour tenir dans la fenêtre de contexte du modèle. Cela arrive quand une recherche ou un autre outil renvoie plus de données que le modèle ne peut en traiter d'un coup.",
  "Dust works at full potential when it can play with your knowledge and help with your tools. Do you recognise some of these?": `${PRODUCT_NAME} donne le meilleur de lui-même quand il accède à vos connaissances et à vos outils. Lesquels utilisez-vous ?`,
  "Edit conversation title": "Renommer la conversation",
  "Edit history": "Modifier l'historique",
  "Edit invitation": "Modifier l'invitation",
  "Edit message": "Modifier le message",
  Editor: "Éditeur",
  "Editors who will see this:": "Éditeurs qui verront ce retour :",
  Email: "Email",
  "Email addresses": "Adresses email",
  "Email addresses, comma separated":
    "Adresses email, séparées par des virgules",
  "Email and Slack notifications are turned off for this workspace by an admin.":
    "Les notifications par email et Slack sont désactivées pour cet espace de travail par un administrateur.",
  "Email frequency": "Fréquence des emails",
  "Email when Dust has a new recommendation for you": `Email quand ${PRODUCT_NAME} a une nouvelle recommandation pour vous`,
  Emojis: "Emojis",
  "Empty response while streaming transcription.":
    "Réponse vide pendant la transcription.",
  "Enable Memory": "Activer la mémoire",
  "Enable notifications": "Activer les notifications",
  "Enter (↵)": "Entrée (↵)",
  "Enter a filter that will be used to filter the webhook payload JSON. Will always trigger if left empty.":
    "Saisissez un filtre appliqué au contenu JSON du webhook. Vide, le déclencheur s'exécute toujours.",
  "Enter new title...": "Nouveau titre…",
  "Enter verification code": "Saisissez le code de vérification",
  "Error !": "Erreur",
  "Error Loading Conversation": "Erreur de chargement de la conversation",
  "Error Updating User": "Erreur de mise à jour du profil",
  "Error archiving inactive agents":
    "Erreur pendant l'archivage des assistants inactifs",
  "Error creating Folder": "Erreur de création du dossier",
  "Error creating agent": "Erreur de création de l'assistant",
  "Error creating space": "Erreur de création de l'espace",
  "Error creating table": "Erreur de création du tableau",
  "Error deleting conversation.":
    "Erreur pendant la suppression de la conversation.",
  "Error dismissing mention": "Erreur pendant le rejet de la mention",
  "Error loading agents": "Erreur de chargement des assistants",
  "Error loading conversations": "Erreur de chargement des conversations",
  "Error loading file metadata":
    "Erreur de chargement des informations du fichier",
  "Error loading the Frame source.":
    "Erreur de chargement de la source du tableau de bord.",
  "Error loading the previous agent versions.":
    "Erreur de chargement des versions précédentes de l'assistant.",
  "Error marking conversation as unread.":
    "Erreur pendant le marquage comme non lue.",
  "Error moving conversation.":
    "Erreur pendant le déplacement de la conversation.",
  "Error previewing inactive agents":
    "Erreur pendant l'aperçu des assistants inactifs",
  "Error removing conversation from Pod.":
    "Erreur pendant le retrait de la conversation du projet.",
  "Error saving Draft Agent":
    "Erreur d'enregistrement du brouillon d'assistant",
  "Error saving memory": "Erreur d'enregistrement du souvenir",
  "Error searching results.": "Erreur pendant la recherche.",
  "Error updating Folder": "Erreur de mise à jour du dossier",
  "Error updating agent": "Erreur de mise à jour de l'assistant",
  "Error updating agent list.":
    "Erreur de mise à jour de la liste des assistants.",
  "Error updating automatic archival":
    "Erreur de mise à jour de l'archivage automatique",
  "Error updating model": "Erreur de changement de modèle",
  "Error updating notification preferences":
    "Erreur de mise à jour des préférences de notification",
  "Error updating server": "Erreur de mise à jour du serveur",
  "Error updating sound notification preferences":
    "Erreur de mise à jour des préférences sonores",
  "Error updating space": "Erreur de mise à jour de l'espace",
  "Events to watch": "Événements à surveiller",
  Expired: "Expirée",
  "Explore different ways to use Dust. Find a setup that works for you and make it your own.": `Découvrez différentes façons d'utiliser ${PRODUCT_NAME}. Trouvez une configuration qui vous convient et adaptez-la.`,
  "Export Failed": "Échec de l'export",
  "Export failed": "Échec de l'export",
  "Export successful": "Export réussi",
  "Export to YAML": "Exporter en YAML",
  "Exporting…": "Export…",
  "Expression too deeply nested (depth > 4)":
    "Expression trop imbriquée (profondeur > 4)",
  "External event that will trigger a run of this agent.":
    "Événement externe qui déclenche une exécution de cet assistant.",
  Failed: "Échec",
  "Failed to add access.": "Impossible d'ajouter l'accès.",
  "Failed to add member to group": "Impossible d'ajouter le membre au groupe",
  "Failed to archive plan": "Impossible d'archiver le plan",
  "Failed to attach file": "Impossible de joindre le fichier",
  "Failed to attach pasted text": "Impossible de joindre le texte collé",
  "Failed to branch conversation":
    "Impossible de créer une branche de la conversation",
  "Failed to cancel message": "Impossible d'annuler le message",
  "Failed to cancel wake-up": "Impossible d'annuler le réveil",
  "Failed to compact conversation": "Impossible de compacter la conversation",
  "Failed to create document": "Impossible de créer le document",
  "Failed to create group": "Impossible de créer le groupe",
  "Failed to create webhook source": "Impossible de créer la source webhook",
  "Failed to delete automation": "Impossible de supprimer l'automatisation",
  "Failed to delete conversations": "Impossible de supprimer les conversations",
  "Failed to delete file": "Impossible de supprimer le fichier",
  "Failed to delete group": "Impossible de supprimer le groupe",
  "Failed to delete memory": "Impossible de supprimer le souvenir",
  "Failed to delete webhook source":
    "Impossible de supprimer la source webhook",
  "Failed to edit message": "Impossible de modifier le message",
  "Failed to edit title": "Impossible de renommer la conversation",
  "Failed to generate name suggestions": "Impossible de suggérer des noms",
  "Failed to generate schema.": "Impossible de générer le schéma.",
  "Failed to inline text": "Impossible d'insérer le texte",
  "Failed to load data sources": "Impossible de charger les sources de données",
  "Failed to load file": "Impossible de charger le fichier",
  "Failed to load spaces": "Impossible de charger les espaces",
  "Failed to load your automations.":
    "Impossible de charger vos automatisations.",
  "Failed to load your wake-ups.": "Impossible de charger vos réveils.",
  "Failed to mark conversations as read":
    "Impossible de marquer les conversations comme lues",
  "Failed to move conversations": "Impossible de déplacer les conversations",
  "Failed to open Frame": "Impossible d'ouvrir le tableau de bord",
  "Failed to prepare seat change":
    "Impossible de préparer le changement de siège",
  "Failed to remove action": "Impossible de retirer l'outil",
  "Failed to remove member from group":
    "Impossible de retirer le membre du groupe",
  "Failed to rename": "Impossible de renommer",
  "Failed to resend code. Please try again.":
    "Impossible de renvoyer le code. Réessayez.",
  "Failed to retrieve Slack channels. Please check your Slack integration.":
    "Impossible de récupérer les canaux Slack. Vérifiez votre intégration Slack.",
  "Failed to revoke access.": "Impossible de retirer l'accès.",
  "Failed to save to Pod": "Impossible d'enregistrer dans le projet",
  "Failed to send audio for transcription.":
    "Impossible d'envoyer l'audio pour la transcription.",
  "Failed to send follow-up message":
    "Impossible d'envoyer le message de suivi",
  "Failed to subscribe to the conversation.":
    "Impossible de rejoindre la conversation.",
  "Failed to transcribe voice": "Impossible de transcrire la voix",
  "Failed to update Dust MCP server settings":
    "Impossible de mettre à jour les réglages du serveur MCP",
  "Failed to update Email agents setting":
    "Impossible de mettre à jour le réglage des assistants par email",
  "Failed to update Frame sharing setting":
    "Impossible de mettre à jour le réglage de partage des tableaux de bord",
  "Failed to update PDF sync setting":
    "Impossible de mettre à jour la synchronisation des PDF",
  "Failed to update Pod knowledge policy":
    "Impossible de mettre à jour la règle des connaissances des projets",
  "Failed to update Pod visibility policy":
    "Impossible de mettre à jour la visibilité des projets",
  "Failed to update Slack footer removal setting":
    "Impossible de mettre à jour le réglage du pied de message Slack",
  "Failed to update Spaces": "Impossible de mettre à jour les espaces",
  "Failed to update URL access": "Impossible de modifier l'accès par lien",
  "Failed to update Voice transcription setting":
    "Impossible de mettre à jour le réglage de transcription vocale",
  "Failed to update Workspace Analyst setting":
    "Impossible de mettre à jour le réglage d'analyse de l'espace de travail",
  "Failed to update audit logs setting":
    "Impossible de mettre à jour le réglage du journal d'audit",
  "Failed to update conversation email and Slack notifications":
    "Impossible de mettre à jour les notifications email et Slack des conversations",
  "Failed to update document": "Impossible de mettre à jour le document",
  "Failed to update extension MCP tools setting":
    "Impossible de mettre à jour le réglage des outils MCP de l'extension",
  "Failed to update frame sharing":
    "Impossible de mettre à jour le partage du tableau de bord",
  "Failed to update group": "Impossible de mettre à jour le groupe",
  "Failed to update group role": "Impossible de changer le rôle du groupe",
  "Failed to update group seat": "Impossible de changer le siège du groupe",
  "Failed to update group spend limit":
    "Impossible de mettre à jour la limite de dépense du groupe",
  "Failed to update labels setting":
    "Impossible de mettre à jour le réglage des étiquettes",
  "Failed to update private conversation URLs setting":
    "Impossible de mettre à jour le réglage des liens privés de conversation",
  "Failed to update published agents setting":
    "Impossible de mettre à jour le réglage des assistants publiés",
  "Failed to update seat": "Impossible de mettre à jour le siège",
  "Failed to update seats": "Impossible de mettre à jour les sièges",
  "Failed to update sensitivity labels setting":
    "Impossible de mettre à jour le réglage des étiquettes de confidentialité",
  "Failed to update skill suggestion":
    "Impossible de mettre à jour la suggestion de compétence",
  "Failed to update spend limit":
    "Impossible de mettre à jour la limite de dépense",
  "Failed to update suggestion": "Impossible de mettre à jour la suggestion",
  "Failed to update the trigger pool":
    "Impossible de changer la réserve de crédits du déclencheur",
  "Failed to update the workspace default agent":
    "Impossible de changer l'assistant par défaut",
  "Failed to upload the file.": "Impossible d'envoyer le fichier.",
  "Feedback sent": "Retour envoyé",
  "Fetching additional data for configuration...":
    "Récupération des données de configuration…",
  "File authorization is not available in the extension. Please open this conversation in the web app to authorize the file.":
    "L'autorisation de fichier n'est pas disponible dans l'extension. Ouvrez cette conversation dans l'application web pour autoriser le fichier.",
  "File authorized": "Fichier autorisé",
  "File deleted": "Fichier supprimé",
  "File not found": "Fichier introuvable",
  "File processing": "Fichier en cours de traitement",
  "File too large.": "Fichier trop volumineux.",
  "File:": "Fichier :",
  "Files and data available to people you share this frame with.":
    "Fichiers et données accessibles aux personnes avec qui vous partagez ce tableau de bord.",
  "Files and data used by this frame are shared too":
    "Les fichiers et données utilisés par ce tableau de bord sont aussi partagés",
  "Filter Expression (optional)": "Expression de filtre (facultative)",
  "Filter to only include content bearing must-have labels, and exclude content with must-not-have labels.":
    "Filtrer pour ne garder que le contenu portant les étiquettes obligatoires et exclure celui qui porte les étiquettes exclues.",
  "First Name": "Prénom",
  "First name": "Prénom",
  "Folder was successfully created.": "Le dossier a été créé.",
  "Folder was successfully updated.": "Le dossier a été mis à jour.",
  "Font used for agent answers in conversations":
    "Police utilisée pour les réponses des assistants",
  "For you": "Pour vous",
  "Former member": "Ancien membre",
  From: "De",
  "Full name": "Nom complet",
  "GPT, Claude, Gemini and more are now available in the model picker. Choose one to use with any agent.":
    "GPT, Claude, Gemini et d'autres sont maintenant dans le sélecteur de modèle. Choisissez-en un pour n'importe quel assistant.",
  "Generated Files": "Fichiers générés",
  "Generating filter...": "Génération du filtre…",
  "Generating name...": "Génération du nom…",
  "Generation stopped.": "Rédaction arrêtée.",
  "Get name suggestions": "Suggérer des noms",
  "Get notified in your browser when messages arrive.":
    "Soyez prévenu dans votre navigateur à l'arrivée des messages.",
  "Give the agent access to additional Spaces":
    "Donner à l'assistant l'accès à d'autres espaces",
  "Go to Pod": "Aller au projet",
  "Go to conversation": "Aller à la conversation",
  "Group created": "Groupe créé",
  "Group deleted": "Groupe supprimé",
  "Group role updated": "Rôle du groupe mis à jour",
  "Group seat updated": "Siège du groupe mis à jour",
  "Group spend limit status unknown":
    "État de la limite de dépense du groupe inconnu",
  "Group spend limit updated": "Limite de dépense du groupe mise à jour",
  "Group updated": "Groupe mis à jour",
  Handoff: "Passage de relais",
  "Help your team understand when to use this trigger.":
    "Aidez votre équipe à comprendre quand utiliser ce déclencheur.",
  "Hide triggered": "Masquer les conversations déclenchées",
  "How often to send email notification summaries":
    "Fréquence des résumés de notifications par email",
  "How to Use This Webhook": "Utiliser ce webhook",
  "How you appear to other members of the workspace":
    "Ce que voient les autres membres de l'espace de travail",
  "I found this helpful": "Cette réponse m'a aidé",
  ID: "Identifiant",
  "If eligible": "Si éligible",
  "If you have access to this page, sign in to open it.":
    "Si vous avez accès à cette page, connectez-vous pour l'ouvrir.",
  "If you leave now, your latest edits won't be kept.":
    "Si vous quittez maintenant, vos dernières modifications seront perdues.",
  "If your email was invited to this frame, we’ll send you a one-time code.":
    "Si votre adresse a été invitée sur ce tableau de bord, vous recevrez un code à usage unique.",
  "Ignore credit spend threshold alert": "Ignorer l'alerte de seuil de crédits",
  "Image generation": "Génération d'images",
  "In-Conversation filtering": "Filtrage selon la conversation",
  "In-app popup": "Fenêtre dans l'application",
  "Inactive agents archived": "Assistants inactifs archivés",
  "Inbox notifications": "Notifications des non lues",
  "Included file list": "Liste des fichiers inclus",
  "Included files": "Fichiers inclus",
  Inputs: "Entrées",
  "Instructions are required.": "Les instructions sont obligatoires.",
  "Instructions required": "Instructions requises",
  "Invalid file type": "Type de fichier invalide",
  "Invalid form data": "Formulaire invalide",
  Invitations: "Invitations",
  "Invitations are sent to email addresses only. People at an added domain can open the link after verifying their email.":
    "Les invitations ne sont envoyées qu'aux adresses email. Les personnes d'un domaine ajouté peuvent ouvrir le lien après avoir vérifié leur adresse.",
  Invite: "Inviter",
  "Invite members": "Inviter des membres",
  "Invite new users": "Inviter de nouveaux utilisateurs",
  "It applies on this device, but could not be saved to your account.":
    "Elle s'applique sur cet appareil mais n'a pas pu être enregistrée sur votre compte.",
  Key: "Clé",
  "Keyboard shortcut to send a message":
    "Raccourci clavier pour envoyer un message",
  "Labels could not be retrieved. You must reconnect your Microsoft connection to grant the necessary permissions.":
    "Impossible de récupérer les étiquettes. Reconnectez votre compte Microsoft pour accorder les autorisations nécessaires.",
  Landscape: "Paysage",
  "Last Name": "Nom",
  "Last name": "Nom",
  Later: "Plus tard",
  "Leave conversation": "Quitter la conversation",
  "Let's check a few things.": "Vérifions quelques points.",
  Light: "Clair",
  "Loading access rules": "Chargement des règles d'accès",
  "Loading frame...": "Chargement du tableau de bord…",
  "Loading recent requests...": "Chargement des requêtes récentes…",
  "Loading suggestion": "Chargement de la suggestion",
  "Loading the frame...": "Chargement du tableau de bord…",
  "Loading users...": "Chargement des utilisateurs…",
  "Loading viewers…": "Chargement des lecteurs…",
  "Looks like this page took an unscheduled coffee break.":
    "Cette page semble avoir pris une pause café imprévue.",
  "Make URL accessible": "Rendre le lien accessible",
  "Manage agents": "Gérer les assistants",
  "Manage skills": "Gérer les compétences",
  "Managed by your identity provider": "Gérée par votre fournisseur d'identité",
  "Mark as read": "Marquer comme lue",
  "Markdown source": "Source Markdown",
  "Member added to group": "Membre ajouté au groupe",
  "Member removed from group": "Membre retiré du groupe",
  "Memory deleted": "Souvenir supprimé",
  "Memory saved.": "Souvenir enregistré.",
  "Message deleted": "Message supprimé",
  "Message edited": "Message modifié",
  "Message has been deleted successfully.": "Le message a été supprimé.",
  "Message has been edited successfully.": "Le message a été modifié.",
  "Message link copied to clipboard": "Lien du message copié",
  "Message not sent": "Message non envoyé",
  "Message was deleted": "Message supprimé",
  "Microphone permission required.": "Autorisation du micro requise.",
  "Migration required": "Migration requise",
  "Model updated": "Modèle mis à jour",
  "Model was overridden for this message using the model picker.":
    "Le modèle de ce message a été changé avec le sélecteur de modèle.",
  Models: "Modèles",
  "More agents available. Type to filter.":
    "D'autres assistants existent. Tapez pour filtrer.",
  "More pods available. Type to filter.":
    "D'autres projets existent. Tapez pour filtrer.",
  "More reactions": "Plus de réactions",
  "More skills available. Type to filter.":
    "D'autres compétences existent. Tapez pour filtrer.",
  Move: "Déplacer",
  "Move conversation to Pod": "Déplacer la conversation vers un projet",
  "Move conversations to Pod": "Déplacer les conversations vers un projet",
  "Move to Pod": "Déplacer vers un projet",
  "Move to...": "Déplacer vers…",
  "Must-have": "Obligatoire",
  "Must-not-have": "Exclu",
  "My credits": "Mes crédits",
  "Name...": "Nom…",
  Navigate: "Naviguer",
  "Needs work": "À améliorer",
  "New Pod": "Nouveau projet",
  "New notification": "Nouvelle notification",
  "New skill": "Nouvelle compétence",
  "Next bill will be adjusted proportionally based on the members' sign-up date.":
    "La prochaine facture sera ajustée au prorata de la date d'inscription des membres.",
  "No Dust Apps available for this space":
    "Aucune application disponible pour cet espace",
  "No Pods are available in your workspace. Create a Pod first to use this feature.":
    "Aucun projet dans votre espace de travail. Créez d'abord un projet pour utiliser cette fonction.",
  "No Pods found": "Aucun projet trouvé",
  "No Spaces available": "Aucun espace disponible",
  "No active plan for this conversation.":
    "Aucun plan actif pour cette conversation.",
  "No agent will be archived automatically.":
    "Aucun assistant ne sera archivé automatiquement.",
  "No agents available": "Aucun assistant disponible",
  "No changes to save": "Aucune modification à enregistrer",
  "No data": "Aucune donnée",
  "No data sources available": "Aucune source de données disponible",
  "No data to preview.": "Aucune donnée à afficher.",
  "No data was extracted.": "Aucune donnée extraite.",
  "No datasources found": "Aucune source de données trouvée",
  "No description suggestions available": "Aucune suggestion de description",
  "No emoji found": "Aucun emoji trouvé",
  "No feedback data available.": "Aucun retour disponible.",
  "No feedback yet.": "Aucun retour pour l'instant.",
  "No invitations match your search":
    "Aucune invitation ne correspond à votre recherche",
  "No linked file was found for this Frame.":
    "Aucun fichier lié à ce tableau de bord.",
  "No matching Spaces": "Aucun espace ne correspond",
  "No matching blocks": "Aucun bloc ne correspond",
  "No members found": "Aucun membre trouvé",
  "No memories yet.": "Aucun souvenir pour l'instant.",
  "No models found": "Aucun modèle trouvé",
  "No payload available.": "Aucun contenu disponible.",
  "No pending invitations": "Aucune invitation en attente",
  "No pending invitations found.": "Aucune invitation en attente.",
  "No previous version": "Aucune version précédente",
  "No provider is configured in your workspace. Contact your administrator.":
    "Aucun fournisseur n'est configuré dans votre espace de travail. Contactez votre administrateur.",
  "No results found.": "Aucun résultat.",
  "No secrets found. Create a secret in your workspace settings first.":
    "Aucun secret trouvé. Créez d'abord un secret dans les réglages de l'espace de travail.",
  "No suggestions available": "Aucune suggestion disponible",
  "No tag suggestions available": "Aucune suggestion d'étiquette",
  "No tools are currently available for this server.":
    "Aucun outil n'est disponible pour ce serveur pour l'instant.",
  "No transcript available.": "Aucune transcription disponible.",
  "No trigger source matches your search":
    "Aucune source de déclencheur ne correspond à votre recherche",
  "No ready-made trigger source available":
    "Aucune source de déclencheur prête à l'emploi",
  "Use a custom webhook to connect another tool.":
    "Utilisez un webhook personnalisé pour relier un autre outil.",
  "No triggers found matching your search":
    "Aucun déclencheur ne correspond à votre recherche",
  "No viewers match your search.":
    "Aucun lecteur ne correspond à votre recherche.",
  "No views recorded yet.": "Aucune consultation pour l'instant.",
  "None of your conversations has a scheduled wake-up. Agents schedule wake-ups to pick a conversation back up on their own.":
    "Aucune de vos conversations n'a de réveil programmé. Les assistants programment des réveils pour reprendre d'eux-mêmes une conversation.",
  "Not Matched": "Non concerné",
  Note: "Note",
  "Note: You will be able to see and copy this secret for the first 10 minutes after creating the webhook.":
    "Note : vous pourrez voir et copier ce secret pendant les 10 minutes qui suivent la création du webhook.",
  "Nothing to display.": "Rien à afficher.",
  "Notification preferences saved": "Préférences de notification enregistrées",
  "Notification sound": "Son de notification",
  Notifications: "Notifications",
  "Notify me about": "Me prévenir pour",
  "One provider required": "Un fournisseur requis",
  "Only administrators can enable default agents for specific Slack channels.":
    "Seuls les administrateurs peuvent activer des assistants par défaut sur des canaux Slack.",
  "Only labeled content matching one of these labels will be synced. Unlabeled content is always included.":
    "Seul le contenu étiqueté avec l'une de ces étiquettes sera synchronisé. Le contenu sans étiquette est toujours inclus.",
  "Only regional models are now available in this workspace.":
    "Seuls les modèles régionaux sont maintenant disponibles dans cet espace de travail.",
  "Only respond to new channel messages, not replies within threads":
    "Ne répondre qu'aux nouveaux messages du canal, pas aux réponses dans les fils",
  "Only workspace member email addresses can be added.":
    "Seules les adresses des membres de l'espace de travail peuvent être ajoutées.",
  "Only workspace members can be added":
    "Seuls les membres de l'espace de travail peuvent être ajoutés",
  Open: "Ouvert",
  "Open File Picker": "Choisir le fichier",
  "Open a new conversation": "Ouvrir une nouvelle conversation",
  "Open in Web App": "Ouvrir dans l'application web",
  "Open in a new tab": "Ouvrir dans un nouvel onglet",
  "Open user menu": "Ouvrir le menu utilisateur",
  "Optionally, provide a schema for the data to be extracted. If you do not specify a schema, the tool will determine the schema based on the conversation context.":
    "Vous pouvez fournir un schéma pour les données à extraire. Sans schéma, l'outil le détermine d'après le contexte de la conversation.",
  "Other channels": "Autres canaux",
  "Otherwise, this is unexpected. Please contact support@dust.tt for assistance on synchronizing the document.":
    "Sinon, ce n'est pas normal. Contactez votre administrateur pour vérifier la synchronisation du document.",
  "Out Of Credits": "Crédits épuisés",
  Output: "Sortie",
  "Override the model used": "Changer le modèle utilisé",
  "PDF Export Failed": "Échec de l'export PDF",
  "PDF exported": "PDF exporté",
  "PDF preview is not available for this document.":
    "L'aperçu PDF n'est pas disponible pour ce document.",
  "PDF sync setting updated successfully":
    "Synchronisation des PDF mise à jour",
  "PDF syncing has been disabled.":
    "La synchronisation des PDF est désactivée.",
  "PDF syncing is now enabled.": "La synchronisation des PDF est activée.",
  Pagination: "Pagination",
  "Pending suggestions": "Suggestions en attente",
  "People who can view this frame can also access the files and data it uses. They can’t access the rest of the conversation or pod.":
    "Les personnes qui voient ce tableau de bord accèdent aussi aux fichiers et données qu'il utilise, mais pas au reste de la conversation ni du projet.",
  "People with access": "Personnes ayant accès",
  "Personal Information": "Informations personnelles",
  "Personal Settings": "Réglages personnels",
  "Personal conversations": "Conversations personnelles",
  "Personal details this agent remembers from your conversations.":
    "Les informations personnelles que cet assistant retient de vos conversations.",
  "Pick a model": "Choisir un modèle",
  "Pick a specific model that supports structured response format (JSON schema)":
    "Choisissez un modèle qui prend en charge le format de réponse structuré (schéma JSON)",
  "Pick an agent": "Choisir un assistant",
  "Pick model": "Choisir le modèle",
  "Pick your alert sound": "Choisissez votre son d'alerte",
  "Pick your role to customize your experience:":
    "Choisissez votre rôle pour personnaliser votre expérience :",
  Play: "Écouter",
  "Play a sound when an agent needs your input to continue":
    "Jouer un son quand un assistant attend votre réponse pour continuer",
  "Please add agent instructions first.":
    "Ajoutez d'abord les instructions de l'assistant.",
  "Please allow microphone access and try again.":
    "Autorisez l'accès au micro et réessayez.",
  "Please describe the issue.": "Décrivez le problème.",
  "Please deselect manually each node you want to unselect. This is due to nodes not being fully synchronized yet":
    "Désélectionnez un par un les éléments voulus : ils ne sont pas encore tous synchronisés.",
  "Please select a YAML file (.yaml or .yml)":
    "Choisissez un fichier YAML (.yaml ou .yml)",
  "Please select a reason or describe the issue.":
    "Choisissez une raison ou décrivez le problème.",
  "Please select an event first": "Choisissez d'abord un événement",
  "Please select at least one editor to save.":
    "Choisissez au moins un éditeur pour enregistrer.",
  "Please select at least one provider to continue with the update.":
    "Choisissez au moins un fournisseur pour continuer.",
  "Please try again.": "Réessayez.",
  "Pod created": "Projet créé",
  "Pod members were successfully updated.":
    "Les membres du projet ont été mis à jour.",
  "Pod name": "Nom du projet",
  "Preparing your agent...": "Préparation de votre assistant…",
  "Previous run": "Exécution précédente",
  "Profile picture": "Photo de profil",
  "Providers Updated": "Fournisseurs mis à jour",
  "Providers must be configured in your workspace to use the agent builder.":
    "Des fournisseurs doivent être configurés dans votre espace de travail pour créer des assistants.",
  "Publish agent": "Publier l'assistant",
  Query: "Requête",
  "Rate Limited": "Limite de débit atteinte",
  Reasoning: "Raisonnement",
  "Receive a summary by email": "Recevoir un résumé par email",
  "Recent viewers": "Lecteurs récents",
  "Recently updated": "Récemment modifiés",
  "Recording error.": "Erreur d'enregistrement.",
  "Regional models setting updated": "Réglage des modèles régionaux mis à jour",
  "Reload the file": "Recharger le fichier",
  "Remaining memories": "Souvenirs restants",
  "Remove access rule": "Retirer la règle d'accès",
  "Remove from Pod?": "Retirer du projet ?",
  "Report an issue with this answer": "Signaler un problème avec cette réponse",
  Resend: "Renvoyer",
  "Resend code": "Renvoyer le code",
  "Respond to all messages in channel": "Répondre à tous les messages du canal",
  "Restore the agent": "Restaurer l'assistant",
  "Restoring the agent": "Restauration de l'assistant",
  "Restrict URL access": "Restreindre l'accès par lien",
  Restricted: "Restreint",
  Results: "Résultats",
  "Revert the last change": "Annuler la dernière modification",
  "Review in instructions": "Relire dans les instructions",
  "Revoke invitation": "Révoquer l'invitation",
  "Role updated": "Rôle mis à jour",
  "Role:": "Rôle :",
  "Run only when (optional)": "Exécuter seulement si (facultatif)",
  "Sample Data": "Exemple de données",
  "Save anyway": "Enregistrer quand même",
  "Save page to Pod": "Enregistrer la page dans le projet",
  Saved: "Enregistré",
  "Saved to Pod": "Enregistré dans le projet",
  "Saving…": "Enregistrement…",
  "Scheduled and sent automatically": "Programmé et envoyé automatiquement",
  "Search Pods": "Rechercher un projet",
  "Search Pods...": "Rechercher un projet…",
  "Search agents, pods and skills…":
    "Rechercher des assistants, projets et compétences…",
  "Search automations": "Rechercher une automatisation",
  "Search by email": "Rechercher par email",
  "Search data": "Recherche de données",
  "Search members": "Rechercher un membre",
  "Search members (email)": "Rechercher un membre (email)",
  "Search templates": "Rechercher un modèle",
  "Search trigger sources...": "Rechercher une source de déclencheur…",
  "Search viewers…": "Rechercher un lecteur…",
  "Searching in:": "Recherche dans :",
  "Seats updated": "Sièges mis à jour",
  Secret: "Secret",
  "Secret for validation...": "Secret de validation…",
  "Secret is required": "Le secret est obligatoire",
  "See documentation": "Voir la documentation",
  "Select DataSource": "Choisir une source de données",
  "Select Pod...": "Choisir un projet…",
  "Select a space...": "Choisir un espace…",
  "Select channels in which this agent replies by default.":
    "Choisissez les canaux où cet assistant répond par défaut.",
  "Select event": "Choisir un événement",
  "Select knowledge type and configure settings":
    "Choisissez le type de connaissances et configurez-les",
  "Select view": "Choisir la vue",
  "Selections:": "Sélections :",
  "Send a POST request to the webhook URL with your payload as JSON":
    "Envoyez une requête POST à l'adresse du webhook avec un contenu JSON",
  "Send code": "Envoyer le code",
  "Send invitation again": "Renvoyer l'invitation",
  "Send invitations to add new members to your workspace":
    "Envoyez des invitations pour ajouter des membres à votre espace de travail",
  "Set as editor": "Nommer éditeur",
  "Set conditions that must be met to run the agent.":
    "Définissez les conditions à remplir pour exécuter l'assistant.",
  "Set model": "Choisir le modèle",
  Share: "Partager",
  "Share details": "Donnez des précisions",
  "Share this frame": "Partager ce tableau de bord",
  Sharing: "Partage",
  "Show a popup inside Dust": `Afficher une fenêtre dans ${PRODUCT_NAME}`,
  "Show triggered": "Afficher les conversations déclenchées",
  "Show your agents on the home page":
    "Afficher vos assistants sur la page d'accueil",
  "Shown next to your messages": "Affichée à côté de vos messages",
  "Shrink-wrap": "Transformer en assistant",
  "Sidekick error": `Erreur de ${SIDEKICK_NAME}`,
  "Sign in": "Se connecter",
  "Sign in to open this Frame": "Connectez-vous pour ouvrir ce tableau de bord",
  "Sign in with an account that has access. We’ll bring you back here.":
    "Connectez-vous avec un compte qui a accès. Vous reviendrez ensuite ici.",
  "Signature Algorithm": "Algorithme de signature",
  "Signature Header": "En-tête de signature",
  "Signature header...": "En-tête de signature…",
  "Skill suggestions": "Suggestions de compétences",
  "Skipped. Running your next message.":
    "Ignoré. Traitement de votre message suivant.",
  "Some active agents may not be eligible for regional models.":
    "Certains assistants actifs ne sont peut-être pas compatibles avec les modèles régionaux.",
  "Some attachments could not be loaded":
    "Certaines pièces jointes n'ont pas pu être chargées",
  "Some conversations couldn’t be deleted":
    "Certaines conversations n'ont pas pu être supprimées",
  "Some conversations couldn’t be moved":
    "Certaines conversations n'ont pas pu être déplacées",
  "Some referenced files cannot be shared":
    "Certains fichiers référencés ne peuvent pas être partagés",
  "Some users are already in the workspace":
    "Certains utilisateurs sont déjà dans l'espace de travail",
  "Something unexpected happened": "Un incident inattendu s'est produit",
  "Something went wrong. Please try again.":
    "Un problème est survenu. Réessayez.",
  "Sound alerts for items that need your attention":
    "Alertes sonores pour ce qui demande votre attention",
  "Space was successfully created.": "L'espace a été créé.",
  "Space was successfully updated.": "L'espace a été mis à jour.",
  "Spend limit updated": "Limite de dépense mise à jour",
  Spirits: "Esprits",
  Starred: "Favoris",
  "Start Tour": "Commencer la visite",
  "Start chat": "Démarrer une conversation",
  "Start with a template": "Partir d'un modèle",
  "Stop agent": "Arrêter l'assistant",
  "Structured response format": "Format de réponse structuré",
  Submit: "Envoyer",
  "Subscribed events": "Événements suivis",
  "Subscribed events must not be empty.": "Choisissez au moins un événement.",
  "Subscribed!": "Vous participez",
  Succeeded: "Réussi",
  "Success !": "C'est fait",
  "Successfully added members": "Membres ajoutés",
  "Successfully created folder": "Dossier créé",
  "Successfully created space": "Espace créé",
  "Successfully created webhook source": "Source webhook créée",
  "Successfully deleted webhook source": "Source webhook supprimée",
  "Successfully updated Pod members": "Membres du projet mis à jour",
  "Successfully updated folder": "Dossier mis à jour",
  "Successfully updated space": "Espace mis à jour",
  "Successfully updated your profile.": "Votre profil a été mis à jour.",
  "Switch to Code": "Voir le code",
  "Switch to Rendering": "Voir le rendu",
  "Table has been updated": "Le tableau a été mis à jour",
  "Table query": "Requête de tableau",
  "Table updated": "Tableau mis à jour",
  "Take screenshot": "Faire une capture d'écran",
  "Template unavailable": "Modèle indisponible",
  "The Frame will be part of the Pod knowledge, and be able to be edited by any Pod member.":
    "Le tableau de bord rejoindra les connaissances du projet et pourra être modifié par tous ses membres.",
  "The agent has been saved successfully. Some channels are currently being linked, the operation will complete shortly.":
    "L'assistant est enregistré. Certains canaux sont en cours de liaison, l'opération se terminera sous peu.",
  "The agent is not published and you are not one of its editors.":
    "L'assistant n'est pas publié et vous n'en êtes pas éditeur.",
  "The agent message has been deleted successfully.":
    "Le message de l'assistant a été supprimé.",
  "The agent selected is not available to you":
    "L'assistant choisi ne vous est pas accessible",
  "The agent will improve with your feedback.":
    "L'assistant s'améliorera grâce à votre retour.",
  "The agent will use the selected secret to authenticate with the service. The secret value will be securely injected at runtime.":
    "L'assistant utilisera le secret choisi pour s'authentifier auprès du service. La valeur est injectée de façon sécurisée à l'exécution.",
  "The content of your personal memory may be disclosed to invited users.":
    "Le contenu de votre mémoire personnelle peut être visible des utilisateurs invités.",
  "The content of your saved memory may appear in responses sent to Slack and other external integrations.":
    "Le contenu de votre mémoire peut apparaître dans les réponses envoyées à Slack et à d'autres intégrations externes.",
  "The conversation has been moved to the Pod.":
    "La conversation a été déplacée vers le projet.",
  "The conversation has been removed from the Pod.":
    "La conversation a été retirée du projet.",
  "The file could not be found at this path.":
    "Aucun fichier à cet emplacement.",
  "The list of providers has been successfully updated.":
    "La liste des fournisseurs a été mise à jour.",
  "The update was submitted but the server response could not be read. The table has been refreshed with the current state.":
    "La mise à jour a été envoyée mais la réponse du serveur est illisible. Le tableau a été rafraîchi avec l'état actuel.",
  "The visualization failed due to an error in the generated code.":
    "La visualisation a échoué à cause d'une erreur dans le code généré.",
  Theme: "Thème",
  "There was an error configuring the tool. Please try again.":
    "Erreur pendant la configuration de l'outil. Réessayez.",
  "There was an issue creating a preview of your agent. Try making a small change to refresh.":
    "L'aperçu de votre assistant n'a pas pu être créé. Faites une petite modification pour le rafraîchir.",
  "These tools are only available to the users of the selected spaces:":
    "Ces outils ne sont disponibles que pour les utilisateurs des espaces choisis :",
  "This agent is already up to date.": "Cet assistant est déjà à jour.",
  "This agent is not available.": "Cet assistant n'est pas disponible.",
  "This automation is managed by Dust.": `Cette automatisation est gérée par ${PRODUCT_NAME}.`,
  "This content type is not yet supported in the Frame drawer.":
    "Ce type de contenu n'est pas encore pris en charge dans le panneau des tableaux de bord.",
  "This conversation may have been deleted or moved.":
    "Cette conversation a peut-être été supprimée ou déplacée.",
  "This conversation reached its size limit":
    "Cette conversation a atteint sa taille maximale",
  "This frame is currently shared publicly. You can restrict access, but you won’t be able to make it public again.":
    "Ce tableau de bord est actuellement public. Vous pouvez restreindre l'accès, mais vous ne pourrez plus le rendre public.",
  "This link template could not be loaded.":
    "Impossible de charger le modèle de ce lien.",
  "This space can't be removed from the skill because the skill uses knowledge or capabilities that belong to it.":
    "Cet espace ne peut pas être retiré de la compétence : elle utilise des connaissances ou des capacités qui lui appartiennent.",
  "This tool could not be loaded.": "Impossible de charger cet outil.",
  "This trigger now runs on its editor's credits.":
    "Ce déclencheur utilise maintenant les crédits de son éditeur.",
  "This trigger now runs on the workspace's credits.":
    "Ce déclencheur utilise maintenant les crédits de l'espace de travail.",
  "This user is not available.": "Cet utilisateur n'est pas disponible.",
  "This website doesn't have any pages to browse yet.":
    "Ce site n'a pas encore de pages à parcourir.",
  "This will hide the current plan from the side panel, but keep it in the conversation's files. The agent can create a new one.":
    "Le plan actuel disparaîtra du panneau latéral mais restera dans les fichiers de la conversation. L'assistant pourra en créer un nouveau.",
  "This will open the agent builder and launch Sidekick on this conversation so you can turn it into an agent.":
    "La page de création d'assistant va s'ouvrir et analyser cette conversation pour en faire un assistant.",
  "This will replace the current model and reasoning effort for every selected agent. All other settings will remain unchanged.":
    "Le modèle et l'effort de raisonnement seront remplacés pour chaque assistant sélectionné. Les autres réglages ne changent pas.",
  "This will restore the agent for everyone.":
    "L'assistant sera restauré pour tout le monde.",
  "Title edited": "Conversation renommée",
  To: "À",
  "To access your file, please authorize it once.":
    "Pour accéder à votre fichier, autorisez-le une fois.",
  "To authenticate your webhook requests, you need to sign the payload using the configured secret and algorithm:":
    "Pour authentifier vos requêtes, signez le contenu avec le secret et l'algorithme configurés :",
  "Too many invitations": "Trop d'invitations",
  Tool: "Outil",
  "Tool added": "Outil ajouté",
  "Tool already added": "Outil déjà ajouté",
  "Tool detail": "Détail de l'outil",
  "Tool information not available.": "Informations sur l'outil indisponibles.",
  "Tool stake setting": "Niveau de risque de l'outil",
  "Tool updated successfully": "Outil mis à jour",
  "Top-level posts only": "Messages principaux uniquement",
  Transcript: "Transcription",
  "Transcription failed.": "Échec de la transcription.",
  "Tried to update PDF sync setting, but no data source was found.":
    "Aucune source de données trouvée pour la synchronisation des PDF.",
  "Trigger deleted": "Déclencheur supprimé",
  "Trigger pool updated": "Réserve de crédits du déclencheur mise à jour",
  "Triggered and sent automatically": "Déclenché et envoyé automatiquement",
  "Try adding more details to your instructions to get better suggestions.":
    "Détaillez davantage vos instructions pour obtenir de meilleures suggestions.",
  "Try adjusting your search terms": "Essayez d'autres termes de recherche",
  "Try it yourself": "Essayer vous-même",
  "Type a label": "Saisissez une étiquette",
  "Type to search agents, pods and skills.":
    "Tapez pour rechercher des assistants, projets et compétences.",
  "URL access restricted": "Accès par lien restreint",
  "URL is now accessible": "Le lien est maintenant accessible",
  "Unable to create preview": "Impossible de créer l'aperçu",
  "Unable to fetch data source views. Please try again.":
    "Impossible de récupérer les sources de données. Réessayez.",
  "Unable to fetch workspace spaces. Please try again.":
    "Impossible de récupérer les espaces. Réessayez.",
  "Unable to load file. You can download it instead.":
    "Impossible d'afficher le fichier. Vous pouvez le télécharger.",
  "Unable to load recent webhook requests.":
    "Impossible de charger les requêtes webhook récentes.",
  Unassigned: "Non attribuée",
  "Unexpected Error": "Erreur inattendue",
  "Unexpected response from server.": "Réponse inattendue du serveur.",
  "Unknown User": "Utilisateur inconnu",
  "Unknown error occurred": "Une erreur inconnue s'est produite",
  "Unknown error.": "Erreur inconnue.",
  "Unpublish agent": "Dépublier l'assistant",
  "Unsaved changes": "Modifications non enregistrées",
  Unselect: "Désélectionner",
  "Unselect all": "Tout désélectionner",
  "Unsupported Content Type": "Type de contenu non pris en charge",
  "Update Failed": "Échec de la mise à jour",
  "Update agent instructions": "Modifier les instructions de l'assistant",
  "Update failed": "Échec de la mise à jour",
  "Update role": "Changer le rôle",
  "Update the skill to stop relying on these items, then remove the space.":
    "Modifiez la compétence pour ne plus dépendre de ces éléments, puis retirez l'espace.",
  "Updated User": "Profil mis à jour",
  "Updating sharing settings": "Mise à jour des réglages de partage",
  "Upload was rejected or failed.": "L'envoi a été refusé ou a échoué.",
  "Used to sign in and receive notifications":
    "Sert à vous connecter et à recevoir les notifications",
  "User declined to answer": "L'utilisateur a refusé de répondre",
  Username: "Nom d'utilisateur",
  Value: "Valeur",
  "Verification code": "Code de vérification",
  "Verification failed. Please try again.":
    "Échec de la vérification. Réessayez.",
  Verify: "Vérifier",
  "Verify your identity": "Vérifiez votre identité",
  "View description and settings": "Voir la description et les réglages",
  "View edit suggestions": "Voir les suggestions de modification",
  "View full conversation": "Voir toute la conversation",
  "View in builder": "Voir dans l'éditeur",
  "View your Premium model usage in Analytics":
    "Voir votre usage des modèles Premium dans l'analytique",
  "Viewer list": "Liste des lecteurs",
  Viewers: "Lecteurs",
  "Visualization Error": "Erreur de visualisation",
  "Visualization failed": "Échec de la visualisation",
  "Visualization not available": "Visualisation indisponible",
  "Voice upload failed.": "Échec de l'envoi de l'enregistrement.",
  "Wait until agent editors finish loading before saving.":
    "Attendez la fin du chargement des éditeurs avant d'enregistrer.",
  "Waiting for them to continue...": "En attente de leur réponse…",
  "Wake-Ups": "Réveils",
  "Wake-up cancelled": "Réveil annulé",
  "Was this answer helpful?": "Cette réponse vous a-t-elle aidé ?",
  "We could not determine the default model for this agent. Please try again.":
    "Impossible de déterminer le modèle par défaut de cet assistant. Réessayez.",
  "We couldn't find any relevant tags to suggest for this agent.":
    "Aucune étiquette pertinente à suggérer pour cet assistant.",
  "We couldn't load your notification settings. Please try again later.":
    "Impossible de charger vos réglages de notification. Réessayez plus tard.",
  "Web search and browsing": "Recherche et navigation web",
  "Webhook Source": "Source webhook",
  "Webhook Source Details": "Détails de la source webhook",
  "Webhook URL": "Adresse du webhook",
  "Webhook source for triggering assistants.":
    "Source webhook pour déclencher des assistants.",
  "Welcome to Dust": `Bienvenue dans ${PRODUCT_NAME}`,
  "What are your favorite platforms?": "Quels outils utilisez-vous le plus ?",
  "Which pool this trigger's runs take credits from.":
    "Réserve de crédits utilisée par les exécutions de ce déclencheur.",
  "Will constrain the model to a specific JSON schema":
    "Contraint le modèle à un schéma JSON précis",
  "Workspace credits": "Crédits de l'espace de travail",
  "Workspaces you've been invited to join":
    "Espaces de travail auxquels vous êtes invité",
  "XML Tag": "Balise XML",
  "Yes, helpful": "Oui, utile",
  "Yes, proceed": "Oui, continuer",
  "You are already a participant in this conversation.":
    "Vous participez déjà à cette conversation.",
  "You are not allowed to send messages.":
    "Vous n'avez pas le droit d'envoyer des messages.",
  "You cannot remove the last editor.":
    "Vous ne pouvez pas retirer le dernier éditeur.",
  "You cannot see the details of this agent.":
    "Vous ne pouvez pas voir le détail de cet assistant.",
  "You don't have a seat in this workspace.":
    "Vous n'avez pas de siège dans cet espace de travail.",
  "You don't have access to this page": "Vous n'avez pas accès à cette page",
  "You don’t have permission to publish agents.":
    "Vous n'avez pas le droit de publier des assistants.",
  "You have been added to this conversation.":
    "Vous avez été ajouté à cette conversation.",
  "You have reached your Premium model limit for the current 7-day window, so Dust ran this message on a Standard model instead.":
    "Vous avez atteint votre limite de modèle Premium sur les 7 derniers jours : ce message a donc été traité par un modèle Standard.",
  "You have selected tools that are not added yet. Are you sure you want to close without adding them?":
    "Vous avez choisi des outils pas encore ajoutés. Voulez-vous vraiment fermer sans les ajouter ?",
  "You have unsaved changes. Are you sure you want to close without saving?":
    "Vous avez des modifications non enregistrées. Voulez-vous vraiment fermer sans enregistrer ?",
  "You may experience reduced performance on very long conversations.":
    "Les très longues conversations risquent d'être moins performantes.",
  "You no longer have permission to share frames publicly":
    "Vous n'avez plus le droit de partager des tableaux de bord publiquement",
  "You will no longer have access to this conversation.":
    "Vous n'aurez plus accès à cette conversation.",
  "Your PDF has been downloaded.": "Votre PDF a été téléchargé.",
  "Your agent has been successfully saved": "Votre assistant est enregistré",
  "Your browser does not support the audio element.":
    "Votre navigateur ne peut pas lire cet audio.",
  "Your browser may not support voice recording.":
    "Votre navigateur ne permet peut-être pas l'enregistrement vocal.",
  "Your document is processing and will appear shortly":
    "Votre document est en cours de traitement et apparaîtra sous peu",
  "Your file is processing and will appear shortly.":
    "Votre fichier est en cours de traitement et apparaîtra sous peu.",
  "Your name is:": "Votre nom :",
  "complete the migration before March 3, 2026":
    "terminez la migration avant le 3 mars 2026",
  "designed for your needs": "conçus pour vos besoins",
  "filter expressions": "expressions de filtre",
  "if the document is a spreadsheet, this is expected. Spreadsheets do not expose raw contents. They are made available in Dust via the `Table Query` action in assistants.":
    "si le document est un tableur, c'est normal : les tableurs n'exposent pas leur contenu brut. Les assistants y accèdent par l'action de requête de tableau.",
  "knowledge and tools": "connaissances et outils",
  "official documentation": "documentation officielle",
  "our guide": "notre guide",
  "{provider} did not respond in time": "{provider} n'a pas répondu à temps",
  "The model": "Le modèle",
  "Something went wrong": "Un problème est survenu",
  "Retry with {tier} model tier": "Réessayer avec le niveau de modèle {tier}",
  "This model did not respond in time. Retry will use the {tier} model tier.":
    "Ce modèle n'a pas répondu à temps. La nouvelle tentative utilisera le niveau de modèle {tier}.",
  "Provide feedback on {agent}": "Donner votre avis sur {agent}",
  "{user} branched this conversation:":
    "{user} a créé une branche de cette conversation :",
  "{count} conversations have been deleted.":
    "{count} conversations ont été supprimées.",
  "1 conversation has been deleted.": "1 conversation a été supprimée.",
  "Could not delete the selected conversations.":
    "Impossible de supprimer les conversations sélectionnées.",
  "Could not delete the selected conversation.":
    "Impossible de supprimer la conversation sélectionnée.",
  "Deleted {done} of {total} conversations.":
    "{done} conversations supprimées sur {total}.",
  " The agent's reply will also be removed.":
    " La réponse de l'assistant sera aussi supprimée.",
  "Are you sure you want to delete this message?{replyNote} This action cannot be undone.":
    "Voulez-vous vraiment supprimer ce message ?{replyNote} Cette action est irréversible.",
  "Are you sure you want to delete this user's message?{replyNote} This will be reflected for all participants.":
    "Voulez-vous vraiment supprimer le message de cet utilisateur ?{replyNote} Tous les participants verront la suppression.",
  "Updated {date}": "Modifié : {date}",
  "to answer.": "qui doit répondre.",
  "{percent}% of context used.": "{percent} % du contexte utilisé.",
  "{name} needs to authorize a file.": "{name} doit autoriser un fichier.",
  "This visualization encountered an error and cannot be displayed.":
    "Cette visualisation a rencontré une erreur et ne peut pas être affichée.",
  "Please contact the creator of this visualization for assistance.":
    "Contactez la personne qui l'a créée pour obtenir de l'aide.",
  "Exit full screen mode": "Quitter le plein écran",
  "Go to full screen mode": "Passer en plein écran",
  "{label}. Open details.": "{label}. Ouvrir le détail.",
  "handoff from {agent}": "relais de {agent}",
  "Generating image {n}": "Génération de l'image {n}",
  "{title} (no longer available)": "{title} (plus disponible)",
  'Pod "{name}" has been created.': "Le projet « {name} » a été créé.",
  "Failed to upload file": "Impossible d'envoyer le fichier",
  "Failed to upload file preview": "Impossible d'envoyer l'aperçu du fichier",
  "Error uploading {file}": "Erreur pendant l'envoi de {file}",
  'File "{name}" ({size}) exceeds the {category} limit of {limit}. Please upload a smaller file.':
    "Le fichier « {name} » ({size}) dépasse la limite de {limit} pour ce type de fichier ({category}). Envoyez un fichier plus petit.",
  'Renamed to "{name}"': "Renommé en « {name} »",
  'The trigger "{name}" has been deleted.':
    "Le déclencheur « {name} » a été supprimé.",
  'Are you sure you want to delete the trigger "{name}"?':
    "Voulez-vous vraiment supprimer le déclencheur « {name} » ?",
  'The automation "{name}" has been deleted.':
    "L'automatisation « {name} » a été supprimée.",
  'Are you sure you want to delete "{name}"?':
    "Voulez-vous vraiment supprimer « {name} » ?",
  "Shorten the file to {count} characters or fewer before saving.":
    "Réduisez le fichier à {count} caractères au plus avant d'enregistrer.",
  "This file is longer than {count} characters. You can read and edit it, but trim it down before saving.":
    "Ce fichier dépasse {count} caractères. Vous pouvez le lire et le modifier, mais réduisez-le avant d'enregistrer.",
  'Agent "{name}" exported to YAML': "Assistant « {name} » exporté en YAML",
  "Show all {count} tools": "Voir les {count} outils",
  "Joined {space}": "Vous avez rejoint {space}",
  "You are now a member of {space}.": "Vous êtes maintenant membre de {space}.",
  "The agent uses restricted spaces you are not a member of:":
    "L'assistant utilise des espaces restreints dont vous n'êtes pas membre :",
  "Join space {space}": "Rejoindre l'espace {space}",
  Enter: "Entrée",
  "Role: {role}": "Rôle : {role}",
  "Sign out": "Se déconnecter",
  "{count} conversations marked as read.":
    "{count} conversations marquées comme lues.",
  "1 conversation marked as read.": "1 conversation marquée comme lue.",
  "Could not mark the conversations as read.":
    "Impossible de marquer les conversations comme lues.",
  "Could not mark the conversation as read.":
    "Impossible de marquer la conversation comme lue.",
  // Fusion amont du 03/10/2026 : chaines modifiees ou ajoutees par Dust.
  "Always allow agents to create tasks":
    "Toujours autoriser les assistants à créer des tâches",
  "Always allow agents to update tasks":
    "Toujours autoriser les assistants à modifier des tâches",
  "Always allow agents to edit Pod information":
    "Toujours autoriser les assistants à modifier les informations du projet",
  "Always allow agents to update Pod members":
    "Toujours autoriser les assistants à modifier les membres du projet",
  "Always allow agents to {tool}{scope}":
    "Toujours autoriser les assistants : {tool}{scope}",
  "Latest indexed record {ago}": "Dernier enregistrement indexé {ago}",
  "Updated {ago}": "Mis à jour {ago}",
  "{n} selected": "Sélection : {n}",
  // Passe de traduction du 03/10/2026 apres la fusion amont (ecrans refaits par Dust).
  Refresh: "Actualiser",
  "Synchronization warning": "Avertissement de synchronisation",
  'Do you want to unselect all of "{title}"?':
    "Voulez-vous tout désélectionner dans « {title} » ?",
  "Unable to load agents": "Impossible de charger les assistants",
  "Suggestion preview": "Aperçu de la suggestion",
  "No structured output": "Pas de sortie structurée",
  "No tags": "Aucune étiquette",
  "Structured output": "Sortie structurée",
  "Hidden agents": "Assistants masqués",
  "Loading actions…": "Chargement des actions…",
  "Retrying…": "Nouvelle tentative…",
  Go: "Aller",
  "New conversation in pod": "Nouvelle conversation dans le projet",
  "Open a new conversation in the active pod":
    "Ouvrir une nouvelle conversation dans le projet actif",
  "Open this Pod": "Ouvrir ce projet",
  "View profile": "Voir le profil",
  "More actions": "Plus d'actions",
  "More conversations available. Type to filter.":
    "D'autres conversations existent. Tapez pour filtrer.",
  "More members available. Type to filter.":
    "D'autres membres existent. Tapez pour filtrer.",
  "More settings available. Type to filter.":
    "D'autres réglages existent. Tapez pour filtrer.",
  "Search…": "Rechercher…",
  "Allow all": "Tout autoriser",
  "Allow remaining": "Autoriser le reste",
  Review: "Relire",
  "Hidden skills": "Compétences masquées",
  Filter: "Filtrer",
  "Clear filters": "Effacer les filtres",
  "All {category}": "Tout : {category}",
  "No results": "Aucun résultat",
  "Updating…": "Mise à jour…",
  "Failed to load filters.": "Impossible de charger les filtres.",
  "Search {category}": "Rechercher : {category}",
  "Not enough usage data to filter on.":
    "Pas assez de données d'usage pour filtrer.",
  Dust: "Par défaut",
  // Onglets des pages Competences et Agents (demande de Louka du 04/10, sans le mot de la marque amont).
  "Our skills": "Nos compétences",
  "Default skills": "Compétences de base",
  "Archived (skills)": "Archivées",
  "Our agents": "Nos assistants",
  "Default agents": "Assistants de base",
  "Archived (agents)": "Archivés",
  // Libellés d'activité des outils (05/10/2026) : étapes affichées pendant que l'assistant
  // travaille (front/lib/actions/tool_display_labels.ts), cibles de lecture des sources de
  // données et libellés statiques des outils amont.
  " to {to}": " à {to}",
  " to several recipients": " à plusieurs destinataires",
  "“{path}”": "« {path} »",
  "“{name}” from conversation": "« {name} » de la conversation",
  "“{name}” from Pod": "« {name} » du projet",
  "Searching “{q}”": "Recherche de « {q} »",
  "Search “{q}”": "Recherche : « {q} »",
  "Browsing “{url}”": "Consultation de « {url} »",
  "Browse “{url}”": "Page consultée : « {url} »",
  "Browsing {count} web pages": "Consultation de {count} pages web",
  "Browse {count} web pages": "Pages web consultées : {count}",
  "Searching “{q}” in Pod": "Recherche de « {q} » dans le projet",
  "Search “{q}” in Pod": "Recherche dans le projet : « {q} »",
  "Finding “{q}”": "Recherche par nom de « {q} »",
  "Find “{q}”": "Recherche par nom : « {q} »",
  "Searching for “{g}” in {target}": "Recherche de « {g} » dans {target}",
  "Search for “{g}” in {target}": "Recherche : « {g} » dans {target}",
  "Reading {target} (next ~{limit} characters)":
    "Lecture de {target} (~{limit} caractères suivants)",
  "Read {target} (next ~{limit} characters)":
    "Lu : {target} (~{limit} caractères suivants)",
  "Reading {target} (first ~{limit} characters)":
    "Lecture de {target} (~{limit} premiers caractères)",
  "Read {target} (first ~{limit} characters)":
    "Lu : {target} (~{limit} premiers caractères)",
  "Reading {target} (from character {offset})":
    "Lecture de {target} (à partir du caractère {offset})",
  "Read {target} (from character {offset})":
    "Lu : {target} (à partir du caractère {offset})",
  "Reading {target}": "Lecture de {target}",
  "Read {target}": "Lu : {target}",
  "Generating image “{name}”": "Génération de l'image « {name} »",
  "Generate image “{name}”": "Image générée : « {name} »",
  "Searching Gmail “{q}”": "Recherche de « {q} » dans Gmail",
  "Search Gmail “{q}”": "Recherche Gmail : « {q} »",
  "Drafting email “{s}”{recipient}": "Rédaction de l'e-mail « {s} »{recipient}",
  "Draft email “{s}”{recipient}": "Brouillon rédigé : « {s} »{recipient}",
  "Sending email “{s}”{recipient}": "Envoi de l'e-mail « {s} »{recipient}",
  "Send email “{s}”{recipient}": "E-mail envoyé : « {s} »{recipient}",
  "Deleting draft “{s}”": "Suppression du brouillon « {s} »",
  "Delete draft “{s}”": "Brouillon supprimé : « {s} »",
  "Getting attachment “{name}”": "Récupération de la pièce jointe « {name} »",
  "Get attachment “{name}”": "Pièce jointe récupérée : « {name} »",
  "Posting Slack message to {to}": "Envoi d'un message Slack à {to}",
  "Post Slack message to {to}": "Message Slack envoyé à {to}",
  "{count} recipients": "{count} destinataires",
  "Searching Slack “{keywords}”": "Recherche de « {keywords} » dans Slack",
  "Search Slack “{keywords}”": "Recherche Slack : « {keywords} »",
  "Searching Slack “{q}”": "Recherche de « {q} » dans Slack",
  "Search Slack “{q}”": "Recherche Slack : « {q} »",
  "Scheduling message to {to}": "Programmation d'un message à {to}",
  "Schedule message to {to}": "Message programmé à {to}",
  "Searching Slack users “{q}”": "Recherche de membres Slack « {q} »",
  "Search Slack users “{q}”": "Membres Slack recherchés : « {q} »",
  "Searching Slack channels “{q}”": "Recherche de canaux Slack « {q} »",
  "Search Slack channels “{q}”": "Canaux Slack recherchés : « {q} »",
  "Listing Slack messages in {channel}":
    "Lecture des messages Slack de {channel}",
  "List Slack messages in {channel}": "Messages Slack lus : {channel}",
  "Reading Slack thread in {channel}": "Lecture d'un fil Slack de {channel}",
  "Read Slack thread in {channel}": "Fil Slack lu : {channel}",
  "Creating Slack channel {name}": "Création du canal Slack {name}",
  "Create Slack channel {name}": "Canal Slack créé : {name}",
  "Inviting users to Slack channel {channel}":
    "Invitation de membres au canal Slack {channel}",
  "Invite users to Slack channel {channel}":
    "Membres invités au canal Slack {channel}",
  "Archiving Slack channel {channel}": "Archivage du canal Slack {channel}",
  "Archive Slack channel {channel}": "Canal Slack archivé : {channel}",
  "Searching Notion “{q}”": "Recherche de « {q} » dans Notion",
  "Search Notion “{q}”": "Recherche Notion : « {q} »",
  "Extracting “{o}”": "Extraction de « {o} »",
  "Extract “{o}”": "Extraction : « {o} »",
  "Searching files “{q}”": "Recherche de « {q} » dans les fichiers",
  "Search files “{q}”": "Recherche dans les fichiers : « {q} »",
  "Searching for “{g}” in file": "Recherche de « {g} » dans le fichier",
  "Search for “{g}” in file": "Recherche dans le fichier : « {g} »",
  "Reading file (next ~{limit} characters)":
    "Lecture du fichier (~{limit} caractères suivants)",
  "Read file (next ~{limit} characters)":
    "Fichier lu (~{limit} caractères suivants)",
  "Reading file (first ~{limit} characters)":
    "Lecture du fichier (~{limit} premiers caractères)",
  "Read file (first ~{limit} characters)":
    "Fichier lu (~{limit} premiers caractères)",
  "Reading file (from character {offset})":
    "Lecture du fichier (à partir du caractère {offset})",
  "Read file (from character {offset})":
    "Fichier lu (à partir du caractère {offset})",
  "Reading file": "Lecture du fichier",
  "Read file": "Fichier lu",
  "Searching “{pattern}” in “{path}”":
    "Recherche de « {pattern} » dans « {path} »",
  "Search “{pattern}” in “{path}”": "Recherche : « {pattern} » dans « {path} »",
  "Writing “{path}”": "Écriture de « {path} »",
  "Write “{path}”": "Fichier écrit : « {path} »",
  "Deleting “{path}”": "Suppression de « {path} »",
  "Delete “{path}”": "Supprimé : « {path} »",
  "Copying “{source}” to “{dest}”": "Copie de « {source} » vers « {dest} »",
  "Copy “{source}” to “{dest}”": "Copié : « {source} » vers « {dest} »",
  "Moving “{source}” to “{dest}”":
    "Déplacement de « {source} » vers « {dest} »",
  "Move “{source}” to “{dest}”": "Déplacé : « {source} » vers « {dest} »",
  "Resolving file “{fileId}”": "Identification du fichier « {fileId} »",
  "Resolve file “{fileId}”": "Fichier identifié : « {fileId} »",
  "Retrieving {url}": "Récupération de {url}",
  "Retrieve {url}": "Récupéré : {url}",
  "Creating issue on {base}: “{title}”":
    "Création d'un ticket sur {base} : « {title} »",
  "Create issue on {base}: “{title}”": "Ticket créé sur {base} : « {title} »",
  "Commenting on {url}": "Commentaire sur {url}",
  "Comment on {url}": "Commenté : {url}",
  "Reviewing {url}": "Relecture de {url}",
  "Review {url}": "Relu : {url}",
  "Listing issues on {base}": "Lecture des tickets de {base}",
  "List issues on {base}": "Tickets listés : {base}",
  "Listing PRs on {base}": "Lecture des PR de {base}",
  "List PRs on {base}": "PR listées : {base}",
  "Creating event “{s}”": "Création de l'événement « {s} »",
  "Create event “{s}”": "Événement créé : « {s} »",
  "Updating event “{s}”": "Mise à jour de l'événement « {s} »",
  "Update event “{s}”": "Événement mis à jour : « {s} »",
  "Searching Drive “{q}”": "Recherche de « {q} » dans Drive",
  "Search Drive “{q}”": "Recherche Drive : « {q} »",
  "Creating “{title}”": "Création de « {title} »",
  "Create “{title}”": "Créé : « {title} »",
  "Creating folder “{name}”": "Création du dossier « {name} »",
  "Create folder “{name}”": "Dossier créé : « {name} »",
  "Retrieving worksheet range “{range}”": "Lecture de la plage « {range} »",
  "Retrieve worksheet range “{range}”": "Plage lue : « {range} »",
  "Copying Drive file to “{name}”": "Copie du fichier Drive vers « {name} »",
  "Copy Drive file to “{name}”": "Fichier Drive copié vers « {name} »",
  "Sharing Drive file with {recipient}":
    "Partage du fichier Drive avec {recipient}",
  "Share Drive file with {recipient}": "Fichier Drive partagé avec {recipient}",
  "Commenting on Drive file: {content}":
    "Commentaire sur le fichier Drive : {content}",
  "Comment on Drive file: {content}": "Fichier Drive commenté : {content}",
  "Listing Sheets matching “{q}”": "Recherche de classeurs Sheets « {q} »",
  "List Sheets matching “{q}”": "Classeurs Sheets trouvés : « {q} »",
  "Creating spreadsheet “{title}”": "Création du classeur « {title} »",
  "Create spreadsheet “{title}”": "Classeur créé : « {title} »",
  "Adding worksheet “{title}”": "Ajout de la feuille « {title} »",
  "Add worksheet “{title}”": "Feuille ajoutée : « {title} »",
  "Renaming worksheet to “{title}”": "Renommage de la feuille en « {title} »",
  "Rename worksheet to “{title}”": "Feuille renommée en « {title} »",
  "Searching OneDrive/SharePoint “{q}”":
    "Recherche de « {q} » dans OneDrive/SharePoint",
  "Search OneDrive/SharePoint “{q}”": "Recherche OneDrive/SharePoint : « {q} »",
  "Uploading “{name}” to OneDrive/SharePoint":
    "Envoi de « {name} » vers OneDrive/SharePoint",
  "Upload “{name}” to OneDrive/SharePoint":
    "Envoyé vers OneDrive/SharePoint : « {name} »",
  "Copying OneDrive/SharePoint file to “{name}”":
    "Copie du fichier OneDrive/SharePoint vers « {name} »",
  "Copy OneDrive/SharePoint file to “{name}”":
    "Fichier OneDrive/SharePoint copié vers « {name} »",
  "Listing Excel files matching “{q}”": "Recherche de fichiers Excel « {q} »",
  "List Excel files matching “{q}”": "Fichiers Excel trouvés : « {q} »",
  " range “{range}”": ", plage « {range} »",
  "Creating Excel worksheet “{worksheetName}”":
    "Création de la feuille Excel « {worksheetName} »",
  "Create Excel worksheet “{worksheetName}”":
    "Feuille Excel créée : « {worksheetName} »",
  "Searching Teams messages “{q}”":
    "Recherche de « {q} » dans les messages Teams",
  "Search Teams messages “{q}”": "Recherche Teams : « {q} »",
  "Listing Teams users matching “{q}”": "Recherche de membres Teams « {q} »",
  "List Teams users matching “{q}”": "Membres Teams trouvés : « {q} »",
  "Listing Teams channels matching “{q}”": "Recherche de canaux Teams « {q} »",
  "List Teams channels matching “{q}”": "Canaux Teams trouvés : « {q} »",
  "Listing Teams chats matching “{q}”":
    "Recherche de discussions Teams « {q} »",
  "List Teams chats matching “{q}”": "Discussions Teams trouvées : « {q} »",
  "Posting Teams message to {targetType}":
    "Envoi d'un message Teams ({targetType})",
  "Post Teams message to {targetType}": "Message Teams envoyé ({targetType})",
  "Listing Teams meetings “{subject}”":
    "Recherche des réunions Teams « {subject} »",
  "List Teams meetings “{subject}”": "Réunions Teams trouvées : « {subject} »",
  "Getting Teams transcript for “{url}”":
    "Récupération de la transcription Teams de « {url} »",
  "Get Teams transcript for “{url}”":
    "Transcription Teams récupérée : « {url} »",
  "Executing Salesforce query “{q}”":
    "Exécution de la requête Salesforce « {q} »",
  "Execute Salesforce query “{q}”": "Requête Salesforce exécutée : « {q} »",
  "Describing Salesforce object {objectName}":
    "Description de l'objet Salesforce {objectName}",
  "Describe Salesforce object {objectName}":
    "Objet Salesforce décrit : {objectName}",
  "Creating Salesforce {objectName} records":
    "Création d'enregistrements Salesforce {objectName}",
  "Create Salesforce {objectName} records":
    "Enregistrements Salesforce {objectName} créés",
  "Updating Salesforce {objectName} records":
    "Mise à jour d'enregistrements Salesforce {objectName}",
  "Update Salesforce {objectName} records":
    "Enregistrements Salesforce {objectName} mis à jour",
  "Listing Salesforce attachments for {recordId}":
    "Recherche des pièces jointes Salesforce de {recordId}",
  "List Salesforce attachments for {recordId}":
    "Pièces jointes Salesforce listées : {recordId}",
  "Reading Salesforce attachments for {recordId}":
    "Lecture des pièces jointes Salesforce de {recordId}",
  "Read Salesforce attachments for {recordId}":
    "Pièces jointes Salesforce lues : {recordId}",
  "Retrieving Zendesk ticket {ticketId}":
    "Récupération du ticket Zendesk {ticketId}",
  "Retrieve Zendesk ticket {ticketId}": "Ticket Zendesk récupéré : {ticketId}",
  "Searching Zendesk tickets “{q}”": "Recherche de tickets Zendesk « {q} »",
  "Search Zendesk tickets “{q}”": "Recherche Zendesk : « {q} »",
  "Generating “{name}”": "Génération de « {name} »",
  "Generate “{name}”": "Généré : « {name} »",
  "Converting “{name}”": "Conversion de « {name} »",
  "Convert “{name}”": "Converti : « {name} »",
  "Creating Frame “{name}”": "Création du tableau de bord « {name} »",
  "Create Frame “{name}”": "Tableau de bord créé : « {name} »",
  "Editing Frame: {d}": "Modification du tableau de bord : {d}",
  "Edit Frame: {d}": "Tableau de bord modifié : {d}",
  "Renaming Frame to “{name}”": "Renommage du tableau de bord en « {name} »",
  "Rename Frame to “{name}”": "Tableau de bord renommé en « {name} »",
  "Asking: “{q}”": "Question : « {q} »",
  "Ask: “{q}”": "Question posée : « {q} »",
  "Retrieving HubSpot {objectType}": "Récupération dans HubSpot : {objectType}",
  "Retrieve HubSpot {objectType}": "Récupéré dans HubSpot : {objectType}",
  "Searching HubSpot {objectType} “{q}”":
    "Recherche de « {q} » dans HubSpot ({objectType})",
  "Search HubSpot {objectType} “{q}”":
    "Recherche HubSpot ({objectType}) : « {q} »",
  "Searching HubSpot {objectType}": "Recherche dans HubSpot ({objectType})",
  "Search HubSpot {objectType}": "Recherche HubSpot : {objectType}",
  "Reading Sheets range “{range}”": "Lecture de la plage Sheets « {range} »",
  "Read Sheets range “{range}”": "Plage Sheets lue : « {range} »",
  "Updating Sheets range “{range}”":
    "Mise à jour de la plage Sheets « {range} »",
  "Update Sheets range “{range}”": "Plage Sheets mise à jour : « {range} »",
  "Appending to Sheets range “{range}”": "Ajout à la plage Sheets « {range} »",
  "Append to Sheets range “{range}”": "Ajouté à la plage Sheets « {range} »",
  "Clearing Sheets range “{range}”":
    "Effacement de la plage Sheets « {range} »",
  "Clear Sheets range “{range}”": "Plage Sheets effacée : « {range} »",
  "Reading Excel worksheet “{worksheetName}”{range}":
    "Lecture de la feuille Excel « {worksheetName} »{range}",
  "Read Excel worksheet “{worksheetName}”{range}":
    "Feuille Excel lue : « {worksheetName} »{range}",
  "Writing Excel worksheet “{worksheetName}”{range}":
    "Écriture dans la feuille Excel « {worksheetName} »{range}",
  "Write Excel worksheet “{worksheetName}”{range}":
    "Feuille Excel modifiée : « {worksheetName} »{range}",
  "Clearing Excel worksheet “{worksheetName}”{range}":
    "Effacement de la feuille Excel « {worksheetName} »{range}",
  "Clear Excel worksheet “{worksheetName}”{range}":
    "Feuille Excel effacée : « {worksheetName} »{range}",
  "Drafting reply to Zendesk ticket {ticketId}":
    "Rédaction d'une réponse au ticket Zendesk {ticketId}",
  "Draft reply to Zendesk ticket {ticketId}":
    "Réponse rédigée au ticket Zendesk {ticketId}",
  "Posting reply to Zendesk ticket {ticketId}":
    "Envoi d'une réponse au ticket Zendesk {ticketId}",
  "Post reply to Zendesk ticket {ticketId}":
    "Réponse envoyée au ticket Zendesk {ticketId}",
  "Updating tags on Zendesk ticket {ticketId}":
    "Mise à jour des étiquettes du ticket Zendesk {ticketId}",
  "Update tags on Zendesk ticket {ticketId}":
    "Étiquettes du ticket Zendesk {ticketId} mises à jour",
  file: "fichier",
  "Google Drive shared with me": "fichiers Google Drive partagés avec moi",
  "Notion syncing resources": "ressources Notion en synchronisation",
  "Notion orphaned resources": "ressources Notion orphelines",
  "Dust project context": "contexte du projet",
  "GitHub issue": "ticket GitHub",
  "GitHub discussion": "discussion GitHub",
  "Zendesk ticket": "ticket Zendesk",
  "Zendesk article": "article Zendesk",
  "GitHub code file": "fichier de code GitHub",
  "GitHub code directory": "dossier de code GitHub",
  "Slack thread": "fil Slack",
  "Slack messages": "messages Slack",
  "Salesforce record": "enregistrement Salesforce",
  "Dust project conversation": "conversation du projet",
  "Dust project metadata": "métadonnées du projet",
  "Dust project": "projet",
  "GitHub repository code": "code du dépôt GitHub",
  "GitHub issues": "tickets GitHub",
  "GitHub discussions": "discussions GitHub",
  "GitHub repository": "dépôt GitHub",
  "Confluence page": "page Confluence",
  "Confluence folder": "dossier Confluence",
  "Confluence space": "espace Confluence",
  "Google Sheets tab": "onglet Google Sheets",
  "Google Drive file": "fichier Google Drive",
  "Notion database": "base Notion",
  "Notion content": "contenu Notion",
  "Slack channel": "canal Slack",
  "Intercom article": "article Intercom",
  "Intercom conversation": "conversation Intercom",
  "Intercom collection": "collection Intercom",
  "Intercom help center": "centre d'aide Intercom",
  "Intercom conversations": "conversations Intercom",
  "Intercom team": "équipe Intercom",
  "Zendesk category": "catégorie Zendesk",
  "Zendesk help center": "centre d'aide Zendesk",
  "Zendesk brand": "marque Zendesk",
  "Zendesk tickets": "tickets Zendesk",
  "Microsoft content": "contenu Microsoft",
  "Gong transcripts": "transcriptions Gong",
  "Gong transcript": "transcription Gong",
  "Salesforce synced query": "requête Salesforce synchronisée",
  "Dust project folder": "dossier du projet",
  "Dust project file": "fichier du projet",
  "Generating random number": "Tirage d'un nombre aléatoire",
  "Generate random number": "Nombre aléatoire tiré",
  "Generating random float": "Tirage d'un nombre décimal aléatoire",
  "Generate random float": "Nombre décimal aléatoire tiré",
  Waiting: "Attente",
  Wait: "Attente terminée",
  "Getting current time": "Lecture de l'heure actuelle",
  "Get current time": "Heure actuelle lue",
  Calculating: "Calcul en cours",
  Calculate: "Calcul effectué",
  "Setting conversation title": "Choix du titre de la conversation",
  "Set conversation title": "Titre de la conversation choisi",
  "Updating conversation read state": "Mise à jour de l'état de lecture",
  "Update conversation read state": "État de lecture mis à jour",
  "Searching data sources": "Recherche dans les sources de données",
  "Search data sources": "Recherche dans les sources de données",
  "Finding tags": "Recherche d'étiquettes",
  "Find tags": "Étiquettes trouvées",
  "Retrieving recent documents": "Récupération des documents récents",
  "Retrieve recent documents": "Documents récents récupérés",
  "Reading file from data source":
    "Lecture d'un fichier des sources de données",
  "Read file from data source": "Fichier des sources de données lu",
  "Listing data source contents": "Exploration des sources de données",
  "List data source contents": "Sources de données explorées",
  "Finding in data sources": "Recherche par nom dans les sources de données",
  "Find in data sources": "Recherche par nom dans les sources de données",
  "Locating content in hierarchy": "Localisation du contenu",
  "Locate content in hierarchy": "Contenu localisé",
  "Extracting data from documents": "Extraction de données des documents",
  "Extract data from documents": "Données extraites des documents",
  "Listing available files": "Liste des fichiers disponibles",
  "Listed available files": "Fichiers disponibles listés",
  "Copying file": "Copie du fichier",
  "Copied file": "Fichier copié",
  "Moving file": "Déplacement du fichier",
  "Moved file": "Fichier déplacé",
  "Resolving file ID": "Identification du fichier",
  "Resolved file ID": "Fichier identifié",
  "Searching file": "Recherche dans le fichier",
  "Searched file": "Recherche dans le fichier terminée",
  "Writing file": "Écriture du fichier",
  "Write file": "Fichier écrit",
  "Uploading file from URL": "Import d'un fichier depuis une URL",
  "Uploaded file from URL": "Fichier importé depuis une URL",
  "Deleting file": "Suppression du fichier",
  "Deleted file": "Fichier supprimé",
  "Editing file": "Modification du fichier",
  "Edited file": "Fichier modifié",
  "Extracting text from document": "Extraction du texte du document",
  "Extracted text from document": "Texte du document extrait",
  "Reading file from conversation": "Lecture d'un fichier de la conversation",
  "Read file from conversation": "Fichier de la conversation lu",
  "Listing files in conversation": "Liste des fichiers de la conversation",
  "List files in conversation": "Fichiers de la conversation listés",
  "Searching files in conversation":
    "Recherche dans les fichiers de la conversation",
  "Search files in conversation":
    "Recherche dans les fichiers de la conversation",
  "Listing conversation attachments": "Liste des pièces jointes",
  "List conversation attachments": "Pièces jointes listées",
  "Searching the web": "Recherche sur le web",
  "Web search": "Recherche web",
  "Browsing web page": "Consultation d'une page web",
  "Browse web page": "Page web consultée",
  "Sending HTTP request": "Envoi d'une requête HTTP",
  "Send HTTP request": "Requête HTTP envoyée",
  "Asking user...": "Question à l'utilisateur…",
  "User answered": "Réponse reçue",
  "Executing command": "Exécution d'une commande",
  "Execute command in the Computer": "Commande exécutée sur l'ordinateur",
  "Describing Computer toolset": "Description des outils de l'ordinateur",
  "Describe Computer toolset": "Outils de l'ordinateur décrits",
  "Requesting Computer network access":
    "Demande d'accès réseau pour l'ordinateur",
  "Allow domain in the Computer": "Domaine autorisé sur l'ordinateur",
  "Requesting network access": "Demande d'accès réseau",
  "Requested a domain": "Domaine demandé",
  "Creating new Frame": "Création d'un tableau de bord",
  "Create new Frame": "Tableau de bord créé",
  "Updating Frame": "Mise à jour du tableau de bord",
  "Update Frame": "Tableau de bord mis à jour",
  "Reverting changes on Frame":
    "Annulation des modifications du tableau de bord",
  "Revert changes on Frame": "Modifications du tableau de bord annulées",
  "Renaming Frame": "Renommage du tableau de bord",
  "Reading Frame content": "Lecture du tableau de bord",
  "Read Frame content": "Tableau de bord lu",
  "Getting share URL": "Récupération du lien de partage",
  "Get share URL": "Lien de partage récupéré",
  "Exporting Frame": "Export du tableau de bord",
  "Export Frame": "Tableau de bord exporté",
  "Publishing Frame": "Publication du tableau de bord",
  "Publish Frame": "Tableau de bord publié",
  "Opening Frame": "Ouverture du tableau de bord",
  "Open Frame": "Tableau de bord ouvert",
  "Updating files panel": "Mise à jour du panneau Fichiers",
  "Update files panel": "Panneau Fichiers mis à jour",
  "Generating image": "Génération d'une image",
  "Generate image": "Image générée",
  "Listing supported formats": "Liste des formats pris en charge",
  "List supported formats": "Formats pris en charge listés",
  "Converting file": "Conversion du fichier",
  "Convert file": "Fichier converti",
  "Generating file": "Génération du fichier",
  "Generate file": "Fichier généré",
  "Retrieving memories": "Lecture de la mémoire",
  "Retrieve memories": "Mémoire lue",
  "Recording memories": "Enregistrement en mémoire",
  "Record memories": "Mémoire enregistrée",
  "Erasing memory entries": "Effacement d'entrées de la mémoire",
  "Erase memory entries": "Entrées de la mémoire effacées",
  "Editing memory entries": "Modification de la mémoire",
  "Edit memory entries": "Mémoire modifiée",
  "Compacting memory": "Compactage de la mémoire",
  "Compact memory": "Mémoire compactée",
  "Reading memory": "Lecture de la mémoire",
  "Read memory": "Mémoire lue",
  "Editing memory": "Modification de la mémoire",
  "Edit memory": "Mémoire modifiée",
  "Listing available tables": "Liste des tables disponibles",
  "List available tables": "Tables disponibles listées",
  "Getting database schema": "Lecture du schéma de la base",
  "Get database schema": "Schéma de la base lu",
  "Executing database query": "Exécution d'une requête",
  "Execute database query": "Requête exécutée",
  "Listing warehouse contents": "Exploration de l'entrepôt de données",
  "List warehouse contents": "Entrepôt de données exploré",
  "Finding tables in warehouse": "Recherche de tables dans l'entrepôt",
  "Find tables in warehouse": "Tables trouvées dans l'entrepôt",
  "Describing warehouse tables": "Description des tables de l'entrepôt",
  "Describe warehouse tables": "Tables de l'entrepôt décrites",
  "Running warehouse query": "Exécution d'une requête sur l'entrepôt",
  "Run warehouse query": "Requête sur l'entrepôt exécutée",
  "No child agent configured": "Aucun assistant configuré",
  "Running agent": "Appel d'un assistant",
  "Listing tools": "Liste des outils",
  "List tools": "Outils listés",
  "Enabling tool": "Activation d'un outil",
  "Enabled tool": "Outil activé",
  "Listing skills": "Liste des compétences",
  "List skills": "Compétences listées",
  "Getting skill": "Lecture d'une compétence",
  "Get skill": "Compétence lue",
  "Creating skill": "Création d'une compétence",
  "Updating skill": "Mise à jour d'une compétence",
  "Update skill": "Compétence mise à jour",
  "Creating plan": "Création du plan",
  "Plan created": "Plan créé",
  "Updating plan": "Mise à jour du plan",
  "Plan updated": "Plan mis à jour",
  "Closing plan": "Clôture du plan",
  "Plan closed": "Plan clôturé",
  "Adding content node to Pod": "Ajout d'un contenu au projet",
  "Add content node to Pod": "Contenu ajouté au projet",
  "Removing content node from Pod": "Retrait d'un contenu du projet",
  "Remove content node from Pod": "Contenu retiré du projet",
  "Editing Pod information": "Modification des informations du projet",
  "Edit Pod information": "Informations du projet modifiées",
  "Updating pinned frame": "Mise à jour du tableau de bord épinglé",
  "Update pinned frame": "Tableau de bord épinglé mis à jour",
  "Updating file tabs": "Mise à jour des onglets de fichiers",
  "Update file tabs": "Onglets de fichiers mis à jour",
  "Setting Pod default agent": "Choix de l'assistant par défaut du projet",
  "Set Pod default agent": "Assistant par défaut du projet choisi",
  "Updating Pod members": "Mise à jour des membres du projet",
  "Update Pod members": "Membres du projet mis à jour",
  "Getting Pod information": "Lecture des informations du projet",
  "Get Pod information": "Informations du projet lues",
  "Listing Pod members": "Liste des membres du projet",
  "List Pod members": "Membres du projet listés",
  "Listing Pods": "Liste des projets",
  "List Pods": "Projets listés",
  "Creating Pod": "Création du projet",
  "Create Pod": "Projet créé",
  "Retrieving recent Pod documents":
    "Récupération des documents récents du projet",
  "Retrieve recent Pod documents": "Documents récents du projet récupérés",
  "Searching Pod": "Recherche dans le projet",
  "Search Pod": "Recherche dans le projet",
  "Creating conversation": "Création d'une conversation",
  "Create conversation": "Conversation créée",
  "Listing Pod conversations": "Liste des conversations du projet",
  "List conversations": "Conversations listées",
  "Moving conversation": "Déplacement de la conversation",
  "Move conversation": "Conversation déplacée",
  "Adding message to conversation": "Ajout d'un message à la conversation",
  "Add message to conversation": "Message ajouté à la conversation",
  "Listing tasks": "Liste des tâches",
  "List tasks": "Tâches listées",
  "Creating tasks": "Création de tâches",
  "Create tasks": "Tâches créées",
  "Updating tasks": "Mise à jour des tâches",
  "Update tasks": "Tâches mises à jour",
  "Starting task work": "Démarrage d'une tâche",
  "Start task work": "Tâche démarrée",
  "Searching users": "Recherche de membres",
  "Search users": "Membres trouvés",
  "Getting mention markdown": "Préparation de la mention",
  "Get mention markdown": "Mention préparée",
  "Creating schedule": "Création d'une planification",
  "Create schedule": "Planification créée",
  "Listing triggers": "Liste des déclencheurs",
  "List triggers": "Déclencheurs listés",
  "Disabling trigger": "Désactivation d'un déclencheur",
  "Disable trigger": "Déclencheur désactivé",
  "Listing event sources": "Liste des sources d'événements",
  "List event sources": "Sources d'événements listées",
  "Creating event trigger": "Création d'un déclencheur",
  "Create event trigger": "Déclencheur créé",
  "Scheduling wake-up": "Programmation d'un réveil",
  "Schedule wake-up": "Réveil programmé",
  // Noms des outils du serveur des réveils (08/10).
  "Schedule wakeup": "Programmer un réveil",
  "List wakeups": "Lister les réveils",
  "Cancel wakeup": "Annuler un réveil",
  "Listing wake-ups": "Liste des réveils",
  "List wake-ups": "Réveils listés",
  "Cancelling wake-up": "Annulation d'un réveil",
  "Transcribing audio": "Transcription de l'audio",
  "Transcribe audio": "Audio transcrit",
  "Generating speech": "Synthèse vocale",
  "Generate speech": "Voix générée",
  "Generating dialogue": "Génération d'un dialogue",
  "Generate dialogue": "Dialogue généré",
  "Generating sound effect": "Génération d'un effet sonore",
  "Generate sound effect": "Effet sonore généré",
  "Requesting access to {domain}": "Demande d'accès à {domain}",
  "Request access to {domain}": "Accès demandé à {domain}",
  // Aperçu en deux onglets (05/10) : le fichier rendu et le texte extrait.
  Original: "Original",
  "Extracted text": "Texte extrait",
  "Loading the extracted text…": "Chargement du texte extrait…",
  "The extracted text could not be loaded.":
    "Le texte extrait n'a pas pu être chargé.",
  "No text was extracted from this document.":
    "Aucun texte n'a été extrait de ce document.",
  // Bouton « Écouter » sous une réponse (05/10) : synthèse vocale du navigateur.
  "Read the answer aloud": "Écouter la réponse",
  "Stop reading aloud": "Arrêter la lecture",
  // Page « Tâches planifiées » (06/10) : les tâches du membre, et toutes celles de l'espace pour un admin.
  "Scheduled tasks": "Tâches planifiées",
  "Tasks your assistant runs on its own, at the times you choose.":
    "Les tâches que votre assistant exécute seul, aux moments que vous choisissez.",
  "New task": "Nouvelle tâche",
  "My tasks": "Mes tâches",
  "All tasks": "Toutes les tâches",
  "Task name": "Tâche",
  "Task frequency": "Fréquence",
  "Next run": "Prochaine exécution",
  "Last run": "Dernière exécution",
  "Task owner": "Propriétaire",
  "Task status": "État",
  "Task active": "Active",
  "Task paused": "En pause",
  "Suspended by an administrator": "Suspendue par un administrateur",
  "Temporarily suspended": "Suspendue temporairement",
  "This task is temporarily suspended.":
    "Cette tâche est suspendue temporairement.",
  "Only an administrator can resume this task.":
    "Seul un administrateur peut réactiver cette tâche.",
  "Triggered by an event": "Déclenchée par un événement",
  "See the result": "Voir le résultat",
  "Run succeeded": "Réussie",
  "Run failed": "En échec",
  "Not run yet": "Pas encore exécutée",
  "No upcoming run": "Aucune",
  "Edit task": "Modifier",
  "Show details": "Afficher le détail",
  Frequency: "Fréquence",
  "Email addresses in the instructions": "Adresses e-mail de la consigne",
  "Task instructions": "Consigne",
  "No instructions.": "Aucune consigne.",
  "Email template (HTML)": "modèle du mail (HTML)",
  Template: "modèle",
  lines: "lignes",
  None: "Aucune",
  "Delete task": "Supprimer",
  "Delete this task?": "Supprimer cette tâche ?",
  "The task « {name} » will be deleted and will no longer run.":
    "La tâche « {name} » sera supprimée et ne s'exécutera plus.",
  "Keep the task": "Conserver",
  "Pause the task": "Mettre la tâche en pause",
  "Resume the task": "Réactiver la tâche",
  "No scheduled task yet": "Aucune tâche planifiée pour l'instant",
  "Ask your assistant to do some work for you on a regular basis. Start from an example or write your own task.":
    "Confiez à votre assistant un travail à faire régulièrement. Partez d'un exemple ou écrivez votre propre tâche.",
  "Loading tasks…": "Chargement des tâches…",
  "The tasks could not be loaded.": "Les tâches n'ont pas pu être chargées.",
  "No main assistant is set up: a new task cannot be created.":
    "Aucun assistant principal n'est configuré : impossible de créer une tâche.",
  "Task deleted": "Tâche supprimée",
  "The task could not be deleted.": "La tâche n'a pas pu être supprimée.",
  // Espaces restreints (08/10) : un admin ajoute et retire des membres. Onglet Groupes de la
  // fiche d'un espace, et notifications de creation, mise a jour, suppression d'un espace.
  Provisioned: "Synchronisé",
  Manual: "Manuel",
  "Search groups...": "Rechercher un groupe…",
  "Loading groups...": "Chargement des groupes…",
  "{count} member": "{count} membre",
  "{count} members": "{count} membres",
  "Failed to add members to {name}": "Échec de l'ajout de membres à {name}",
  "Members were added to {name}.": "Les membres ont été ajoutés à {name}.",
  "Space {name} deleted": "Espace {name} supprimé",
  "{name} was successfully deleted.": "{name} a bien été supprimé.",
  "Error deleting space {name}":
    "Erreur lors de la suppression de l'espace {name}",
  "The maximum number of spaces for your subscription has been reached. To create another space, ask for the limit to be raised.":
    "Le nombre maximal d'espaces de votre abonnement est atteint. Pour créer un autre espace, demandez que la limite soit relevée.",
  // Connexions (08/10) : l'administrateur suspend Google Drive et déconnecte Service public, sans rien perdre.
  Synchronization: "Synchronisation",
  "Pause synchronization": "Suspendre la synchronisation",
  "Resume synchronization": "Reprendre la synchronisation",
  "Documents from {name} are imported automatically.":
    "Les documents de {name} sont importés automatiquement.",
  "The synchronization of {name} is paused. Documents already imported stay searchable by the assistant.":
    "La synchronisation de {name} est suspendue. Les documents déjà importés restent consultables par l'assistant.",
  "Pause the synchronization of {name}?":
    "Suspendre la synchronisation de {name} ?",
  "New documents and changes made in {name} will no longer be imported. Documents already imported stay searchable and nothing is deleted. You can resume at any time.":
    "Les nouveaux documents et les modifications faites dans {name} ne seront plus importés. Les documents déjà importés restent consultables et rien n'est supprimé. Vous pourrez reprendre à tout moment.",
  "Confirm the pause": "Confirmer la suspension",
  "Synchronization paused": "Synchronisation suspendue",
  "Synchronization resumed": "Synchronisation reprise",
  "New documents and changes made in {name} are imported again.":
    "Les nouveaux documents et les modifications faites dans {name} sont de nouveau importés.",
  "The synchronization could not be changed.":
    "La synchronisation n'a pas pu être modifiée.",
  Reconnect: "Reconnecter",
  "Disconnect Service public?": "Déconnecter Service public ?",
  "The assistant will no longer use Service public (laws, companies, public procurement, practical guides). The server and its settings are kept: you can reconnect it at any time.":
    "L'assistant n'utilisera plus Service public (lois, entreprises, marchés publics, fiches pratiques). Le serveur et ses réglages sont conservés : vous pourrez le reconnecter à tout moment.",
  "Confirm the disconnection": "Confirmer la déconnexion",
  "Disconnected by an administrator: the assistant no longer uses these tools.":
    "Déconnecté par un administrateur : l'assistant n'utilise plus ces outils.",
  "Service public disconnected": "Service public déconnecté",
  "Service public reconnected": "Service public reconnecté",
  // Reglages personnels · Notifications par courriel (08/10, front/lib/compta/reglages_notifications.ts).
  "Choose when you receive an email": "Choisissez quand vous recevez un email",
  "Notifications are sent by email. In-app popups and sounds are not available.":
    "Les notifications arrivent par email. Les fenêtres et les sons dans l'application ne sont pas disponibles.",
  "Email notifications": "Notifications par email",
  "Mentions, replies in your conversations and results of your scheduled tasks":
    "Mentions, réponses dans vos conversations et résultats de vos tâches planifiées",
  "In your conversations. A conversation where you are the only member always notifies you, unless you choose Nothing.":
    "Dans vos conversations. Une conversation où vous êtes seul vous prévient toujours, sauf avec « Rien ».",
  "At most one email per conversation": "Au plus un email par conversation",
  "Scheduled task results are emailed after each run, whatever you choose above.":
    "Le résultat d'une tâche planifiée vous est envoyé après chaque exécution, quel que soit le choix ci-dessus.",
  "All activity": "Toute l'activité",
  "Mentions only": "Mentions seulement",
  Nothing: "Rien",
  "Every 5 minutes": "Toutes les 5 minutes",
  "Every 15 minutes": "Toutes les 15 minutes",
  "Every 30 minutes": "Toutes les 30 minutes",
  "Every hour": "Toutes les heures",
  "Once a day": "Une fois par jour",
  "Once a week": "Une fois par semaine",
  // Project page of the assistant apps (10/10): tabs, dialogs, notifications and tasks.
  "What’s next, [Name]?": "Et maintenant, [Name] ?",
  "What are we working on, [Name]?": "Sur quoi travaillons-nous, [Name] ?",
  "What’s on your mind, [Name]?": "À quoi pensez-vous, [Name] ?",
  "What are we building, [Name]?": "Que construisons-nous, [Name] ?",
  "Where do we start, [Name]?": "Par où commençons-nous, [Name] ?",
  "What’s the plan, [Name]?": "Quel est le programme, [Name] ?",
  "What can I help with, [Name]?": "Comment puis-je vous aider, [Name] ?",
  "What should we start with, [Name]?": "Par quoi commençons-nous, [Name] ?",
  "What’s cooking, [Name]?": "Quoi de neuf, [Name] ?",
  "Ready when you are, [Name].": "Prêt quand vous l'êtes, [Name].",
  "It's quiet in here.": "C'est bien calme ici.",
  "Your Pod is ready but empty! Let us help you invite people, add key data, and more.":
    "Votre projet est prêt, mais encore vide. Nous pouvons vous aider à inviter des personnes, à ajouter les données clés, et plus encore.",
  "Let's go": "C'est parti",
  "You need to be invited to participate in this Pod.":
    "Vous devez être invité pour participer à ce projet.",
  "Join this Pod to participate in conversations.":
    "Rejoignez ce projet pour participer aux conversations.",
  "Joining...": "Ajout en cours…",
  "Join the {podName} Pod": "Rejoindre le projet {podName}",
  "No conversations found.": "Aucune conversation trouvée.",
  "No group conversations yet in this Pod.":
    "Aucune conversation de groupe dans ce projet pour l'instant.",
  "You are not a participant in any conversation yet.":
    "Vous ne participez encore à aucune conversation.",
  "Attach files to the conversation": "Joindre des fichiers à la conversation",
  "Archived Pod": "Archivé",
  "This Pod is archived and no longer appears in your sidebar. You can still search for it and view past conversations, but you cannot start new ones.":
    "Ce projet est archivé et n'apparaît plus dans votre barre latérale. Vous pouvez toujours le rechercher et consulter ses conversations passées, mais pas en démarrer de nouvelles.",
  Mine: "Les miennes",
  "Conversations where you have sent a message.":
    "Les conversations où vous avez envoyé un message.",
  Group: "Groupe",
  "Conversations with more than one person": "Les conversations à plusieurs",
  "All conversations": "Toutes",
  "Every conversation in this Pod.": "Toutes les conversations de ce projet.",
  "Failed to search conversations. Please try again.":
    "La recherche des conversations a échoué. Veuillez réessayer.",
  "Leave this Pod?": "Quitter ce projet ?",
  "You will no longer have access to conversations and context in":
    "Vous n'aurez plus accès aux conversations ni au contexte de",
  "You can rejoin this Pod anytime.":
    "Vous pourrez rejoindre ce projet à tout moment.",
  "Frame no longer available": "Tableau de bord introuvable",
  "File no longer available": "Fichier introuvable",
  "This frame is missing or was renamed in Pod files ({relativePath}). Remove it from Tabs in Settings, or restore the file.":
    "Ce tableau de bord est absent ou a été renommé dans les fichiers du projet ({relativePath}). Retirez-le des onglets dans les Réglages, ou restaurez le fichier.",
  "This file is missing or was renamed in Pod files ({relativePath}). Remove it from Tabs in Settings, or restore the file.":
    "Ce fichier est absent ou a été renommé dans les fichiers du projet ({relativePath}). Retirez-le des onglets dans les Réglages, ou restaurez le fichier.",
  Unpin: "Désépingler",
  "Exit full screen": "Quitter le plein écran",
  "Open in full screen": "Ouvrir en plein écran",
  "Unknown error": "Erreur inconnue",
  "Pod options": "Options du projet",
  "You are the last editor of this Pod and cannot leave it.":
    "Vous êtes le dernier éditeur de ce projet et ne pouvez pas le quitter.",
  "Leave the Pod": "Quitter le projet",
  "A pod can have at most {max} custom tabs.":
    "Un projet peut avoir au plus {max} onglets personnalisés.",
  "Add file to Tabs": "Ajouter un fichier aux onglets",
  "Failed to rename the Pod": "Impossible de renommer le projet",
  "Pod renamed": "Projet renommé",
  "Edit Pod name": "Renommer le projet",
  "My settings": "Mes réglages",
  "Remove from starred": "Retirer des favoris",
  "Add to starred": "Ajouter aux favoris",
  Pod: "Projet",
  "Member list": "Liste des membres",
  "Try refreshing the page to continue.": "Rechargez la page pour continuer.",
  "Still having trouble? Reach out at support@dust.tt":
    "Le problème persiste ? Contactez votre administrateur.",
  "Pod not found": "Projet introuvable",
  "The Pod you're looking for doesn't exist or you don't have access to it.":
    "Ce projet n'existe pas ou vous n'y avez pas accès.",
  "New folder": "Nouveau dossier",
  "Folder name": "Nom du dossier",
  "Add file tab": "Ajouter un onglet de fichier",
  "Edit file tab": "Modifier l'onglet de fichier",
  "Change icon": "Changer l'icône",
  "Tab title": "Titre de l'onglet",
  "Remove tab": "Retirer l'onglet",
  "Add tab": "Ajouter l'onglet",
  "Unpin from Pod banner": "Retirer de la bannière du projet",
  "This frame is no longer available in the Pod files.":
    "Ce tableau de bord n'est plus disponible dans les fichiers du projet.",
  "Adding files to Pods is disabled by your workspace admin.":
    "L'ajout de fichiers aux projets est désactivé par l'administrateur de votre espace de travail.",
  "From Company Data": "Depuis les Données Entreprise",
  "No data available in Company Data":
    "Aucune donnée dans les Données Entreprise",
  "There is no data available in Company Data yet. Go to Company Data to add data.":
    "Les Données Entreprise sont encore vides. Ouvrez les Données Entreprise pour y ajouter des données.",
  "Go to Company Data": "Ouvrir les Données Entreprise",
  "Drop files here to upload them.":
    "Déposez vos fichiers ici pour les importer.",
  "Remove content node?": "Retirer ce contenu ?",
  'Are you sure you want to remove "{name}" from this Pod?':
    "Voulez-vous vraiment retirer « {name} » de ce projet ?",
  "This Pod is archived. No files have been added.":
    "Ce projet est archivé. Aucun fichier n'a été ajouté.",
  "No files have been added to this Pod yet.":
    "Aucun fichier n'a encore été ajouté à ce projet.",
  "Add data from Company Data": "Ajouter des Données Entreprise",
  "No files to add": "Aucun fichier à ajouter",
  "No files found": "Aucun fichier trouvé",
  "Delete Pod": "Supprimer le projet",
  "Delete {name}?": "Supprimer {name} ?",
  Type: "Saisissez",
  "below to confirm. This permanently removes all Pod content and cannot be undone.":
    "ci-dessous pour confirmer. Tout le contenu du projet sera définitivement supprimé, sans retour possible.",
  "Type delete to confirm": "Saisissez delete pour confirmer",
  "Delete permanently": "Supprimer définitivement",
  "Successfully updated Pod groups": "Groupes du projet mis à jour",
  "The groups with access to this Pod were updated.":
    "Les groupes qui ont accès à ce projet ont été mis à jour.",
  "Manage Groups of {name}": "Gérer les groupes de {name}",
  "Successfully removed group": "Groupe retiré",
  "The group no longer has access to this Pod.":
    "Le groupe n'a plus accès à ce projet.",
  "Group name": "Nom du groupe",
  "Group type": "Type de groupe",
  Role: "Rôle",
  "Remove from Pod": "Retirer du projet",
  "Remove group": "Retirer le groupe",
  'Are you sure you want to remove "{name}" from this Pod? Its members will lose access, unless they are members of the Pod some other way.':
    "Voulez-vous vraiment retirer « {name} » de ce projet ? Ses membres perdront l'accès, sauf s'ils sont membres du projet par un autre biais.",
  "Pods must have at least one editor.":
    "Un projet doit avoir au moins un éditeur.",
  "Successfully removed member": "Membre retiré",
  "Pod member was successfully removed.":
    "Le membre a bien été retiré du projet.",
  "Pod editor was successfully added.":
    "L'éditeur a bien été ajouté au projet.",
  "Pod editor was successfully removed.":
    "L'éditeur a bien été retiré du projet.",
  "Joined at": "Arrivée le",
  "Remove from editors": "Retirer des éditeurs",
  'Are you sure you want to remove "{name}" from editors?':
    "Voulez-vous vraiment retirer « {name} » des éditeurs ?",
  'Are you sure you want to add "{name}" as an editor?':
    "Voulez-vous vraiment nommer « {name} » éditeur ?",
  "Remove member": "Retirer le membre",
  "Failed to load": "Échec du chargement",
  "The Pod network settings could not be loaded.":
    "Les réglages réseau du projet n'ont pas pu être chargés.",
  Network: "Réseau",
  "This Pod's Computer can reach these domains on top of the workspace allowlist. Changes apply to running Computers within about a minute.":
    "L'ordinateur de ce projet peut joindre ces domaines en plus de la liste autorisée de l'espace de travail. Les changements s'appliquent aux ordinateurs en cours d'exécution en une minute environ.",
  "You can request additional domains; a workspace admin reviews each request.":
    "Vous pouvez demander d'autres domaines, chaque demande est examinée par un administrateur de l'espace de travail.",
  "No Pod-specific domains are currently allowed.":
    "Aucun domaine propre au projet n'est autorisé pour l'instant.",
  "Only when mentioned": "Seulement quand je suis mentionné",
  "Don't notify me": "Ne pas me notifier",
  "Update Pod name?": "Renommer le projet ?",
  'The Pod name will be changed to "{name}".':
    "Le projet s'appellera désormais « {name} ».",
  "Successfully updated Pod name": "Projet renommé",
  "Pod name was successfully updated.": "Le nom du projet a bien été modifié.",
  "Enter Pod name": "Nom du projet",
  "Describe what this Pod is about...": "Décrivez le sujet de ce projet…",
  "How you get notified about activity in this Pod. Also available from the Pod menu.":
    "La façon dont vous êtes prévenu de l'activité de ce projet. Également accessible depuis le menu du projet.",
  "Archive and delete": "Archiver et supprimer",
  "Archived on": "Archivé le",
  Unarchive: "Désarchiver",
  "This Pod is removed from your sidebar. Its content stays intact and agents can still use it as a data source. You can restore it at any time.":
    "Le projet disparaît de votre barre latérale. Son contenu reste intact et les assistants peuvent toujours s'en servir comme source de données. Vous pouvez le restaurer à tout moment.",
  "Deleting removes all content in this Pod: conversations, folders, websites, and data sources. Agents that use its tools will stop working. This cannot be undone.":
    "La suppression efface tout le contenu de ce projet : conversations, dossiers, sites web et sources de données. Les assistants qui utilisent ses outils cesseront de fonctionner. Cette action est irréversible.",
  Participants: "Participants",
  "This Pod has been archived.": "Ce projet a été archivé.",
  "@dust is designed to give your users the best experience by default. A custom default agent may not handle every request as reliably. Do you want to set it as the default anyway?":
    "@dust est conçu pour offrir par défaut la meilleure expérience à vos utilisateurs. Un autre assistant par défaut risque de traiter certaines demandes de façon moins fiable. Voulez-vous quand même le choisir par défaut ?",
  "Default Agent: {name} (workspace default)":
    "Assistant par défaut : {name} (celui de l'espace de travail)",
  "Default Agent: {name}": "Assistant par défaut : {name}",
  "Workspace default": "Par défaut de l'espace de travail",
  "This Pod's default agent isn't available to you, so @dust is used instead. Contact the editor of the pod for more information.":
    "L'assistant par défaut de ce projet ne vous est pas accessible, @dust est donc utilisé à la place. Contactez l'éditeur du projet pour en savoir plus.",
  "Pod instructions for Agents": "Consignes du projet pour les assistants",
  "Seen by all agents in this Pod, stored as":
    "Lues par tous les assistants de ce projet, enregistrées sous",
  "in the Pod's files.": "dans les fichiers du projet.",
  "Enter instructions for agents":
    "Saisissez les consignes pour les assistants",
  "Default agent": "Assistant par défaut",
  "The agent pre-selected when anyone starts a new conversation in this Pod.":
    "L'assistant présélectionné quand quelqu'un démarre une nouvelle conversation dans ce projet.",
  "When unset, it inherits the Workspace default agent.":
    "S'il n'est pas défini, c'est l'assistant par défaut de l'espace de travail qui s'applique.",
  "Reset to workspace default": "Revenir au réglage de l'espace de travail",
  "Default Skills": "Compétences par défaut",
  "The skills pre-selected when anyone starts a new conversation in this Pod. Members can still edit the skills in each conversation.":
    "Les compétences présélectionnées quand quelqu'un démarre une nouvelle conversation dans ce projet. Les membres peuvent toujours les modifier dans chaque conversation.",
  "No default skills configured.": "Aucune compétence par défaut.",
  "Open Pods are disabled by your workspace admin.":
    "Les projets ouverts sont désactivés par l'administrateur de votre espace de travail.",
  "Switch to open?": "Ouvrir le projet à tous ?",
  "Switch to restricted?": "Restreindre le projet ?",
  "All workspace members will be able to join and see everything in the Pod — including existing conversations and files.":
    "Tous les membres de l'espace de travail pourront rejoindre le projet et tout y voir, y compris les conversations et fichiers existants.",
  "Access will be limited to invited members only.":
    "L'accès sera réservé aux membres invités.",
  "Successfully updated Pod visibility": "Visibilité du projet mise à jour",
  "Pod is now open.": "Le projet est désormais ouvert.",
  "Pod is now restricted.": "Le projet est désormais restreint.",
  "Open to everyone": "Ouvert à tous",
  "Anyone in the workspace can find and join the Pod.":
    "Tout membre de l'espace de travail peut trouver et rejoindre le projet.",
  "Search (email)": "Rechercher (e-mail)",
  "No members yet. Add people to give them access to this Pod.":
    "Aucun membre pour l'instant. Ajoutez des personnes pour leur donner accès à ce projet.",
  "No groups yet. Add a group to give all of its members access at once.":
    "Aucun groupe pour l'instant. Ajoutez un groupe pour donner accès à tous ses membres d'un coup.",
  "Add a default skill": "Ajouter une compétence par défaut",
  "Add a skill": "Ajouter une compétence",
  "No skills found": "Aucune compétence trouvée",
  "No more skills to add": "Plus aucune compétence à ajouter",
  "Pod Customization": "Personnalisation du projet",
  Tabs: "Onglets",
  "Files pinned to this Pod's Tabs. Drag to reorder, or pick a custom icon.":
    "Les fichiers épinglés dans les onglets de ce projet. Faites-les glisser pour les réordonner, ou choisissez une icône.",
  "No files in the Tabs yet.": "Aucun fichier dans les onglets pour l'instant.",
  "Add file": "Ajouter un fichier",
  "File {path} missing or renamed": "Fichier {path} absent ou renommé",
  "Remove from Tabs": "Retirer des onglets",
  "No assignee": "Sans responsable",
  "Assign to {name} (you)": "Confier à {name} (vous)",
  "Assign to {name}": "Confier à {name}",
  "Choose assignee": "Choisir un responsable",
  "Add a task...": "Ajouter une tâche…",
  "Edit task text": "Modifier le texte de la tâche",
  "Open task conversation": "Ouvrir la conversation de la tâche",
  "Reopen this task before starting work.":
    "Rouvrez cette tâche avant de vous y mettre.",
  "No Pod members available to assign.":
    "Aucun membre du projet à qui confier la tâche.",
  "Filter tasks...": "Filtrer les tâches…",
  "No tasks match your filter.": "Aucune tâche ne correspond à votre filtre.",
  "Error loading tasks.": "Erreur au chargement des tâches.",
  "You're all caught up!": "Vous êtes à jour.",
  "Done today": "Terminées aujourd'hui",
  "Done in the last 7 days": "Terminées ces 7 derniers jours",
  "Done in the last 30 days": "Terminées ces 30 derniers jours",
  Everyone: "Tout le monde",
  "Stay in this conversation": "Rester dans cette conversation",
  "After start: open task conversation or stay here":
    "Après le lancement : ouvrir la conversation de la tâche ou rester ici",
  "Redirect to conversation": "Aller à la conversation",
  "Stay on tasks": "Rester sur les tâches",
  "After start: open conversation or stay on tasks":
    "Après le lancement : ouvrir la conversation ou rester sur les tâches",
  "Start working on task": "Lancer le travail sur la tâche",
  "Can't start work on this task in this state yet.":
    "Impossible de lancer le travail sur cette tâche dans cet état.",
  "Additional instructions for the agent":
    "Consignes supplémentaires pour l'assistant",
  "(optional) Add a custom message for the agent...":
    "(facultatif) Ajoutez un message pour l'assistant…",
  "Selected agent: {name}": "Assistant choisi : {name}",
  "This Pod's default agent isn't available to you, so @dust is used instead. Discuss with your Pod editors if you think this is an error.":
    "L'assistant par défaut de ce projet ne vous est pas accessible, @dust est donc utilisé à la place. Parlez-en aux éditeurs du projet si vous pensez qu'il s'agit d'une erreur.",
  "Start working": "Lancer le travail",
  "(you)": "(vous)",
  "Dismiss all": "Tout refuser",
  "Suggested for this Pod.": "Suggérée pour ce projet.",
  "Task actions": "Actions de la tâche",
  Reassign: "Réattribuer",
  someone: "quelqu'un",
  "an agent": "un assistant",
  "a user": "un utilisateur",
  "An agent is working on this task.":
    "Un assistant travaille sur cette tâche.",
  "Created by": "Créée par",
  "Done by": "Terminée par",
  "Only invited members can access the Pod.":
    "Seuls les membres invités ont accès au projet.",
  "Failed to add references to Pod":
    "Impossible d'ajouter les références au projet",
  "Some items could not be added":
    "Certains éléments n'ont pas pu être ajoutés",
  "Failed to remove content nodes from Pod":
    "Impossible de retirer les contenus du projet",
  "Failed to create folder": "Impossible de créer le dossier",
  "Failed to move file": "Impossible de déplacer le fichier",
  "File moved": "Fichier déplacé",
  "Failed to set up starter tasks":
    "Impossible de préparer les premières tâches",
  "Failed to add task": "Impossible d'ajouter la tâche",
  "Failed to update task": "Impossible de modifier la tâche",
  "Failed to delete task": "Impossible de supprimer la tâche",
  "Failed to start task work": "Impossible de lancer le travail sur la tâche",
  "You can now participate in conversations.":
    "Vous pouvez maintenant participer aux conversations.",
  "Could not join Pod": "Impossible de rejoindre le projet",
  "You have successfully left the Pod.": "Vous avez bien quitté le projet.",
  "Could not leave Pod": "Impossible de quitter le projet",
  "Error updating Pod metadata": "Erreur pendant la mise à jour du projet",
  "Error updating Pod notification preference":
    "Erreur pendant la mise à jour des notifications du projet",
  "Pod notification preference updated": "Notifications du projet mises à jour",
  "Failed to update Pod network policy":
    "Impossible de mettre à jour la politique réseau du projet",
  "Pod network policy updated": "Politique réseau du projet mise à jour",
  "Failed to reject domain request":
    "Impossible de refuser la demande de domaine",
  "Failed to request domain": "Impossible de demander le domaine",
  "Added to Pod files": "Ajouté aux fichiers du projet",
  "Added {count} items to Pod files":
    "{count} éléments ajoutés aux fichiers du projet",
  "{count} added": "{count} ajouté",
  "{count} added (plural)": "{count} ajoutés",
  "{count} failed.": "{count} en échec.",
  "{count} failed. (plural)": "{count} en échec.",
  "Removed from Pod files": "Retiré des fichiers du projet",
  "Removed {count} items from Pod files":
    "{count} éléments retirés des fichiers du projet",
  'Folder "{name}" created': "Dossier « {name} » créé",
  'Failed to extract "{name}"': "Impossible d'extraire « {name} »",
  'Extracted {count} file from "{name}"':
    "{count} fichier extrait de « {name} »",
  'Extracted {count} files from "{name}"':
    "{count} fichiers extraits de « {name} »",
  "{userName} joined Pod {podName}": "{userName} a rejoint le projet {podName}",
  "{userName} left Pod {podName}": "{userName} a quitté le projet {podName}",
  "Error starring Pod": "Erreur pendant l'ajout du projet aux favoris",
  "Error unstarring Pod": "Erreur pendant le retrait du projet des favoris",
  "Pod tabs cleared": "Onglets du projet vidés",
  "Pod tabs updated": "Onglets du projet mis à jour",
  "Frame pinned as Pod banner": "Tableau de bord épinglé en bannière du projet",
  "Banner unpinned": "Bannière retirée",
  "Pod archived": "Projet archivé",
  "Pod unarchived": "Projet désarchivé",
  "Pod updated": "Projet mis à jour",
  "Sandbox egress policy changes will be applied by the proxy cache shortly.":
    "Les changements de politique réseau seront appliqués sous peu.",
  "Domain already allowed": "Domaine déjà autorisé",
  "Domain already requested": "Domaine déjà demandé",
  "Domain requested": "Domaine demandé",
  "A workspace admin will review your request.":
    "Un administrateur de l'espace de travail examinera votre demande.",
  "{domain} is already allowed for this Pod.":
    "{domain} est déjà autorisé pour ce projet.",
  "{domain} is already pending review for this Pod.":
    "{domain} est déjà en attente de validation pour ce projet.",
  "Pod tab limit reached": "Limite d'onglets du projet atteinte",
  "Add as Pod tab?": "Ajouter comme onglet du projet ?",
  '"{label}" will appear as a tab in this Pod for all members.':
    "« {label} » apparaîtra comme onglet de ce projet pour tous les membres.",
  "Remove Pod tab?": "Retirer l'onglet du projet ?",
  '"{label}" will no longer appear as a tab in this Pod.':
    "« {label} » n'apparaîtra plus comme onglet de ce projet.",
  "Pin as Pod banner?": "Épingler en bannière du projet ?",
  '"{label}" will appear at the top of this Pod for all members.':
    "« {label} » apparaîtra en haut de ce projet pour tous les membres.",
  Pin: "Épingler",
  "Unpin Pod banner?": "Retirer la bannière du projet ?",
  '"{label}" will no longer appear at the top of this Pod.':
    "« {label} » n'apparaîtra plus en haut de ce projet.",
  "The pinned banner will no longer appear at the top of this Pod.":
    "La bannière épinglée n'apparaîtra plus en haut de ce projet.",
  "Archive Pod?": "Archiver le projet ?",
  "You'll no longer be able to create new conversations in this Pod and it will be hidden from the sidebar. Triggers targeting this Pod will be disabled. However, existing content can still be used by agents. Unarchive to restore access.":
    "Vous ne pourrez plus créer de conversation dans ce projet et il sera masqué de la barre latérale. Les tâches planifiées qui le ciblent seront désactivées. Les assistants pourront toutefois toujours utiliser son contenu. Désarchivez-le pour en rétablir l'accès.",
  "Manage Members of {name}": "Gérer les membres de {name}",
  "{count} reply": "{count} réponse",
  "{count} replies": "{count} réponses",
  "{count} unread reply": "{count} réponse non lue",
  "{count} unread replies": "{count} réponses non lues",
  "{count} mention": "{count} mention",
  "{count} mentions": "{count} mentions",
  "in {count} unread reply": "dans {count} réponse non lue",
  "in {count} unread replies": "dans {count} réponses non lues",
  "Last message from {name}.": "Dernier message de {name}.",
  // Écrans des déclencheurs webhook (audit du 23/10).
  "Edited by {name}": "Modifié par {name}",
  "Edited on {date}": "Modifié le {date}",
  "Name & Icon": "Nom et icône",
  "is using this webhook source.": "utilise cette source webhook.",
  "are using this webhook source.": "utilisent cette source webhook.",
  "The associated trigger(s) will be automatically removed from it.":
    "Les déclencheurs associés lui seront retirés automatiquement.",
  "The associated trigger(s) will be automatically removed from them.":
    "Les déclencheurs associés leur seront retirés automatiquement.",
  "New {name} Trigger": "Nouveau déclencheur {name}",
  "New Custom Trigger": "Nouveau webhook personnalisé",
  custom: "personnalisé",
  "Trigger this agent with {name}.": "Déclencher cet assistant avec {name}.",
  "This trigger uses a custom webhook without an integrated provider: write the filter expression yourself to set conditions on the webhook's payload.":
    "Ce déclencheur utilise un webhook personnalisé : écrivez vous-même l'expression de filtre pour poser des conditions sur la charge utile reçue.",
  "Maximum number of runs over a 24-hour window. This will count towards your":
    "Nombre maximal d'exécutions sur 24 heures. Elles comptent dans",
  "personal credit pool.": "votre réserve de crédits personnelle.",
  "workspace's credit pool.": "la réserve de crédits de l'espace de travail.",
  "personal fair use limits.": "vos limites d'usage personnelles.",
  "workspace's programmatic usage.":
    "l'usage programmatique de l'espace de travail.",
};

export function t(cle: string): string {
  const v = FR[cle];
  return v === undefined ? cle : v;
}

// Libellé à paramètres : « Updated {ago} ago » → « Mis à jour il y a {ago} » ; un paramètre absent reste tel quel.
export function tp(
  cle: string,
  params: Record<string, string | number>
): string {
  return t(cle).replace(/\{(\w+)\}/g, (tout, nom: string) =>
    nom in params ? String(params[nom]) : tout
  );
}
